// //=============== RAKESH KA ===============================//
// import React, { useEffect, useState } from 'react'
// import Select from "react-select";
// import api from '../../utils/api';
// import { Button } from '../../common/Button/Button';
// import ESPUmcReactTable from './ESPUmcReactTable';
// import ModalContent from '../../common/Modal/ModalContent';
// import close_modal from '../../assets/ic_close_wh.svg'
// import Modal from "react-modal";
// import Spinner from '../../common/Spinner/Spinner';
// import { toast } from 'react-toastify';
// import CancellationReasonModal from '../../components/ServiceRequests/Handholder/CancellationReasonModal';
// import MultiSelectAll from '../../common/Multiselect/MultiSelectAll';
// import { ControlledInput } from '../../common/Input/Input';
// import Checkbox from '../../common/Checkbox/Checkbox';

// import ViewWhatsappMessagesModal from '../../components/ServiceRequests/Handholder/ViewWhatsappMessagesModal';

// import ic_filter from "../../assets/ic_filter.svg";

// import ESPUmcLedFilterModel from '../../components/EServicePartnerServiceRequests/ESPUmcLedFilterModel';

// const ESPUmcInterface = () => {

//     const [revenueModal, setRevenueModal] = useState(false)
//     const [revenueAmount, setRevenueAmount] = useState('')

//     const [resourceId, setResourceId] = useState(0)
//     const [serviceDisplay, setServiceDisplay] = useState("")

//     const [tableData, setTableData] = useState([])
//     const [isClearAction, setIsClearAction] = useState(false);

//     const [oppTypeNameList, setOppTypeNameList] = useState()
//     const [selectedOppType, setSelectedOppType] = useState(null)

//     const [oppTitleNameList, setOppTitleNameList] = useState([])
//     const [selectedOppTitle, setSelectedOppTitle] = useState([])

//     const [businessSectorList, setBusinessSectorList] = useState([])
//     const [selectedBusinessSector, setSelectedBusinessSector] = useState([])

//     const [displayRecordCount, setDisplayRecordCount] = useState({displayCount: true, count: 0})

//     const [searchFields, setSearchFields] = useState({
//         sContactNumber: ""
//     })

//     const [confirmationChecked, setConfirmationChecked] = useState(false)

//     useEffect(() => {
//         if (isClearAction) {
//             // Call umcCustomersData only after state updates have been completed
//             getTableData(tableInstance, true);
            
//             // Reset the clear action flag
//             setIsClearAction(false);
//         }
//     }, [
//         isClearAction // This ensures the function is called after clearing
//     ]);

//     const handleChange = (name, value) => {
//         const updated = { ...searchFields, [name]: value };
//         setSearchFields(updated)
//     }

//     const onBusinessSectorChange = (options) => {
//         // setSelectedBusinessSector(option)
//         // getTagsDropdown(option)

//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedBusinessSector([{ value: "*", label: "All" }]);
//             getTagsDropdown(processFilters(options))
//         } else {
//             setSelectedBusinessSector(options.filter((opt) => opt.value !== "*"));
//             getTagsDropdown(processFilters(options))
//         }
//     }

//     const toggleAllSector = () => {
//         if (selectedBusinessSector.length != businessSectorList.length && selectedBusinessSector.length != (businessSectorList.length + 1)) {
//           let temp = []
    
//           if (selectedBusinessSector.includes({ label: "All", value: "*" })) {
//             temp = selectedBusinessSector
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = businessSectorList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setBusinessSectorList(tempSR)
//           setSelectedBusinessSector(temp)
//           getTagsDropdown(processFilters(temp))
//         } else {
//           setSelectedBusinessSector([])
//           getTagsDropdown(null)
//         }
    
//       }

//     const [businessCityList, setBusinessCityList] = useState([])
//     const [selectedBusinessCity, setSelectedBusinessCity] = useState([])

//     const onBusinessCityChange = (options) => {
//         // setSelectedBusinessCity(option)
        
//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedBusinessCity([{ value: "*", label: "All" }]);
//         } else {
//             setSelectedBusinessCity(options.filter((opt) => opt.value !== "*"));
//         }
//     }

//     const toggleAllBusinessCity = () => {
//         if (selectedBusinessCity.length != businessCityList.length && selectedBusinessCity.length != (businessCityList.length + 1)) {
//           let temp = []
    
//           if (selectedBusinessCity.includes({ label: "All", value: "*" })) {
//             temp = selectedBusinessCity
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = businessCityList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setBusinessCityList(tempSR)
//           setSelectedBusinessCity(temp)
//         } else {
//           setSelectedBusinessCity([])
//         }
    
//       }

//     const [tagsDropDownList, setTagsDropdownList] = useState([])
//     const [selectedTagOption, setSelectedTagOption] = useState([])

//     const getTagsDropdown = (e) => {
//         if (e !== null) {
//             api.tagsListApi(e)
//                 .then(({ data }) => {
//                     if (data.data.length > 0) {
//                         // Flatten all sTag arrays into a single array
//                         const allTags = data.data.flatMap(sector => sector.sTag);
    
//                         // Remove duplicates
//                         const uniqueTags = [...new Set(allTags)];
    
//                         // Format the tags for the dropdown
//                         const formattedData = uniqueTags.map(tag => ({
//                             value: tag,
//                             label: tag
//                         }));
    
//                         setTagsDropdownList(formattedData);
//                         console.log("Drop list", formattedData);
//                     } else {
//                         setTagsDropdownList([]);
//                     }
//                 })
//                 .catch(error => {
//                     console.error("API error:", error);
//                     setTagsDropdownList([]);
//                 });
//         } else {
//             setTagsDropdownList([]);
//             setSelectedTagOption([]);
//         }
//     };

//     const onTagChange = (options) => {
//         // setSelectedTagOption(option)

//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedTagOption([{ value: "*", label: "All" }]);
//         } else {
//             setSelectedTagOption(options.filter((opt) => opt.value !== "*"));
//         }
//     }

//     const toggleAllTags = () => {
//         if (selectedTagOption.length != tagsDropDownList.length && selectedTagOption.length != (tagsDropDownList.length + 1)) {
//           let temp = []
    
//           if (selectedTagOption.includes({ label: "All", value: "*" })) {
//             temp = selectedTagOption
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = tagsDropDownList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setTagsDropdownList(tempSR)
//           setSelectedTagOption(temp)
//         } else {
//           setSelectedTagOption([])
//         }
    
//       }

//     const [pages, setPages] = useState(0);
//     const [pageSize, setPageSize] = useState(10);
//     const [currentPage, setcurrentPage] = useState(0);
//     const [tableInstance, setTableInstance] = useState(null);
//     const [count, setCount] = useState(0);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isFilterTrue, setIsFilterTrue] = useState(false)
//     const [pageSizeOptions, setpageSizeOptions] = useState([
//         {
//             value: "10",
//             label: "10 Rows",
//         },
//         {
//             value: "20",
//             label: "20 Rows",
//         },
//         {
//             value: "30",
//             label: "30 Rows",
//         },
//         {
//             value: "50",
//             label: "50 Rows",
//         },
//         {
//             value: "75",
//             label: "75 Rows",
//         },
//         {
//             value: "100",
//             label: "100 Rows",
//         },
//     ]);
//     const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
//         value: "10",
//         label: "10",
//     });
//     const [selectedServices, setSelectedServices] = useState([]);

//     /**CancellationReason */

// 	const [showCancellationReasonModal, setShowCancellationReasonModal,] = useState(false);
//     const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState();
// 	const [selectedCancellationReason, setSelectedCancellationReason,] = useState();
// 	const [enableOtherDescriptionTextbox, setEnableOtherDescriptionTextbox,] = useState(false);
// 	const [cancellationReasonOtherDescription, setCancellationReasonOtherDescription,] = useState();
// 	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");

// 	const toggleCancellationReasonModal = () => {
//         setSelectedCancellationReason()
//         setCancellationReasonOtherDescription()
// 		setShowCancellationReasonModal(!showCancellationReasonModal);
// 	};

//     // const enableCancelButton = () => {
//     //     if(selectedCancellationReason){
//     //         setEnableCancelButtonFlag("")
//     //     }
//     // }

//     const enableCancelButton = () => {
// 		if (selectedCancellationReason) {
// 			if (selectedCancellationReason.value === "Other") {
// 				if (
// 					cancellationReasonOtherDescription &&
// 					cancellationReasonOtherDescription.length > 0
// 				) {
// 					setEnableCancelButtonFlag("");
// 				} else setEnableCancelButtonFlag("disable");
// 			} else setEnableCancelButtonFlag("");
// 		} else setEnableCancelButtonFlag("disable");
// 	};

//     useEffect(() => {
//         enableCancelButton()
//     }, [selectedCancellationReason, cancellationReasonOtherDescription])

//     const handleCheckboxChange = (serviceInstanceId) => {
//         console.log(serviceInstanceId, ">>>>ServiceInstanceId");
        
//         const currentIndex = selectedServices.indexOf(serviceInstanceId);
//         const newSelectedServices = [...selectedServices];

//         if (currentIndex === -1) {
//             newSelectedServices.push(serviceInstanceId);
//         } else {
//             newSelectedServices.splice(currentIndex, 1);
//         }

//         setSelectedServices(newSelectedServices);
//         console.log("Selected Service", newSelectedServices)
//     };

//     const isSelected = (serviceInstanceId) => selectedServices.includes(serviceInstanceId);

//     const handleSelectAll = () => {
//         const selectableServices = tableData.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled');
//         const selectableServiceIds = selectableServices.map(service => service.nResourceInstanceId);
    
//         if (selectedServices.length === selectableServiceIds.length) {
//             // Deselect all services
//             setSelectedServices([]);
//         } else {
//             // Select all services
//             setSelectedServices(selectableServiceIds);
//         }
//         console.log("Serv", selectableServiceIds)
//     };

//     const onDeliverServicesBtnClick = async() => {
//             let payload = {
//                 nResourceInstanceId: selectedServices,
//                 refCurrentState: 'Delivered'
//             }
//             setIsLoading(true)
//             const {deliverBulkServices} = api.deliverBulkServiceData(payload)
//             .then(({data}) => {
//                 if(data){
//                     console.log("Data", data.Message)
//                     setIsLoading(false)
//                     toast(String(data.Message), {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     });
//                     getTableData(tableInstance, false)
//                     setSelectedServices([])
//                 }
//             }) .catch((error) => {
//                 setIsLoading(false);
//                 if (error.response.data.error) {
//                     toast(String("Services cannot be delivered as some services are still in LPM."), {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//                 else if (error.response.data.message) {
//                     toast(String(error.response.data.message), {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//                 else {
//                     toast("Internal server error", {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//             })
//     }

//     const getTableData = async (instance, flag = false) => {
//         if (!instance) return;
//         if (!tableInstance) setTableInstance(instance);

//         try {
//             const { page } = instance.state ?? { page: 0 };
//             let icurrentPage = page;
//             if (!flag && isNaN(icurrentPage)) return;
//             const pageSize = selectedPageSizeOption.value;

//             if (flag || isNaN(icurrentPage)) {
//                 icurrentPage = 0;
//             }

//             let servicestatusListtemp2 = [];
//         selectedServiceStatusListForFilter.map((e) => {
//             if (e.value != "*") {
//                 servicestatusListtemp2.push(e.value);
//             }
//         });
//         const serviceStatusList = servicestatusListtemp2;

//         let serviceStatusFilter = [];
//         serviceStatusList.map((e) => {
//             if (e === "Willing to Pay") {
//                 serviceStatusFilter.push("Ready For Progression:Partner");
//                 serviceStatusFilter.push("Partial/ Full Payment Pending");
//             }
//             else if (e === "Payment Received") {
//                 serviceStatusFilter.push("Payment Confirmed By Partner");
//                 serviceStatusFilter.push("Ready For Progression:deAsra");
//             }
//             else {
//                 serviceStatusFilter.push(e);
//             }
//         });
//         const statusList = serviceStatusFilter;

//             let ResourceNamesTemp = []
//             selectedOppTitle.map((e) => {
//                 if(e.value != "*"){
//                     ResourceNamesTemp.push(e.value)
//                 }
//             })


//             let filterParameters = {
//                 page_no: icurrentPage + 1,
//                 page_size: pageSize,
//                 // pagination: true,
//                 // SP_email: 'archana.sapre@mailinator.com'
//             };

//             if(selectedOppType){
//                 filterParameters.service_codes = [selectedOppType.value]
//             }
    
//             if(selectedOppTitle){
//                 filterParameters.ResourceName = ResourceNamesTemp
//             }

//             // if (selectedOppTitle.length > 0) {
//             //     filterParameters.sServiceDisplayName = processFilters(selectedOppTitle) 
//             // }

//             if(confirmationChecked){
//                 filterParameters.bConfirmation_tag = confirmationChecked
//             }
            
//             if (statusList.length) {
//                 filterParameters.statusList = statusList;
//             }

//             if(selectedBusinessSector.length > 0){
//                 filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
//             }

//             if(selectedBusinessCity.length > 0){
//                 filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
//             }

//             if(selectedTagOption.length > 0){
//                 filterParameters.sTag = processFilters(selectedTagOption)
//             }

//             if (searchFields.sContactNumber !== "") {
//                 filterParameters.search_value = searchFields.sContactNumber
//             }

//             if (currentPage != icurrentPage) {
//                 setSelectedServices([]);
//             }

//             setIsLoading(true);
//             const { tempServices } = api.getExternalPartnerUmcServices(filterParameters).then(({ data }) => {
//                 setIsLoading(false);
//                 if (data) {
//                     // const { results, count } = data;
//                     setcurrentPage(icurrentPage);
//                     setPages(data.total_pages);
//                     setPageSize(pageSize);
//                     setDisplayRecordCount({...displayRecordCount, count: data?.total_count})


//                     let tempLPMServiceList = data.ServiceRequests.map((x) => {
//                         x.custrefSRState = x.refSRState;
//                         x.custsSRCancellationReason = x.sSRCancellationReason;
//                         x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
//                         x.custsNotesHH = null;
//                         x.custdtFollowupOn = null;
//                         x.custsFollowupNotes = null;
//                         x.serviceFrom = "LPM";
//                         x.custOtherServiceInfo = x.sOtherServicesInfo;
//                         x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
//                         x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
//                         x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
//                         x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
//                         x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
//                         x.custsCallStatus = x.sCallStatus;
//                         x.custsUpdateNoteForAllServicesInPackage = false;
//                         x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
//                         x.custbOfflineMeet = x.bOfflineMeet;
//                         return x;
//                     });
    
//                     let tempSPMerviceList = data.Services.map((x) => {
//                         x.custrefSRState = x.refCurrentState.sServiceState;
//                         x.custsSRCancellationReason = x.sServiceCancellationReason;
//                         x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
//                         x.custsNotesHH = null;
//                         x.custdtFollowupOn = null;
//                         x.custsFollowupNotes = null;
//                         x.serviceFrom = "SPM";
//                         x.OtherServiceInfo = null;
//                         x.custOtherServiceInfo = x.sOtherServicesInfo;
//                         x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
//                         x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
//                         x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
//                         x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
//                         x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
//                         x.custsCallStatus = x.sCallStatus;
//                         x.custsUpdateNoteForAllServicesInPackage = false;
//                         x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
//                         x.custbOfflineMeet = x.bOfflineMeet;
//                         return x;
//                     });

//                     var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
//                     let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
//                         return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
//                     })

//                     console.log("New Data", sortedServiceRequestsDesc)
//                     setTableData(sortedServiceRequestsDesc)
//                 }
//                 else {
//                     // toast("Something went wrong. Please contact Deasra Representative.", {
//                     //     autoClose: 5000,
//                     //     type: toast.TYPE.ERROR,
//                     // });
//                 }
//             })
//         } catch (error) {
//             setIsLoading(false);
//             console.log(error)
//             // toast("Internal Server Error", {
//             //     autoClose: 5000,
//             //     type: toast.TYPE.ERROR,
//             // });
//         }

//     }

//     const onSearchClick = () => {
//         getTableData(tableInstance, true)
//     }

//     const onClearClick = () => {
//         setSelectedOppType(null)
//         setSelectedOppTitle([])
//         setSelectedBusinessSector([])
//         setSelectedBusinessCity([])
//         setSelectedTagOption([])
//         setSearchFields({
//             sContactNumber: ""
//         })
//         setConfirmationChecked(false)
//         setIsClearAction(true);
//     }

//     const onEnterRevenueClick = (ele) => {
//         openRevenueModalisTrue()
//         setResourceId(ele.nResourceInstanceId)
//         setServiceDisplay(ele.sServiceDisplayName)
//     }

//     const onGenerateRevenueClick = () => {
//         if(revenueAmount === "0") {
//             toast("Revenue cannot be zero", {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//         } else {
//             setIsLoading(true)
//             openRevenueModalisFalse()
//             let payload = {
//                 nResourceInstanceId: resourceId,
//                 sServiceDisplayName: serviceDisplay,
//                 nRevenue: revenueAmount
//             }
    
//             const {tempAddRevenueUmc} = api.addRevenueUmc(payload)
//             .then(({data}) => {
//                 setIsLoading(false)
//                 toast("Revenue Updated Successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 console.log(data)
//                 setRevenueAmount('')
//                 getTableData(tableInstance, false)
//             })
//         }
        
//     }

//     useEffect(() => {
//         getTableData(tableInstance, true)
//     }, [selectedPageSizeOption])

//     useEffect(() => {
//         const { temp } = api.getCancellationReasons().then(({ data }) => {
// 			console.log("cancellationRason", data);
// 			let temp1 = data.map((e) => {
// 				return { value: e.sReason, label: e.sReason };
// 			});
// 			setCancellationReasonDropdownOptions(temp1);
// 		});
//     }, [])

//     const fetchServiceRequests = (instance, flag) => {
//         getTableData(instance, flag);
//     };
    

//     const onOppTypeChange = (option) => {
//         // setSelectedOppTitle(null)
//         if(showWhatsappMessagesModal){
//             setSelectedOppTypeWpModal(option)
//         } else{
//             setSelectedOppType(option)
//         }
//         getOppTitleNames(option)
//     }

//     // const onOppTitleChange = (option) => {
//     //     setSelectedOppTitle(option)
//     // }

//     const openRevenueModalisTrue = () => {
//         setRevenueModal(true)
//     }

//     const openRevenueModalisFalse = () => {
//         setRevenueModal(false)
//     }

//     useEffect(() => {
//         const { tempOppTypeServiceNames } = api.oppTypeListApi()
//         .then(({data}) => {
//             const formattedData = data.results.map((ele) => ({
//                 value: ele.sServiceCode,
//                 label: ele.sServiceName
//             }))
//             setOppTypeNameList(formattedData);
//             setOppTypeNameListWpModal(formattedData);
//         })

//         const { tempBusinessSectorListApi } = api.businessSectorListApi()
//             .then(({ data }) => {
//                 console.log("Business Sector", data)
//                 const formattedData = data.data
//                 .filter(ele => ele.sBusinessSector !== null)
//                 .map((ele) => ({
//                     value: ele.sBusinessSector,
//                     label: ele.sBusinessSector
//                 }))
//                 setBusinessSectorList(formattedData)
//             })

//             const { tempBusinessCityListApi } = api.businessCityListApi()
//             .then(({data}) => {
//                 const formatttedData = data.data
//                 .map((ele) => ({
//                     value: ele.sBusinessCity,
//                     label: ele.sBusinessCity
//                 }))
//                 setBusinessCityList(formatttedData)
//             })
//     }, [])

//     const getOppTitleNames = (ele) => {
//         // let filterParameters = {}

//         // if(selectedOppType !== null) {
//         //     filterParameters.OpportunityType = selectedOppType.value
//         // }
//         if(showWhatsappMessagesModal){
//             if(ele) {
//                 const { tempOppTitleNames } = api.oppTitleListApi({
//                     OpportunityType: ele.value
//                 })
//                 .then(({data}) => {
//                     const formattedData = data.results.map((ele) => ({
//                         value: ele.ResourceName,
//                         label: ele.ResourceName
//                     }))
//                     setOppTitleNameListWpModal(formattedData)
//                 })
//             } else {
//                 setOppTitleNameListWpModal([]);
//                 setSelectedOppTitleWpModal([]);
//             }
//         } else {
//             if(ele) {
//                 const { tempOppTitleNames } = api.oppTitleListApi({
//                     OpportunityType: ele.value
//                 })
//                 .then(({data}) => {
//                     const formattedData = data.results.map((ele) => ({
//                         value: ele.ResourceName,
//                         label: ele.ResourceName
//                     }))
//                     setOppTitleNameList(formattedData)
//                 })
//             } else {
//                 setOppTitleNameList([])
//                 setSelectedOppTitle([])
//             }
//         }
//     }

//     const toggleAllOppTitle = () => {
//         console.log(">>>toggle all opp titlw got clicekd");

//         if(showWhatsappMessagesModal){
//             if (selectedOppTitleWpModal?.length != oppTitleNameListWpModal?.length && selectedOppTitleWpModal?.length != (oppTitleNameListWpModal?.length + 1)) {
//                 let temp = []
          
//                 if (selectedOppTitleWpModal?.includes({ label: "All", value: "*" })) {
//                   temp = selectedOppTitleWpModal
//                 } else {
//                   temp = [{ label: "All", value: '*' }]
//                 }
          
//                 let tempSR = oppTitleNameListWpModal.map((e) => {
//                   if (!temp.includes(e)) {
//                     temp = temp.concat(e)
//                   }
//                   return e
//                 })
//                 setOppTitleNameListWpModal(tempSR);
//                 setSelectedOppTitleWpModal(temp)
//               //   getTagsDropdown(processFilters(temp))
//             } else {
//             setSelectedOppTitleWpModal([])
//             //   getTagsDropdown(null)
//             }
//         } else{
//             if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
//                 let temp = []
          
//                 if (selectedOppTitle.includes({ label: "All", value: "*" })) {
//                   temp = selectedOppTitle
//                 } else {
//                   temp = [{ label: "All", value: '*' }]
//                 }
          
//                 let tempSR = oppTitleNameList.map((e) => {
//                   if (!temp.includes(e)) {
//                     temp = temp.concat(e)
//                   }
//                   return e
//                 })
//                 setOppTitleNameList(tempSR)
//                 setSelectedOppTitle(temp)
//               //   getTagsDropdown(processFilters(temp))
//             } else {
//             setSelectedOppTitle([])
//             //   getTagsDropdown(null)
//             }
//         }
//     }

//     const onOppTitleChange = (options) => {
//         if(showWhatsappMessagesModal){
//             const isAllSelected = options.some((opt) => opt.value === "*");

//             if (isAllSelected) {
//                 setSelectedOppTitleWpModal([{ value: "*", label: "All" }]);
//                 // getTagsDropdown(processFilters(options))
//             } else {
//                 setSelectedOppTitleWpModal(options.filter((opt) => opt.value !== "*"));
//                 // getTagsDropdown(processFilters(options))
//             }
//         } else {
//             const isAllSelected = options.some((opt) => opt.value === "*");
//             if (isAllSelected) {
//                 setSelectedOppTitle([{ value: "*", label: "All" }]);
//                 // getTagsDropdown(processFilters(options))
//             } else {
//                 setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
//                 // getTagsDropdown(processFilters(options))
//             }
//         }
//     }

//     const handleChangeState = () => {
//         let cancellation_Reason, OtherDescription;
//         if(selectedCancellationReason) {
//             cancellation_Reason = selectedCancellationReason.value;
// 				if (cancellation_Reason !== "Other") OtherDescription = null;
// 				else OtherDescription = cancellationReasonOtherDescription;
//         }
//         setIsLoading(true)
//         setShowCancellationReasonModal(false)
//         let payload = {
//             nResourceInstanceId: selectedServices,
//             refCurrentState: "Cancelled",
//             sServiceCancellationReason: cancellation_Reason,
//             sOtherReason: OtherDescription
//         }

//         const {tempCancelBulkServices} = api.cancelBulkServiceData(payload)
//         .then(({data}) => {
//             if(data){
//                 setIsLoading(false)
//                 toast(String("Services Cancelled Successfully"), {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 setSelectedCancellationReason()
//                 setCancellationReasonOtherDescription()
//                 getTableData(tableInstance, false)
//                 setSelectedServices([])
//             }
//         })
//     }

//     const calculateEnableOtherDescriptionTextbox = () => {
// 		if (selectedCancellationReason && selectedCancellationReason.value === "Other") {
// 			setEnableOtherDescriptionTextbox(true);
// 		}
// 		else {
// 			setEnableOtherDescriptionTextbox(false);
// 		}
// 	};

// 	useEffect(() => {
// 		calculateEnableOtherDescriptionTextbox();
// 	}, [selectedCancellationReason]);

//     const processFilters = (filter) => {
//         let filterNames = ""
//         if (filter.length > 1) {
//             filterNames = filter.map(city => city.value).join(", ");
//         } else if (filter.length === 1) {
//             filterNames = filter[0].value;
//         }

//         return filterNames
//     }

//     const handleCatalogueClick = (ele) => {
//         setIsLoading(true)
//         let payload = {
//             api_key: "82mqEyJnct4kzC8y",
//             user_id: ele._original.nUserId
//         }

//         const { tempCataloguelinkData } = api.catalogueLinkApi(payload)
//             .then(({ data }) => {
//                 console.log("Link", data)
//                 if (data.data !== null) {
//                     window.open(data.data.catalogue_url, "_blank");
//                     setIsLoading(false)
//                 }
//             })
//     }
    
//     // Handle send cancellation Message Function
//     const handleSendCancellationMessage = () => {
//         // console.log(">>>>>Cancellation Message Button Clicked");
//         setIsLoading(true)

//         let payload = {"nResourceInstanceId": selectedServices}
//         api.sendCancellationMessage(payload).then(({data}) => {
//             if(data){
//                 toast("Whatsapp message sent successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 })

//                 setSelectedServices([]);
//             }

//             setIsLoading(false)
//         })
//     }

//     //===== View Whatsapp Message Related Function and States ====//
//     const [showWhatsappMessagesModal, setShowWhatsappMessagesModal] = useState(false);
//     const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
//     const [wpMessageDisplayRecordCount, setWpMessageDisplayRecordCount] = useState({displayCount: true, count: 0})
//     const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
//     const [wpMessagepages, setWpMessagePages] = useState(0);
//     const [wpMessagePageSize, setWpMessagePageSize] = useState(10);
//     const [viewMessagePageSizeOptions, setViewMessagePageSizeOptions] = useState([
//         {
//             value: "10",
//             label: "10 Rows",
//         },
//         {
//             value: "20",
//             label: "20 Rows",
//         },
//         {
//             value: "30",
//             label: "30 Rows",
//         },
//         {
//             value: "50",
//             label: "50 Rows",
//         },
//         {
//             value: "75",
//             label: "75 Rows",
//         },
//         {
//             value: "100",
//             label: "100 Rows",
//         },
//     ]);
//     const [selectedViewMessagePageSizeOption, setSelectedViewMessagePageSizeOption] = useState({
//         value: "10",
//         label: "10",
//     });

//     const [oppTypeNameListWpModal, setOppTypeNameListWpModal] = useState(null);
//     const [selectedOppTypeWpModal, setSelectedOppTypeWpModal] = useState(null);

//     const [oppTitleNameListWpModal, setOppTitleNameListWpModal] = useState([])
//     const [selectedOppTitleWpModal, setSelectedOppTitleWpModal] = useState([]);

//     const [fromDate, setFromDate] = useState(null);
//     const [toDate, setToDate] = useState(null);

//     const [messageTypeOptions, setMessageTypeOptions] = useState(
//         [
//             {label: "New Opportunity", value:"Opportunity"},
//             {label: "Cancellation", value:"Cancellation"}
//         ]
//     )
//     const [selectedMessageType, setSelectedMessageType] = useState(null);

//     const [wpCancellationMessageIsLoading, setWpCancellationMessageIsLoading] = useState(false);
//     const [clearActionWpModalData, setClearActionWpModalData] = useState(false);

//     const toggleShowWhatsappMessagesModal = () => {
//         setShowWhatsappMessagesModal(!showWhatsappMessagesModal);

//         setSelectedOppTypeWpModal(null);
//         setSelectedOppTitleWpModal([]);
//         setFromDate(null);
//         setToDate(null);
//         // setSelectedOppTitle([]);
//         // setOppTitleNameList([]);
//     }

    

//     useEffect(()=>{
//         console.log(">>>useEffect to get cancellation message ran");
        
//         let payloads = {
//             page: wpMessagecurrentPage+1,
//             page_size: selectedViewMessagePageSizeOption?.value,
//             pagination: true,
//             sMessageType: "Opportunity"
//         }

//         console.log(payloads, ">>>>>>payloads");
        

//         if(showWhatsappMessagesModal){
//             getWhatsappCancellationMessages();
//         }
//         setClearActionWpModalData(false);
//     }, [showWhatsappMessagesModal, clearActionWpModalData ])

//     useEffect(()=>{
//         if(toDate < fromDate){
//             toast(String("From-Date cant be greater than To-Date"), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//         }else {
//             {
//                 let selectedOppTypeWp = [];
//                 let selectedOppTitleWp = [];
//                 let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
//                 let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
    
//                 selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
//                 selectedOppTitleWpModal?.map(titleObj => {
//                     selectedOppTitleWp.push(titleObj?.value);
//                 })
    
//                 let data = {
//                     page: wpMessagecurrentPage+1,
//                     page_size: selectedViewMessagePageSizeOption?.value,
//                     pagination: true,
//                     sMessageType: selectedMessageType?.value,
//                     sServiceCode:[...selectedOppTypeWp],
//                     sServiceDisplayName: [...selectedOppTitleWp],
//                     fromDate: formattedFromDate,
//                     toDate: adjustedToDate(formattedToDate)
//                 }
        
//                 console.log(data, ">> data on search click");
//                 getWhatsappCancellationMessages(data);
//             }
//         }
//     }, [ wpMessagecurrentPage, selectedViewMessagePageSizeOption])

//     let getWhatsappCancellationMessages = async(data) =>{
//         try{
//             setWpCancellationMessageIsLoading(true);
            
//             let response = await api.getWhatsappMessageSentForCancellation(data);
//             // console.log(response, ">>> whatsapp cancellation message responseeeee");
//             // console.log(response.data.count, ">>>>response count");
            
//             // console.log(response?.data?.results, ">>> whatsapp cancellation message response data");
//             setSentWhatsappCancellationMessages(response?.data?.results);
//             // setWpMessagePageSize(response.data.length);

//             let totalCounts = response?.data?.count;
//             // console.log(totalCounts, ">>>>totalCounts");
            
//             let totalPages = Math.ceil(totalCounts/selectedViewMessagePageSizeOption?.value);
//             // console.log(totalPages, ">>>>>totalPages");
            
//             setWpMessagePages(totalPages)

            
//             // toast(String("Successfully received the "), {
//             //     autoClose: 5000,
//             //     type: toast.TYPE.SUCCESS,
//             // });

//             setWpCancellationMessageIsLoading(false)
//         } catch(err){
//             console.log(err)
//             setWpCancellationMessageIsLoading(false)
//         }
//     }

//     const searchFilterWpSendCacellationMessages = () =>{
//         console.log(wpMessagecurrentPage, ">>>>wpMessagecurrentPage");
//         console.log(selectedViewMessagePageSizeOption, ">>>>selectedViewMessagePageSizeOption");
//         console.log("pagination: true");
//         console.log("sMessageType");
        
        
        
//         console.log(selectedOppTypeWpModal, ">>>selectedOppTypeWpModal");
//         console.log(selectedOppTitleWpModal, ">>>selectedOppTitleWpModal");
//         console.log(fromDate, ">>>fromDate");
//         console.log(toDate, ">>>toDate");
//         console.log(toDate > fromDate, ">>>is two date greater than from date")
//         console.log(selectedMessageType, ">>>> Selected Message Type");

//         if(wpMessagecurrentPage){
//             setwpMessagecurrentPage(0);
//         }else {
//             if(toDate < fromDate){
//                 toast(String("From-Date cant be greater than To-Date"), {
//                     autoClose: 5000,
//                     type: toast.TYPE.ERROR,
//                 });
//             }else {
//                 {
//                     let selectedOppTypeWp = [];
//                     let selectedOppTitleWp = [];
//                     let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
//                     let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
        
//                     selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
//                     selectedOppTitleWpModal?.map(titleObj => {
//                         selectedOppTitleWp.push(titleObj?.value);
//                     })
        
//                     let data = {
//                         page: wpMessagecurrentPage+1,
//                         page_size: selectedViewMessagePageSizeOption?.value,
//                         pagination: true,
//                         sMessageType: selectedMessageType?.value,
//                         sServiceCode:[...selectedOppTypeWp],
//                         sServiceDisplayName: [...selectedOppTitleWp],
//                         fromDate: formattedFromDate,
//                         toDate: adjustedToDate(formattedToDate)
//                     }
            
//                     console.log(data, ">> data on search click");
//                     getWhatsappCancellationMessages(data);
//                 }
//             }
//         }
//     }

//     const clearSearchFilterWpCancellationMessages = () => {
//         setClearActionWpModalData(true);
//         setSelectedOppTypeWpModal(null);
//         setSelectedOppTitleWpModal([]);
//         setOppTitleNameListWpModal([]);
        
//         setFromDate(null);
//         setToDate(null);
//         setSelectedMessageType(null);
//         setwpMessagecurrentPage(0)
//     }

//     const adjustedToDate = (date) => {
// 		let toDateAdjusted;
// 		if (date) {
// 			toDateAdjusted = new Date(date);

// 			toDateAdjusted = new Date(
// 				toDateAdjusted.setTime(
// 					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
// 				)
// 			);
// 		}
// 		return toDateAdjusted;
// 	};

//     const handleFromDate = (date) =>{
//         if(toDate && toDate<date){
//             setToDate(null)
//         }
//         setFromDate(date)
//     }

//     const handleToDate = (date) => {
//         if(fromDate && fromDate > date){
//             setFromDate(null)
//         }
//         setToDate(date)
//     }

//     const handleViewMessageOnFetchData = (state) =>{
//         console.log(state, ">>>>state on handleViewMessageOnFetchData");
//         setwpMessagecurrentPage(state?.page ? state?.page : 0);
//     }

//     const onMessageTypeChange = (option) =>{
//         // console.log(option, ">>>>option of message type");
//         setSelectedMessageType(option)
//     }

//     // States and functions for filter by status
//     /*Filter modal callbacks */
//     const [showFilterModal, setShowFilterModal] = useState(false);
//     const toggleFilterModal = () => {
//         setShowFilterModal(!showFilterModal);
//     };
//     const handleViewFilterModal = (original) => {
//         toggleFilterModal();
//     };
//     /*End */

//     // service status strates in filter modal
//     const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);
//     const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
//     const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
//     const [serviceStatusList, setServiceStatusList] = useState(statusArray);

//     let MainStatus = [
//         {
//             checked: false,
//             label: "Requested",
//             id: "Requested",
//             code: "Requested",
//         },
//         {
//             checked: false,
//             label: "Eligible",
//             id: "Eligible",
//             code: "Eligible",
//         },
//         {
//             checked: false,
//             label: "Quotation Sent",
//             id: "Quotation Sent",
//             code: "Quotation Sent",
//         },
//         {
//             checked: false,
//             label: "Willing to Pay",
//             id: "Willing to Pay",
//             code: "Willing to Pay",
//         },
//         {
//             checked: false,
//             label: "Payment Received",
//             id: "Payment Received",
//             code: "Payment Received",
//         },
//         {
//             checked: false,
//             label: "Awaiting for information/Documents",
//             id: "Awaiting for information/Documents",
//             code: "Awaiting for information/Documents",
//         },
//         {
//             checked: false,
//             label: "Service Delivery Started",
//             id: "Service Delivery Started",
//             code: "Service Delivery Started",
//         },
//         {
//             checked: false,
//             label: "Service deliverables ready",
//             id: "Service deliverables ready",
//             code: "Service deliverables ready",
//         },
//         {
//             checked: false,
//             label: "Full Payment Requested",
//             id: "Full Payment Requested",
//             code: "Full Payment Requested",
//         },
//         {
//             checked: false,
//             label: "Full Payment Received",
//             id: "Full Payment Received",
//             code: "Full Payment Received",
//         },
//         {
//             checked: false,
//             label: "Delivered",
//             id: "Delivered",
//             code: "Delivered",
//         },
//         {
//             checked: false,
//             label: "Cancelled",
//             id: "Cancelled",
//             code: "Cancelled",
//         },
//         {
//             checked: false,
//             label: "Refunded",
//             id: "Refunded",
//             code: "Refunded",
//         },
//     ]
    
//     var statusArray = MainStatus;

//     useEffect(()=>{
//         const serviceStatusNameForFilter = [];
//         MainStatus.map((x) => {
//             serviceStatusNameForFilter.push({
//                 label: x.label,
//                 value: x.code,
//                 id: x.id,
//             });
//         });

//         setServiceStatusNameListForFilter(serviceStatusNameForFilter);
//     }, [])

//     const toggleAllForServiceStatusFilter = () => {
//         let temp = [];

//         if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
//             if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
//                 temp = selectedServiceStatusListForFilter;
//             }
//             else {
//                 temp = [{ label: "All", value: "*" }];
//             }

//             let tempSR = serviceStatusNameListForFilter.map((e) => {
//                 if (!temp.includes(e)) {
//                     temp = temp.concat(e);
//                 }
//                 return e;
//             });
//             setSelectedServiceStatusListForFilter(temp);
//             setServiceStatusNameListForFilter(tempSR);
//             //getExternalPartnerServices(tableInstance);
//         }
//         else {
//             setSelectedServiceStatusListForFilter([]);
//             //getExternalPartnerServices(tableInstance);
//         }
//     };

//     const toggleSelectionForServiceStatusFilter = (e) => {
//         setSelectedServiceStatusListForFilter(e);
//     };
    
//     const toggleAllForFilter = () => {
//         let temp = [];

//         // if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
//         //     if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
//         //         temp = selectedServiceNameListForFilter;
//         //     }
//         //     else {
//         //         temp = [{ label: "All", value: "*" }];
//         //     }

//         //     let tempSR = serviceNameListForFilter.map((e) => {
//         //         if (!temp.includes(e)) {
//         //             temp = temp.concat(e);
//         //         }
//         //         return e;
//         //     });
//         //     setSelectedServiceNameListForFilter(temp);
//         //     setServiceNameListForFilter(tempSR);
//         //     //getExternalPartnerServices(tableInstance);
//         // }
//         // else {
//         //     setSelectedServiceNameListForFilter([]);
//         //     //getExternalPartnerServices(tableInstance);
//         // }
//     };

//     const toggleSelectionForFilter = (e) => {
//         // setSelectedServiceNameListForFilter(e);
//     };

//     const handleSearchClick = async () => {
//         if (showFilterModal) {
//             toggleFilterModal();
//         }
//         // setSelectedServiceForEdit();
//         // setSelectedSecondServiceForEdit();
//         // setExpandedChange({});
//         // if(confirmationChecked){
//         //      getFilterDataExternalService(tableInstance, true)
//         // } else {
//             // getExternalPartnerServices(tableInstance, true);
//             getTableData(tableInstance, true)
//         // }
        
//         //refreshTable();
//     };

//     const handleClearFilterSearch = () => {
//         let tempStatus = serviceStatusList?.map((x) => {
//             x.checked = false;
//             return x;
//         });
//         // setSelectedServiceNameListForFilter([]);
//         // setSelectedServiceStatus([]);
//         setServiceStatusList(tempStatus);
//         // setSearchTerm("");
//         // setfromDate("");
//         // settoDate("");
//         // setSelectedRequestedaCallBackOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setSelectedNeedToTalkToSPOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setSelectedRequestedByOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setselectedCallStatusOptionForFilter(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setselectedofflinemeetoptionsForFilter(null);

//         // setSelectedPackageNameListForFilter(null);
//         // // setselectedofflinemeetoptions(null);
//         // //setExpandedChange({});
//         setSelectedServiceStatusListForFilter([]);
//         // setRequestWithinTAT('');
//     };

    
    

//     // console.log(selectedServiceStatusListForFilter, ">>>>selectedServiceStatusListForFilter");
    

//     // console.log(fromDate, ">>>>fromDate");
//     // console.log(toDate, ">>>toDate");
//     // console.log(selectedOppTypeWpModal, ">>>>selectedOppTypeWpModal");
//     // console.log(selectedOppTitleWpModal, ">>>>selectedOppTitleWpModal");
//     console.log(sentWhatsappCancellationMessages, ">>>>sentWhatsappCancellationMessages");
//     console.log(wpMessageDisplayRecordCount, ">>>>wpMessageDisplayRecordCount");
//     console.log(wpMessagecurrentPage, ">>>>wpMessagecurrentPage");
//     console.log(wpMessagepages, ">>>>>wpMessagepages");
//     console.log(wpMessagePageSize, ">>>>>wpMessagePageSize");
//     console.log(selectedViewMessagePageSizeOption, ">>>>>selectedViewMessagePageSizeOption");

//     // const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
//     // const [wpMessageDisplayRecordCount, setWpMessageDisplayRecordCount] = useState({displayCount: true, count: 0})
//     // const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
//     // const [wpMessagepages, setWpMessagePages] = useState(0);
//     // const [wpMessagePageSize, setWpMessagePageSize] = useState(10);
    
//   return (
//     <div className={`${isLoading && "set-opacity"}`}>
//             {isLoading && <Spinner className="center-screen" />}

//           <Modal isOpen={revenueModal}>
//               <ModalContent className="general-modal">
//                   <div className="modal-header" style={{
//                       backgroundColor: '#76287C',
//                       color: '#fff'
//                   }}>
//                       <span className="modal-title">Enter Revenue</span>
//                       <img
//                           alt="close"
//                           id="Close"
//                           src={close_modal}
//                           className="close modal-close"
//                           onClick={openRevenueModalisFalse}
//                       />
//                   </div>

//                   <div className="modal-body">
//                       {/* <div className="row">
//                           <div className="col m-2">
//                               <span className="spled-colored-label">Service Price</span> <span className="spled-black-text">: {serviceRequestReadOnlyData.fAmountFirst}</span>
//                           </div>
//                       </div> */}
//                       <div className="row mt-2">
//                           <div className="col-12 w-100">
//                               <input type="number" placeholder="Enter Revenue Generated (for eg: 1000)" style={{
//                                   width: "-webkit-fill-available",
//                                   height: '45px'
//                               }}
//                               min={0}
//                                   onKeyDown={(e) => {
//                                       const invalidChars = ['=', '-', '+', 'e'];
//                                       if (invalidChars.includes(e.key)) {
//                                           e.preventDefault();
//                                       }
//                                   }}
//                                   onChange={(e) => setRevenueAmount(e.target.value)} />
//                           </div>
//                       </div>
//                       <div className="row m-2">
//                           <div className="offset-3 col-6">
//                               <Button 
//                               onClick={onGenerateRevenueClick}
//                               >Update Revenue</Button>
//                           </div>
//                       </div>
//                   </div>
//               </ModalContent>
//           </Modal>

//           <div className="row" style={{
//             //   height: "75px",
//               marginBottom: '15px',
//               boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)"
//           }} >
            
//               <div className='col-12'>
//                 <div className='row'>
//                     <div className="col-2 ml-4 mt-3 conv-pl25 spled-container conv-zindex" style={{backgroundColor:""}}>
//                         <button className="con-btn-filled conv-pl15 conv-pr15 conv-font14" style={{ marginLeft: '15px' }}
//                             onClick={(e) => { handleViewFilterModal() }} 
//                         >
//                             <img
//                                 alt=""
//                                 src={ic_filter}
//                                 height={"15px"}
//                                 width={"15px"}
//                                 className="conv-mr10"
//                             />
//                             Filter By
//                         </button>
//                 </div>
//                 </div>
//               </div>
            
//               <div className="col-12">
//                 <div className="row">
//                 <div className="col-2 ml-5 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       <Select
//                           options={oppTypeNameList}
//                           onChange={onOppTypeChange}
//                           value={selectedOppType}
//                           placeholder="Select Opp Type"
//                           isClearable
//                       />
//                   </div>
//               </div>

//               <div className="col-2 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       {/* <Select
//                           options={oppTitleNameList}
//                             onChange={onOppTitleChange}
//                             value={selectedOppTitle}
//                           placeholder="Select Opp Title"
//                           isClearable
//                       /> */}
//                       <MultiSelectAll
//                                   toggleAll={toggleAllOppTitle}
//                                   toggleSelection={onOppTitleChange}
//                                   checkboxItemsList={oppTitleNameList}
//                                   selectedOptions={selectedOppTitle}
//                                   placeholderButtonLabel="Select Opp Title"
//                               />
//                   </div>
//               </div>

//               <div className="col-2 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={businessSectorList}
//                           placeholder="Select Sector"
//                           onChange={onBusinessSectorChange}
//                           value={selectedBusinessSector}
//                           isClearable
//                       /> */}
//                               <MultiSelectAll
//                                   toggleAll={toggleAllSector}
//                                   toggleSelection={onBusinessSectorChange}
//                                   checkboxItemsList={businessSectorList}
//                                   selectedOptions={selectedBusinessSector}
//                                   placeholderButtonLabel="Select Sector"
//                               />
//                   </div>
//               </div>
//               <div className="col-2 spled-container mt-3 conv-zindex">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={tagsDropDownList}
//                           placeholder="Select Tag"
//                           onChange={onTagChange}
//                           value={selectedTagOption}
//                           isClearable
//                       /> */}
//                           <MultiSelectAll
//                               toggleAll={toggleAllTags}
//                               toggleSelection={onTagChange}
//                               checkboxItemsList={tagsDropDownList}
//                               selectedOptions={selectedTagOption}
//                               placeholderButtonLabel="Select Tags"
//                           />
//                   </div>
//                   <div className="col-2 spled-container mt-3 conv-zindex">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={businessCityList}
//                           placeholder="Select City"
//                           onChange={onBusinessCityChange}
//                           value={selectedBusinessCity}
//                           isClearable
//                       /> */}
//                           <MultiSelectAll
//                               toggleAll={toggleAllBusinessCity}
//                               toggleSelection={onBusinessCityChange}
//                               checkboxItemsList={businessCityList}
//                               selectedOptions={selectedBusinessCity}
//                               placeholderButtonLabel="Select City"
//                           />
//                   </div>

//               {/* <div className="col-2 mt-3 spled-container conv-zindex"> */}
//                   <div className='mt-3 spled-container conv-zindex'>
//                       <Button style={{
//                           margin: 0,
//                           marginLeft: '10px',
//                           height: '37px'
//                       }}
//                           onClick={onSearchClick}
//                           // disabled={!props.selectedExtPartner}
//                           className="con-btn-filled">Search</Button>
//                   </div>
//               {/* </div> */}
//                 </div>
//               </div>


//               {/* <div className="col-3 mt-2 spled-container"  style={{
//                     //   justifyContent: 'flex-end'
//                     marginLeft: '47px'
//                   }}>
//                             <ControlledInput
//                                 className="reportInputUmc"
//                                 name="sContactNumber"
//                                 placeholder="Contact Number"
//                                 value={searchFields.sContactNumber}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 //   onKeyDown={(e) => {
//                                 //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                                 //       if (
//                                 //           !/^\d$/.test(e.key) &&
//                                 //           !allowedKeys.includes(e.key) &&
//                                 //           e.key !== "Tab"
//                                 //       ) {
//                                 //           e.preventDefault();
//                                 //       }
//                                 //   }}
//                                 onKeyDown={(e) => {
//                                     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                                     const ctrlKeys = ["a", "c", "v", "x"];

//                                     if (
//                                         !/^\d$/.test(e.key) && // Allow digits
//                                         !allowedKeys.includes(e.key) && // Allow navigation keys
//                                         !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                                     ) {
//                                         e.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div> */}

              
//                   {/* <div className="col-3 d-flex align-items-center">
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={onDeliverServicesBtnClick}
//                                   className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Deliver Services</button>
//                               :
//                               <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Deliver Services</button>

//                       }
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={() => setShowCancellationReasonModal(true)}
//                                   className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Cancel Services</button>
//                               :
//                               <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Cancel Services</button>

//                       }
//                   </div> */}

//                   {/* Added Confirmation Received */}
//                  {/* <div className="col-4 d-flex mt-3">
//                             <div className="">
//                                 <Checkbox
//                                     id={`checkbox3-completed`}
//                                     checked={confirmationChecked}
//                                     onChange={(e) => {
//                                         e.stopPropagation();
//                                         setConfirmationChecked(!confirmationChecked)
//                                         // updateConfirmationFlagData(row.original)
//                                         // props.getExternalPartnerServices()
//                                     }}
//                                     label={"Confirmation Received"}
//                                 // disabled={row.original.bConfirmation_tag}
//                                 ></Checkbox>
//                             </div>
//                     </div> */}

//               <div className="col-2 mt-2 spled-container" style={{
//                   // justifyContent: 'flex-end'
//                   marginLeft: '33px',
//                   display: "flex",
//                   // alignItems:"center"
//                   justifyContent: "space-between",
//                   backgroundColor:""
//               }}>
//                   {/* Added Confirmation Received */}
//                   <div className="col-5 d-flex" style={{backgroundColor:""}}>
//                       <div className="">
//                           <Checkbox
//                               id={`checkbox3-completed`}
//                               checked={confirmationChecked}
//                               onChange={(e) => {
//                                   e.stopPropagation();
//                                   setConfirmationChecked(!confirmationChecked)
//                                   // updateConfirmationFlagData(row.original)
//                                   // props.getExternalPartnerServices()
//                               }}
//                               label={"Confirmation Received"}
//                           // disabled={row.original.bConfirmation_tag}
//                           ></Checkbox>
//                       </div>
//                   </div>
//               </div>

//               {/* <div className="col-8 d-flex align-items-center pl-4 ml-1">

//                   <div className='mt-2' style={{ display: "flex" }}>
//                       <ControlledInput
//                           className="reportInputUmc"
//                           name="sContactNumber"
//                           placeholder="Contact Number"
//                           value={searchFields.sContactNumber}
//                           onChange={({ target: { name, value } }) => handleChange(name, value)}
//                           // onKeyDown={(e) => {
//                           //     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                           //     if (
//                           //         !/^\d$/.test(e.key) &&
//                           //         !allowedKeys.includes(e.key) &&
//                           //         e.key !== "Tab"
//                           //     ) {
//                           //         e.preventDefault();
//                           //     }
//                           // }}
//                           onKeyDown={(e) => {
//                               const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                               const ctrlKeys = ["a", "c", "v", "x"];

//                               if (
//                                   !/^\d$/.test(e.key) && // Allow digits
//                                   !allowedKeys.includes(e.key) && // Allow navigation keys
//                                   !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                               ) {
//                                   e.preventDefault();
//                               }
//                           }}
//                           autoComplete="off"
//                       />
//                   </div>
//                   {
//                       selectedServices.length > 0 ?
//                           <button
//                               onClick={onDeliverServicesBtnClick}
//                               className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Deliver Services</button>
//                           :
//                           <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Deliver Services</button>

//                   }
//                   {
//                       selectedServices.length > 0 ?
//                           <button
//                               onClick={() => setShowCancellationReasonModal(true)}
//                               className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Cancel Services</button>
//                           :
//                           <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Cancel Services</button>

//                   }
//               </div> */}

//                <div className="col-2 mt-2 spled-container"  style={{
//                     //   justifyContent: 'flex-end'
//                     marginLeft: '15px',
//                     backgroundColor:""
//                   }}>
//                             <ControlledInput
//                                 className="reportInputUmc"
//                                 name="sContactNumber"
//                                 placeholder="Contact Number"
//                                 value={searchFields.sContactNumber}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 //   onKeyDown={(e) => {
//                                 //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                                 //       if (
//                                 //           !/^\d$/.test(e.key) &&
//                                 //           !allowedKeys.includes(e.key) &&
//                                 //           e.key !== "Tab"
//                                 //       ) {
//                                 //           e.preventDefault();
//                                 //       }
//                                 //   }}
//                                 onKeyDown={(e) => {
//                                     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                                     const ctrlKeys = ["a", "c", "v", "x"];

//                                     if (
//                                         !/^\d$/.test(e.key) && // Allow digits
//                                         !allowedKeys.includes(e.key) && // Allow navigation keys
//                                         !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                                     ) {
//                                         e.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div>

//                 {/* <div className="col-6 d-flex align-items-center" style={{backgroundColor:"red", margin:"0px", padding:"0px",justifyContent:"space-between", paddingLeft:"9px", paddingRight:"13px"}}>
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={onDeliverServicesBtnClick}
//                                   className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Deliver Services</button>
//                               :
//                               <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Deliver Services</button>

//                       }
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={() => setShowCancellationReasonModal(true)}
//                                   className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Cancel Services</button>
//                               :
//                               <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Cancel Services</button>

//                       }


//                     {
//                         selectedServices.length > 0 ?
//                             <button
//                                 onClick={() => handleSendCancellationMessage()}
//                                 className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                     marginBottom: "15px"
//                                 }}>
//                                 Send Cancellation Messge</button>
//                             :
//                             <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                 marginBottom: "15px",
//                                 opacity: "0.4",
//                                 pointerEvents: "none",
//                             }}>
//                                 Send Cancellation Message</button>
//                     }
//                     {
//                         <button
//                         onClick={() => toggleShowWhatsappMessagesModal()}
//                         className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                             marginBottom: "15px"
//                         }}>
//                             View Messages
//                         </button>
//                     }
//                 </div> */}

//                 <div
//                 className="col-6 d-flex align-items-center"
//                 style={{
//                     backgroundColor: "",
//                     margin: "0px",
//                     padding: "0px",
//                     justifyContent: "space-between",
//                     paddingLeft: "7px",
//                     paddingRight: "15px"
//                 }}
//                 >
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={onDeliverServicesBtnClick}
//                         className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Deliver Services
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Deliver Services
//                     </button>
//                     )
//                 }
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={() => setShowCancellationReasonModal(true)}
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Cancel Services
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Cancel Services
//                     </button>
//                     )
//                 }
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={() => handleSendCancellationMessage()}
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Send Cancellation Message
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Send Cancellation Message
//                     </button>
//                     )
//                 }
//                 {
//                     <button
//                     onClick={() => toggleShowWhatsappMessagesModal()}
//                     className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                     style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                     }}
//                     >
//                     View Messages
//                     </button>
//                 }
//                 </div>


//               {/* <div className='col-2 mt-2 spled-container conv-zindex'>
//                   <Button style={{
//                       margin: 0,
//                       marginLeft: '6px',
//                       height: '37px',
//                       display: 'none',
//                       width: 100
//                   }}
//                       onClick={onClearClick}
//                       // disabled={!props.selectedExtPartner}
//                       className="con-btn-filled">Clear</Button>
//               </div> */}


//                   <div className='mt-2 spled-container conv-zindex' style={{backgroundColor:""}}>
//                       <Button style={{
//                           margin: 0,
//                           marginLeft: '10px',
//                           height: '37px',
//                           width: 100
//                       }}
//                           onClick={onClearClick}
//                           // disabled={!props.selectedExtPartner}
//                           className="con-btn-filled">Clear</Button>
//                   </div>

                  

              
              
//               {/* <div className="col-2 d-flex align-items-center" style={{
//                   justifyContent: 'flex-end'
//               }} >
//                   {
//                       selectedServiceRequests.length > 0 ?
//                           <Button
//                               onClick={openPaymentModalisTrue}
//                               className="esp-inline-button ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Settle Payment</Button>
//                           :
//                           <Button className="esp-inline-button ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Settle Payment</Button>

//                   }
//               </div> */}
//           </div>

//           <ESPUmcReactTable 
//             data={tableData}
//             displayRecordCount={displayRecordCount}
//             handleCatalogueClick={handleCatalogueClick}
//             onEnterRevenueClick={onEnterRevenueClick}
//             handleCheckboxChange={handleCheckboxChange}
//             isSelected={isSelected}
//             selectedServices={selectedServices}
//             handleSelectAll={handleSelectAll}
//             openRevenueModalisTrue={openRevenueModalisTrue}
//             onFetchServiceRequests={fetchServiceRequests}
//             pages={pages}
//             pageSize={pageSize}
//             page={currentPage}
//             pageSizeOptions={pageSizeOptions}
//             selectedPageSizeOption={selectedPageSizeOption}
//             onPageSizeOptionChange={(option) => {
//                 setSelectedPageSizeOption(option);
//             }}
//           />

//           {
//               showCancellationReasonModal &&
//               <CancellationReasonModal
//                   isDisabled={enableCancelButtonFlag}
//                   isOpen={showCancellationReasonModal}
//                   toggleModal={toggleCancellationReasonModal}
//                   cancellationReasonDropdownOptions={
//                       cancellationReasonDropdownOptions
//                   }
//                   onSelectCancellationReason={setSelectedCancellationReason}
//                   selectedCancellationReason={selectedCancellationReason}
//                   enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
//                   cancellationReasonOtherDescription={
//                       cancellationReasonOtherDescription
//                   }
//                   onChangeCancellationReasonOtherDescription={(value) => {
//                       setCancellationReasonOtherDescription(value);
//                   }}
//                   onChangeState={handleChangeState}
//               />
//           }

//           {/* View Whatsapp Messages Model */}
//           <ViewWhatsappMessagesModal
//             isOpen = {showWhatsappMessagesModal}
//             data = {sentWhatsappCancellationMessages}
//             displayRecordCount={wpMessageDisplayRecordCount}
//             pageSizeOptions={viewMessagePageSizeOptions}

//             pages={wpMessagepages}
            
//             toggleModal = {toggleShowWhatsappMessagesModal}
            
//             pageSize = {wpMessagePageSize} // responsible for purple select the page size
//             page={wpMessagecurrentPage}
            
//             onViewMessagePageSizeOptionChange={(option) => {
//                 console.log(">>>>option on onViewMessagePageSizeOptionChange");
                
//                 setSelectedViewMessagePageSizeOption(option);
//                 setWpMessagePageSize(option?.value)
//             }}
//             selectedPageSizeOption={selectedViewMessagePageSizeOption}

//             // BELOW IS DATA FOR FILTER
//             oppTypeNameListWpModal={oppTypeNameListWpModal}
//             onOppTypeChange={onOppTypeChange}
//             selectedOppType={selectedOppTypeWpModal}

//             toggleAllOppTitle={toggleAllOppTitle}
//             onOppTitleChange={onOppTitleChange}
//             oppTitleNameListWpModal={oppTitleNameListWpModal}
//             selectedOppTitleWpModal={selectedOppTitleWpModal}

//             // setFromDate = {setFromDate}
//             handleFromDate={handleFromDate}
//             // setToDate={setToDate}
//             handleToDate={handleToDate}
//             fromDate={fromDate}
//             toDate={toDate}

//             searchFilterWpSendCacellationMessages={searchFilterWpSendCacellationMessages}
//             wpCancellationMessageIsLoading={wpCancellationMessageIsLoading}

//             clearSearchFilterWpCancellationMessages={clearSearchFilterWpCancellationMessages}

//             messageTypeOptions={messageTypeOptions}
//             onMessageTypeChange={onMessageTypeChange}
//             selectedMessageType={selectedMessageType}

//             handleViewMessageOnFetchData={handleViewMessageOnFetchData}
//           />

// {
// 				showFilterModal &&
// 				(
// 					<ESPUmcLedFilterModel
// 						isOpen={showFilterModal}
// 						toggleModal={toggleFilterModal}
// 						toggleAllForFilter={toggleAllForFilter}
// 						toggleSelectionForFilter={toggleSelectionForFilter}
// 						serviceNameListForFilter={serviceNameListForFilter}

// 						// selectedServiceNameListForFilter={props.selectedServiceNameListForFilter}
// 						// fromDate={props.fromDate}
// 						// setfromDate={props.setfromDate}
// 						// toDate={props.toDate}
// 						// settoDate={props.settoDate}
// 						// requestedByOptions={props.requestedByOptions}
// 						// setSelectedRequestedByOption={props.setSelectedRequestedByOption}
// 						// selectedRequestedByOption={props.selectedRequestedByOption}
// 						// packageNameListForFilter={props.packageNameListForFilter}
// 						// oppTypeNameListforFilter={props.oppTypeNameListforFilter}
// 						// setSelectedPackageNameListForFilter={props.setSelectedPackageNameListForFilter}
// 						// selectedPackageNameListForFilter={props.selectedPackageNameListForFilter}
// 						// requestedaCallBackOptions={props.requestedaCallBackOptions}
// 						// setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
// 						// selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
// 						// toggleServiceStatus={props.toggleServiceStatus}
// 						// serviceStatusList={props.serviceStatusList}
// 						// callStatusOptionsForFilter={props.callStatusOptionsForFilter}
// 						// setselectedCallStatusOptionForFilter={props.setselectedCallStatusOptionForFilter}
// 						// selectedCallStatusOptionForFilter={props.selectedCallStatusOptionForFilter}
// 						// setSelectedRequestedaCallBackOption={props.setSelectedRequestedaCallBackOption}
// 						// selectedRequestedaCallBackOption={props.selectedRequestedaCallBackOption}

// 						onSearchClicked={handleSearchClick}
// 						onClearFilterSearch={handleClearFilterSearch}
// 						toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
// 						toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
// 						selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
// 						serviceStatusNameListForFilter={serviceStatusNameListForFilter}

// 						// //offline meet
// 						// offlinemeetoptionsForFilter={props.offlinemeetoptionsForFilter}
// 						// setselectedofflinemeetoptionsForFilter={props.setselectedofflinemeetoptionsForFilter}
// 						// selectedofflinemeetoptionsForFilter={props.selectedofflinemeetoptionsForFilter}



// 						// offlinemeetoptions={props.offlinemeetoptions}
// 						// selectedofflinemeetoptions={props.selectedofflinemeetoptions}
// 						// setselectedofflinemeetoptions={props.setselectedofflinemeetoptions}




// 						// //for admin
// 						// externalServicePartnerOptions={props.externalServicePartnerOptions}
// 						// selectedExternalServicePartner={props.selectedExternalServicePartner}
// 						// onExternalServicePartnerChange={props.onExternalServicePartnerChange}
// 						// ExternalServicePartnerOrganization={props.ExternalServicePartnerOrganization}
// 						// isForAdmin={props.isForAdmin}
// 					>
// 					</ESPUmcLedFilterModel>
// 				)
// 			}
                
//     </div>
//   )
// }

// export default ESPUmcInterface



// //======================================= WISH KA =================================== //
// import React, { useEffect, useState } from 'react'
// import Select from "react-select";
// import api from '../../utils/api';
// import { Button } from '../../common/Button/Button';
// import ESPUmcReactTable from './ESPUmcReactTable';
// import ModalContent from '../../common/Modal/ModalContent';
// import close_modal from '../../assets/ic_close_wh.svg'
// import Modal from "react-modal";
// import Spinner from '../../common/Spinner/Spinner';
// import { toast } from 'react-toastify';
// import CancellationReasonModal from '../../components/ServiceRequests/Handholder/CancellationReasonModal';
// import MultiSelectAll from '../../common/Multiselect/MultiSelectAll';
// import { ControlledInput } from '../../common/Input/Input';
// import Checkbox from '../../common/Checkbox/Checkbox';

// import ViewWhatsappMessagesModal from '../../components/ServiceRequests/Handholder/ViewWhatsappMessagesModal';

// import ic_filter from "../../assets/ic_filter.svg";

// import ESPUmcLedFilterModel from '../../components/EServicePartnerServiceRequests/ESPUmcLedFilterModel';

// const ESPUmcInterface = () => {

//     const [revenueModal, setRevenueModal] = useState(false)
//     const [revenueAmount, setRevenueAmount] = useState('')

//     const [resourceId, setResourceId] = useState(0)
//     const [serviceDisplay, setServiceDisplay] = useState("")

//     const [tableData, setTableData] = useState([])
//     const [isClearAction, setIsClearAction] = useState(false);

//     const [oppTypeNameList, setOppTypeNameList] = useState()
//     const [selectedOppType, setSelectedOppType] = useState(null)

//     const [oppTitleNameList, setOppTitleNameList] = useState([])
//     const [selectedOppTitle, setSelectedOppTitle] = useState([])

//     const [businessSectorList, setBusinessSectorList] = useState([])
//     const [selectedBusinessSector, setSelectedBusinessSector] = useState([])

//     const [displayRecordCount, setDisplayRecordCount] = useState({displayCount: true, count: 0})

//     const [searchFields, setSearchFields] = useState({
//         sContactNumber: ""
//     })

//     const [confirmationChecked, setConfirmationChecked] = useState(false)

//     useEffect(() => {
//         if (isClearAction) {
//             // Call umcCustomersData only after state updates have been completed
//             getTableData(tableInstance, true);
            
//             // Reset the clear action flag
//             setIsClearAction(false);
//         }
//     }, [
//         isClearAction // This ensures the function is called after clearing
//     ]);

//     const handleChange = (name, value) => {
//         const updated = { ...searchFields, [name]: value };
//         setSearchFields(updated)
//     }

//     const onBusinessSectorChange = (options) => {
//         // setSelectedBusinessSector(option)
//         // getTagsDropdown(option)

//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedBusinessSector([{ value: "*", label: "All" }]);
//             getTagsDropdown(processFilters(options))
//         } else {
//             setSelectedBusinessSector(options.filter((opt) => opt.value !== "*"));
//             getTagsDropdown(processFilters(options))
//         }
//     }

//     const toggleAllSector = () => {
//         if (selectedBusinessSector.length != businessSectorList.length && selectedBusinessSector.length != (businessSectorList.length + 1)) {
//           let temp = []
    
//           if (selectedBusinessSector.includes({ label: "All", value: "*" })) {
//             temp = selectedBusinessSector
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = businessSectorList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setBusinessSectorList(tempSR)
//           setSelectedBusinessSector(temp)
//           getTagsDropdown(processFilters(temp))
//         } else {
//           setSelectedBusinessSector([])
//           getTagsDropdown(null)
//         }
    
//       }

//     const [businessCityList, setBusinessCityList] = useState([])
//     const [selectedBusinessCity, setSelectedBusinessCity] = useState([])

//     const onBusinessCityChange = (options) => {
//         // setSelectedBusinessCity(option)
        
//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedBusinessCity([{ value: "*", label: "All" }]);
//         } else {
//             setSelectedBusinessCity(options.filter((opt) => opt.value !== "*"));
//         }
//     }

//     const toggleAllBusinessCity = () => {
//         if (selectedBusinessCity.length != businessCityList.length && selectedBusinessCity.length != (businessCityList.length + 1)) {
//           let temp = []
    
//           if (selectedBusinessCity.includes({ label: "All", value: "*" })) {
//             temp = selectedBusinessCity
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = businessCityList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setBusinessCityList(tempSR)
//           setSelectedBusinessCity(temp)
//         } else {
//           setSelectedBusinessCity([])
//         }
    
//       }

//     const [tagsDropDownList, setTagsDropdownList] = useState([])
//     const [selectedTagOption, setSelectedTagOption] = useState([])

//     const getTagsDropdown = (e) => {
//         if (e !== null) {
//             api.tagsListApi(e)
//                 .then(({ data }) => {
//                     if (data.data.length > 0) {
//                         // Flatten all sTag arrays into a single array
//                         const allTags = data.data.flatMap(sector => sector.sTag);
    
//                         // Remove duplicates
//                         const uniqueTags = [...new Set(allTags)];
    
//                         // Format the tags for the dropdown
//                         const formattedData = uniqueTags.map(tag => ({
//                             value: tag,
//                             label: tag
//                         }));
    
//                         setTagsDropdownList(formattedData);
//                         console.log("Drop list", formattedData);
//                     } else {
//                         setTagsDropdownList([]);
//                     }
//                 })
//                 .catch(error => {
//                     console.error("API error:", error);
//                     setTagsDropdownList([]);
//                 });
//         } else {
//             setTagsDropdownList([]);
//             setSelectedTagOption([]);
//         }
//     };

//     const onTagChange = (options) => {
//         // setSelectedTagOption(option)

//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedTagOption([{ value: "*", label: "All" }]);
//         } else {
//             setSelectedTagOption(options.filter((opt) => opt.value !== "*"));
//         }
//     }

//     const toggleAllTags = () => {
//         if (selectedTagOption.length != tagsDropDownList.length && selectedTagOption.length != (tagsDropDownList.length + 1)) {
//           let temp = []
    
//           if (selectedTagOption.includes({ label: "All", value: "*" })) {
//             temp = selectedTagOption
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = tagsDropDownList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setTagsDropdownList(tempSR)
//           setSelectedTagOption(temp)
//         } else {
//           setSelectedTagOption([])
//         }
    
//       }

//     const [pages, setPages] = useState(0);
//     const [pageSize, setPageSize] = useState(10);
//     const [currentPage, setcurrentPage] = useState(0);
//     const [tableInstance, setTableInstance] = useState(null);
//     const [count, setCount] = useState(0);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isFilterTrue, setIsFilterTrue] = useState(false)
//     const [pageSizeOptions, setpageSizeOptions] = useState([
//         {
//             value: "10",
//             label: "10 Rows",
//         },
//         {
//             value: "20",
//             label: "20 Rows",
//         },
//         {
//             value: "30",
//             label: "30 Rows",
//         },
//         {
//             value: "50",
//             label: "50 Rows",
//         },
//         {
//             value: "75",
//             label: "75 Rows",
//         },
//         {
//             value: "100",
//             label: "100 Rows",
//         },
//     ]);
//     const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
//         value: "10",
//         label: "10",
//     });
//     const [selectedServices, setSelectedServices] = useState([]);

//     /**CancellationReason */

// 	const [showCancellationReasonModal, setShowCancellationReasonModal,] = useState(false);
//     const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState();
// 	const [selectedCancellationReason, setSelectedCancellationReason,] = useState();
// 	const [enableOtherDescriptionTextbox, setEnableOtherDescriptionTextbox,] = useState(false);
// 	const [cancellationReasonOtherDescription, setCancellationReasonOtherDescription,] = useState();
// 	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");

// 	const toggleCancellationReasonModal = () => {
//         setSelectedCancellationReason()
//         setCancellationReasonOtherDescription()
// 		setShowCancellationReasonModal(!showCancellationReasonModal);
// 	};

//     // const enableCancelButton = () => {
//     //     if(selectedCancellationReason){
//     //         setEnableCancelButtonFlag("")
//     //     }
//     // }

//     const enableCancelButton = () => {
// 		if (selectedCancellationReason) {
// 			if (selectedCancellationReason.value === "Other") {
// 				if (
// 					cancellationReasonOtherDescription &&
// 					cancellationReasonOtherDescription.length > 0
// 				) {
// 					setEnableCancelButtonFlag("");
// 				} else setEnableCancelButtonFlag("disable");
// 			} else setEnableCancelButtonFlag("");
// 		} else setEnableCancelButtonFlag("disable");
// 	};

//     useEffect(() => {
//         enableCancelButton()
//     }, [selectedCancellationReason, cancellationReasonOtherDescription])

//     const handleCheckboxChange = (serviceInstanceId) => {
//         const currentIndex = selectedServices.indexOf(serviceInstanceId);
//         const newSelectedServices = [...selectedServices];

//         if (currentIndex === -1) {
//             newSelectedServices.push(serviceInstanceId);
//         } else {
//             newSelectedServices.splice(currentIndex, 1);
//         }

//         setSelectedServices(newSelectedServices);
//         console.log("Selected Service", newSelectedServices)
//     };

//     const isSelected = (serviceInstanceId) => selectedServices.includes(serviceInstanceId);

//     const handleSelectAll = () => {
//         const selectableServices = tableData.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled');
//         const selectableServiceIds = selectableServices.map(service => service.nResourceInstanceId);
    
//         if (selectedServices.length === selectableServiceIds.length) {
//             // Deselect all services
//             setSelectedServices([]);
//         } else {
//             // Select all services
//             setSelectedServices(selectableServiceIds);
//         }
//         console.log("Serv", selectableServiceIds)
//     };

//     const onDeliverServicesBtnClick = async() => {
//             let payload = {
//                 nResourceInstanceId: selectedServices,
//                 refCurrentState: 'Delivered'
//             }
//             setIsLoading(true)
//             const {deliverBulkServices} = api.deliverBulkServiceData(payload)
//             .then(({data}) => {
//                 if(data){
//                     console.log("Data", data.Message)
//                     setIsLoading(false)
//                     toast(String(data.Message), {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     });
//                     getTableData(tableInstance, false)
//                     setSelectedServices([])
//                 }
//             }) .catch((error) => {
//                 setIsLoading(false);
//                 if (error.response.data.error) {
//                     toast(String("Services cannot be delivered as some services are still in LPM."), {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//                 else if (error.response.data.message) {
//                     toast(String(error.response.data.message), {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//                 else {
//                     toast("Internal server error", {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//             })
//     }

//     const getTableData = async (instance, flag = false) => {
//         if (!instance) return;
//         if (!tableInstance) setTableInstance(instance);

//         try {
//             const { page } = instance.state ?? { page: 0 };
//             let icurrentPage = page;
//             if (!flag && isNaN(icurrentPage)) return;
//             const pageSize = selectedPageSizeOption.value;

//             if (flag || isNaN(icurrentPage)) {
//                 icurrentPage = 0;
//             }

//             let servicestatusListtemp2 = [];
//         selectedServiceStatusListForFilter.map((e) => {
//             if (e.value != "*") {
//                 servicestatusListtemp2.push(e.value);
//             }
//         });
//         const serviceStatusList = servicestatusListtemp2;

//         let serviceStatusFilter = [];
//         serviceStatusList.map((e) => {
//             if (e === "Willing to Pay") {
//                 serviceStatusFilter.push("Ready For Progression:Partner");
//                 serviceStatusFilter.push("Partial/ Full Payment Pending");
//             }
//             else if (e === "Payment Received") {
//                 serviceStatusFilter.push("Payment Confirmed By Partner");
//                 serviceStatusFilter.push("Ready For Progression:deAsra");
//             }
//             else {
//                 serviceStatusFilter.push(e);
//             }
//         });
//         const statusList = serviceStatusFilter;

//             let ResourceNamesTemp = []
//             selectedOppTitle.map((e) => {
//                 if(e.value != "*"){
//                     ResourceNamesTemp.push(e.value)
//                 }
//             })


//             let filterParameters = {
//                 page_no: icurrentPage + 1,
//                 page_size: pageSize,
//                 // pagination: true,
//                 // SP_email: 'archana.sapre@mailinator.com'
//             };

//             if(selectedOppType){
//                 filterParameters.service_codes = [selectedOppType.value]
//             }
    
//             if(selectedOppTitle){
//                 filterParameters.ResourceName = ResourceNamesTemp
//             }

//             // if (selectedOppTitle.length > 0) {
//             //     filterParameters.sServiceDisplayName = processFilters(selectedOppTitle) 
//             // }

//             if(confirmationChecked){
//                 filterParameters.bConfirmation_tag = confirmationChecked
//             }
            
//             if (statusList.length) {
//                 filterParameters.statusList = statusList;
//             }

//             if(selectedBusinessSector.length > 0){
//                 filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
//             }

//             if(selectedBusinessCity.length > 0){
//                 filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
//             }

//             if(selectedTagOption.length > 0){
//                 filterParameters.sTag = processFilters(selectedTagOption)
//             }

//             if (searchFields.sContactNumber !== "") {
//                 filterParameters.search_value = searchFields.sContactNumber
//             }

//             if (currentPage != icurrentPage) {
//                 setSelectedServices([]);
//             }

//             setIsLoading(true);
//             const { tempServices } = api.getExternalPartnerUmcServices(filterParameters).then(({ data }) => {
//                 setIsLoading(false);
//                 if (data) {
//                     // const { results, count } = data;
//                     setcurrentPage(icurrentPage);
//                     setPages(data.total_pages);
//                     setPageSize(pageSize);
//                     setDisplayRecordCount({...displayRecordCount, count: data?.total_count})


//                     let tempLPMServiceList = data.ServiceRequests.map((x) => {
//                         x.custrefSRState = x.refSRState;
//                         x.custsSRCancellationReason = x.sSRCancellationReason;
//                         x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
//                         x.custsNotesHH = null;
//                         x.custdtFollowupOn = null;
//                         x.custsFollowupNotes = null;
//                         x.serviceFrom = "LPM";
//                         x.custOtherServiceInfo = x.sOtherServicesInfo;
//                         x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
//                         x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
//                         x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
//                         x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
//                         x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
//                         x.custsCallStatus = x.sCallStatus;
//                         x.custsUpdateNoteForAllServicesInPackage = false;
//                         x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
//                         x.custbOfflineMeet = x.bOfflineMeet;
//                         return x;
//                     });
    
//                     let tempSPMerviceList = data.Services.map((x) => {
//                         x.custrefSRState = x.refCurrentState.sServiceState;
//                         x.custsSRCancellationReason = x.sServiceCancellationReason;
//                         x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
//                         x.custsNotesHH = null;
//                         x.custdtFollowupOn = null;
//                         x.custsFollowupNotes = null;
//                         x.serviceFrom = "SPM";
//                         x.OtherServiceInfo = null;
//                         x.custOtherServiceInfo = x.sOtherServicesInfo;
//                         x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
//                         x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
//                         x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
//                         x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
//                         x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
//                         x.custsCallStatus = x.sCallStatus;
//                         x.custsUpdateNoteForAllServicesInPackage = false;
//                         x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
//                         x.custbOfflineMeet = x.bOfflineMeet;
//                         return x;
//                     });

//                     var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
//                     let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
//                         return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
//                     })

//                     console.log("New Data", sortedServiceRequestsDesc)
//                     setTableData(sortedServiceRequestsDesc)
//                 }
//                 else {
//                     // toast("Something went wrong. Please contact Deasra Representative.", {
//                     //     autoClose: 5000,
//                     //     type: toast.TYPE.ERROR,
//                     // });
//                 }
//             })
//         } catch (error) {
//             setIsLoading(false);
//             console.log(error)
//             // toast("Internal Server Error", {
//             //     autoClose: 5000,
//             //     type: toast.TYPE.ERROR,
//             // });
//         }

//     }

//     const onSearchClick = () => {
//         getTableData(tableInstance, true)
//     }

//     const onClearClick = () => {
//         setSelectedOppType(null)
//         setSelectedOppTitle([])
//         setSelectedBusinessSector([])
//         setSelectedBusinessCity([])
//         setSelectedTagOption([])
//         setSearchFields({
//             sContactNumber: ""
//         })
//         setConfirmationChecked(false)
//         setIsClearAction(true);
//     }

//     const onEnterRevenueClick = (ele) => {
//         openRevenueModalisTrue()
//         setResourceId(ele.nResourceInstanceId)
//         setServiceDisplay(ele.sServiceDisplayName)
//     }

//     const onGenerateRevenueClick = () => {
//         if(revenueAmount === "0") {
//             toast("Revenue cannot be zero", {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//         } else {
//             setIsLoading(true)
//             openRevenueModalisFalse()
//             let payload = {
//                 nResourceInstanceId: resourceId,
//                 sServiceDisplayName: serviceDisplay,
//                 nRevenue: revenueAmount
//             }
    
//             const {tempAddRevenueUmc} = api.addRevenueUmc(payload)
//             .then(({data}) => {
//                 setIsLoading(false)
//                 toast("Revenue Updated Successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 console.log(data)
//                 setRevenueAmount('')
//                 getTableData(tableInstance, false)
//             })
//         }
        
//     }

//     useEffect(() => {
//         getTableData(tableInstance, true)
//     }, [selectedPageSizeOption])

//     useEffect(() => {
//         const { temp } = api.getCancellationReasons().then(({ data }) => {
// 			console.log("cancellationRason", data);
// 			let temp1 = data.map((e) => {
// 				return { value: e.sReason, label: e.sReason };
// 			});
// 			setCancellationReasonDropdownOptions(temp1);
// 		});
//     }, [])

//     const fetchServiceRequests = (instance, flag) => {
//         getTableData(instance, flag);
//     };
    

//     const onOppTypeChange = (option) => {
//         // setSelectedOppTitle(null)
//         if(showWhatsappMessagesModal){
//             setSelectedOppTypeWpModal(option)
//         } else{
//             setSelectedOppType(option)
//         }
//         getOppTitleNames(option)
//     }

//     // const onOppTitleChange = (option) => {
//     //     setSelectedOppTitle(option)
//     // }

//     const openRevenueModalisTrue = () => {
//         setRevenueModal(true)
//     }

//     const openRevenueModalisFalse = () => {
//         setRevenueModal(false)
//     }

//     useEffect(() => {
//         const { tempOppTypeServiceNames } = api.oppTypeListApi()
//         .then(({data}) => {
//             const formattedData = data.results.map((ele) => ({
//                 value: ele.sServiceCode,
//                 label: ele.sServiceName
//             }))
//             setOppTypeNameList(formattedData);
//             setOppTypeNameListWpModal(formattedData);
//         })

//         const { tempBusinessSectorListApi } = api.businessSectorListApi()
//             .then(({ data }) => {
//                 console.log("Business Sector", data)
//                 const formattedData = data.data
//                 .filter(ele => ele.sBusinessSector !== null)
//                 .map((ele) => ({
//                     value: ele.sBusinessSector,
//                     label: ele.sBusinessSector
//                 }))
//                 setBusinessSectorList(formattedData)
//             })

//             const { tempBusinessCityListApi } = api.businessCityListApi()
//             .then(({data}) => {
//                 const formatttedData = data.data
//                 .map((ele) => ({
//                     value: ele.sBusinessCity,
//                     label: ele.sBusinessCity
//                 }))
//                 setBusinessCityList(formatttedData)
//             })
//     }, [])

//     const getOppTitleNames = (ele) => {
//         // let filterParameters = {}

//         // if(selectedOppType !== null) {
//         //     filterParameters.OpportunityType = selectedOppType.value
//         // }
//         if(showWhatsappMessagesModal){
//             if(ele) {
//                 const { tempOppTitleNames } = api.oppTitleListApi({
//                     OpportunityType: ele.value
//                 })
//                 .then(({data}) => {
//                     const formattedData = data.results.map((ele) => ({
//                         value: ele.ResourceName,
//                         label: ele.ResourceName
//                     }))
//                     setOppTitleNameListWpModal(formattedData)
//                 })
//             } else {
//                 setOppTitleNameListWpModal([]);
//                 setSelectedOppTitleWpModal([]);
//             }
//         } else {
//             if(ele) {
//                 const { tempOppTitleNames } = api.oppTitleListApi({
//                     OpportunityType: ele.value
//                 })
//                 .then(({data}) => {
//                     const formattedData = data.results.map((ele) => ({
//                         value: ele.ResourceName,
//                         label: ele.ResourceName
//                     }))
//                     setOppTitleNameList(formattedData)
//                 })
//             } else {
//                 setOppTitleNameList([])
//                 setSelectedOppTitle([])
//             }
//         }
//     }

//     const toggleAllOppTitle = () => {
//         console.log(">>>toggle all opp titlw got clicekd");

//         if(showWhatsappMessagesModal){
//             if (selectedOppTitleWpModal?.length != oppTitleNameListWpModal?.length && selectedOppTitleWpModal?.length != (oppTitleNameListWpModal?.length + 1)) {
//                 let temp = []
          
//                 if (selectedOppTitleWpModal?.includes({ label: "All", value: "*" })) {
//                   temp = selectedOppTitleWpModal
//                 } else {
//                   temp = [{ label: "All", value: '*' }]
//                 }
          
//                 let tempSR = oppTitleNameListWpModal.map((e) => {
//                   if (!temp.includes(e)) {
//                     temp = temp.concat(e)
//                   }
//                   return e
//                 })
//                 setOppTitleNameListWpModal(tempSR);
//                 setSelectedOppTitleWpModal(temp)
//               //   getTagsDropdown(processFilters(temp))
//             } else {
//             setSelectedOppTitleWpModal([])
//             //   getTagsDropdown(null)
//             }
//         } else{
//             if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
//                 let temp = []
          
//                 if (selectedOppTitle.includes({ label: "All", value: "*" })) {
//                   temp = selectedOppTitle
//                 } else {
//                   temp = [{ label: "All", value: '*' }]
//                 }
          
//                 let tempSR = oppTitleNameList.map((e) => {
//                   if (!temp.includes(e)) {
//                     temp = temp.concat(e)
//                   }
//                   return e
//                 })
//                 setOppTitleNameList(tempSR)
//                 setSelectedOppTitle(temp)
//               //   getTagsDropdown(processFilters(temp))
//             } else {
//             setSelectedOppTitle([])
//             //   getTagsDropdown(null)
//             }
//         }
//     }

//     const onOppTitleChange = (options) => {
//         if(showWhatsappMessagesModal){
//             const isAllSelected = options.some((opt) => opt.value === "*");

//             if (isAllSelected) {
//                 setSelectedOppTitleWpModal([{ value: "*", label: "All" }]);
//                 // getTagsDropdown(processFilters(options))
//             } else {
//                 setSelectedOppTitleWpModal(options.filter((opt) => opt.value !== "*"));
//                 // getTagsDropdown(processFilters(options))
//             }
//         } else {
//             const isAllSelected = options.some((opt) => opt.value === "*");
//             if (isAllSelected) {
//                 setSelectedOppTitle([{ value: "*", label: "All" }]);
//                 // getTagsDropdown(processFilters(options))
//             } else {
//                 setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
//                 // getTagsDropdown(processFilters(options))
//             }
//         }
//     }

//     const handleChangeState = () => {
//         let cancellation_Reason, OtherDescription;
//         if(selectedCancellationReason) {
//             cancellation_Reason = selectedCancellationReason.value;
// 				if (cancellation_Reason !== "Other") OtherDescription = null;
// 				else OtherDescription = cancellationReasonOtherDescription;
//         }
//         setIsLoading(true)
//         setShowCancellationReasonModal(false)
//         let payload = {
//             nResourceInstanceId: selectedServices,
//             refCurrentState: "Cancelled",
//             sServiceCancellationReason: cancellation_Reason,
//             sOtherReason: OtherDescription
//         }

//         const {tempCancelBulkServices} = api.cancelBulkServiceData(payload)
//         .then(({data}) => {
//             if(data){
//                 setIsLoading(false)
//                 toast(String("Services Cancelled Successfully"), {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 setSelectedCancellationReason()
//                 setCancellationReasonOtherDescription()
//                 getTableData(tableInstance, false)
//                 setSelectedServices([])
//             }
//         })
//     }

//     const calculateEnableOtherDescriptionTextbox = () => {
// 		if (selectedCancellationReason && selectedCancellationReason.value === "Other") {
// 			setEnableOtherDescriptionTextbox(true);
// 		}
// 		else {
// 			setEnableOtherDescriptionTextbox(false);
// 		}
// 	};

// 	useEffect(() => {
// 		calculateEnableOtherDescriptionTextbox();
// 	}, [selectedCancellationReason]);

//     const processFilters = (filter) => {
//         let filterNames = ""
//         if (filter.length > 1) {
//             filterNames = filter.map(city => city.value).join(", ");
//         } else if (filter.length === 1) {
//             filterNames = filter[0].value;
//         }

//         return filterNames
//     }

//     const handleCatalogueClick = (ele) => {
//         setIsLoading(true)
//         let payload = {
//             api_key: "82mqEyJnct4kzC8y",
//             user_id: ele._original.nUserId
//         }

//         const { tempCataloguelinkData } = api.catalogueLinkApi(payload)
//             .then(({ data }) => {
//                 console.log("Link", data)
//                 if (data.data !== null) {
//                     window.open(data.data.catalogue_url, "_blank");
//                     setIsLoading(false)
//                 }
//             })
//     }
    
//     // Handle send cancellation Message Function
//     const handleSendCancellationMessage = () => {
//         // console.log(">>>>>Cancellation Message Button Clicked");
//         setIsLoading(true)

//         let payload = {"nResourceInstanceId": selectedServices}
//         api.sendCancellationMessage(payload).then(({data}) => {
//             if(data){
//                 toast("Whatsapp message sent successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 })

//                 setSelectedServices([]);
//             }

//             setIsLoading(false)
//         })
//     }

//     //===== View Whatsapp Message Related Function and States ====//
//     const [showWhatsappMessagesModal, setShowWhatsappMessagesModal] = useState(false);
//     const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
//     const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
//     const [wpMessagepages, setWpMessagePages] = useState(0);
//     const [wpMessagePageSize, setWpMessagePageSize] = useState(10);

//     const [oppTypeNameListWpModal, setOppTypeNameListWpModal] = useState(null);
//     const [selectedOppTypeWpModal, setSelectedOppTypeWpModal] = useState(null);

//     const [oppTitleNameListWpModal, setOppTitleNameListWpModal] = useState([])
//     const [selectedOppTitleWpModal, setSelectedOppTitleWpModal] = useState([]);

//     const [fromDate, setFromDate] = useState(null);
//     const [toDate, setToDate] = useState(null);
//     const [wpCancellationMessageIsLoading, setWpCancellationMessageIsLoading] = useState(false);
//     const [clearActionWpModalData, setClearActionWpModalData] = useState(false);

//     const toggleShowWhatsappMessagesModal = () => {
//         setShowWhatsappMessagesModal(!showWhatsappMessagesModal);

//         setSelectedOppTypeWpModal(null);
//         setSelectedOppTitleWpModal([]);
//         setFromDate(null);
//         setToDate(null);
//         // setSelectedOppTitle([]);
//         // setOppTitleNameList([]);
//     }

//     useEffect(()=>{
//         console.log(">>>useEffect to get cancellation message ran");
        
//         if(showWhatsappMessagesModal){
//             getWhatsappCancellationMessages();
//         }
//         setClearActionWpModalData(false);
//     }, [showWhatsappMessagesModal, clearActionWpModalData])

//     let getWhatsappCancellationMessages = async(data) =>{
//         try{
//             setWpCancellationMessageIsLoading(true)
//             let response = await api.getWhatsappMessageSentForCancellation(data);
//             console.log(response, ">>> whatsapp cancellation message data");
//             setSentWhatsappCancellationMessages(response.data);
//             // toast(String("Successfully received the "), {
//             //     autoClose: 5000,
//             //     type: toast.TYPE.SUCCESS,
//             // });

//             setWpCancellationMessageIsLoading(false)
//         } catch(err){
//             console.log(err)
//             setWpCancellationMessageIsLoading(false)
//         }
//     }

//     const searchFilterWpSendCacellationMessages = () =>{
//         console.log(selectedOppTypeWpModal, ">>>selectedOppTypeWpModal");
//         console.log(selectedOppTitleWpModal, ">>>selectedOppTitleWpModal");
//         console.log(fromDate, ">>>fromDate");
//         console.log(toDate, ">>>toDate");
//         console.log(toDate > fromDate, ">>>is two date greater than from date")

//         let nowDate = new Date()

//         if(toDate < fromDate){
//             toast(String("From-Date cant be greater than To-Date"), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//         }else {
//             {
//                 let selectedOppTypeWp = [];
//                 let selectedOppTitleWp = [];
//                 let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
//                 let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
    
//                 selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
//                 selectedOppTitleWpModal?.map(titleObj => {
//                     selectedOppTitleWp.push(titleObj?.value);
//                 })
    
//                 let data = {
//                     sServiceCode:[...selectedOppTypeWp],
//                     sServiceDisplayName: [...selectedOppTitleWp],
//                     fromDate: formattedFromDate,
//                     toDate: adjustedToDate(formattedToDate),
//                 }
        
//                 console.log(data, ">> data on search click");
        
//                 getWhatsappCancellationMessages(data);
//             }
//         }
//     }

//     const clearSearchFilterWpCancellationMessages = () => {
//         setClearActionWpModalData(true);
//         setSelectedOppTypeWpModal(null);
//         setSelectedOppTitleWpModal([]);
//         setOppTitleNameListWpModal([]);
        
//         setFromDate(null);
//         setToDate(null);
//     }

//     const adjustedToDate = (date) => {
// 		let toDateAdjusted;
// 		if (date) {
// 			toDateAdjusted = new Date(date);

// 			toDateAdjusted = new Date(
// 				toDateAdjusted.setTime(
// 					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
// 				)
// 			);
// 		}
// 		return toDateAdjusted;
// 	};

//     const handleFromDate = (date) =>{
//         if(toDate && toDate<date){
//             setToDate(null)
//         }
//         setFromDate(date)
//     }

//     const handleToDate = (date) => {
//         if(fromDate && fromDate > date){
//             setFromDate(null)
//         }
//         setToDate(date)
//     }

//     // States and functions for filter by status
//     /*Filter modal callbacks */
//     const [showFilterModal, setShowFilterModal] = useState(false);
//     const toggleFilterModal = () => {
//         setShowFilterModal(!showFilterModal);
//     };
//     const handleViewFilterModal = (original) => {
//         toggleFilterModal();
//     };
//     /*End */

//     // service status strates in filter modal
//     const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);
//     const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
//     const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
//     const [serviceStatusList, setServiceStatusList] = useState(statusArray);

//     let MainStatus = [
//         {
//             checked: false,
//             label: "Requested",
//             id: "Requested",
//             code: "Requested",
//         },
//         {
//             checked: false,
//             label: "Eligible",
//             id: "Eligible",
//             code: "Eligible",
//         },
//         {
//             checked: false,
//             label: "Quotation Sent",
//             id: "Quotation Sent",
//             code: "Quotation Sent",
//         },
//         {
//             checked: false,
//             label: "Willing to Pay",
//             id: "Willing to Pay",
//             code: "Willing to Pay",
//         },
//         {
//             checked: false,
//             label: "Payment Received",
//             id: "Payment Received",
//             code: "Payment Received",
//         },
//         {
//             checked: false,
//             label: "Awaiting for information/Documents",
//             id: "Awaiting for information/Documents",
//             code: "Awaiting for information/Documents",
//         },
//         {
//             checked: false,
//             label: "Service Delivery Started",
//             id: "Service Delivery Started",
//             code: "Service Delivery Started",
//         },
//         {
//             checked: false,
//             label: "Service deliverables ready",
//             id: "Service deliverables ready",
//             code: "Service deliverables ready",
//         },
//         {
//             checked: false,
//             label: "Full Payment Requested",
//             id: "Full Payment Requested",
//             code: "Full Payment Requested",
//         },
//         {
//             checked: false,
//             label: "Full Payment Received",
//             id: "Full Payment Received",
//             code: "Full Payment Received",
//         },
//         {
//             checked: false,
//             label: "Delivered",
//             id: "Delivered",
//             code: "Delivered",
//         },
//         {
//             checked: false,
//             label: "Cancelled",
//             id: "Cancelled",
//             code: "Cancelled",
//         },
//         {
//             checked: false,
//             label: "Refunded",
//             id: "Refunded",
//             code: "Refunded",
//         },
//     ]
    
//     var statusArray = MainStatus;

//     useEffect(()=>{
//         const serviceStatusNameForFilter = [];
//         MainStatus.map((x) => {
//             serviceStatusNameForFilter.push({
//                 label: x.label,
//                 value: x.code,
//                 id: x.id,
//             });
//         });

//         setServiceStatusNameListForFilter(serviceStatusNameForFilter);
//     }, [])

//     const toggleAllForServiceStatusFilter = () => {
//         let temp = [];

//         if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
//             if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
//                 temp = selectedServiceStatusListForFilter;
//             }
//             else {
//                 temp = [{ label: "All", value: "*" }];
//             }

//             let tempSR = serviceStatusNameListForFilter.map((e) => {
//                 if (!temp.includes(e)) {
//                     temp = temp.concat(e);
//                 }
//                 return e;
//             });
//             setSelectedServiceStatusListForFilter(temp);
//             setServiceStatusNameListForFilter(tempSR);
//             //getExternalPartnerServices(tableInstance);
//         }
//         else {
//             setSelectedServiceStatusListForFilter([]);
//             //getExternalPartnerServices(tableInstance);
//         }
//     };

//     const toggleSelectionForServiceStatusFilter = (e) => {
//         setSelectedServiceStatusListForFilter(e);
//     };
    
//     const toggleAllForFilter = () => {
//         let temp = [];

//         // if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
//         //     if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
//         //         temp = selectedServiceNameListForFilter;
//         //     }
//         //     else {
//         //         temp = [{ label: "All", value: "*" }];
//         //     }

//         //     let tempSR = serviceNameListForFilter.map((e) => {
//         //         if (!temp.includes(e)) {
//         //             temp = temp.concat(e);
//         //         }
//         //         return e;
//         //     });
//         //     setSelectedServiceNameListForFilter(temp);
//         //     setServiceNameListForFilter(tempSR);
//         //     //getExternalPartnerServices(tableInstance);
//         // }
//         // else {
//         //     setSelectedServiceNameListForFilter([]);
//         //     //getExternalPartnerServices(tableInstance);
//         // }
//     };

//     const toggleSelectionForFilter = (e) => {
//         // setSelectedServiceNameListForFilter(e);
//     };

//     const handleSearchClick = async () => {
//         if (showFilterModal) {
//             toggleFilterModal();
//         }
//         // setSelectedServiceForEdit();
//         // setSelectedSecondServiceForEdit();
//         // setExpandedChange({});
//         // if(confirmationChecked){
//         //      getFilterDataExternalService(tableInstance, true)
//         // } else {
//             // getExternalPartnerServices(tableInstance, true);
//             getTableData(tableInstance, true)
//         // }
        
//         //refreshTable();
//     };

//     const handleClearFilterSearch = () => {
//         let tempStatus = serviceStatusList?.map((x) => {
//             x.checked = false;
//             return x;
//         });
//         // setSelectedServiceNameListForFilter([]);
//         // setSelectedServiceStatus([]);
//         setServiceStatusList(tempStatus);
//         // setSearchTerm("");
//         // setfromDate("");
//         // settoDate("");
//         // setSelectedRequestedaCallBackOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setSelectedNeedToTalkToSPOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setSelectedRequestedByOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setselectedCallStatusOptionForFilter(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setselectedofflinemeetoptionsForFilter(null);

//         // setSelectedPackageNameListForFilter(null);
//         // // setselectedofflinemeetoptions(null);
//         // //setExpandedChange({});
//         setSelectedServiceStatusListForFilter([]);
//         // setRequestWithinTAT('');
//     };

    
    

//     console.log(selectedServiceStatusListForFilter, ">>>>selectedServiceStatusListForFilter");
    

//     console.log(fromDate, ">>>>fromDate");
//     console.log(toDate, ">>>toDate");
//     console.log(selectedOppTypeWpModal, ">>>>selectedOppTypeWpModal");
//     console.log(selectedOppTitleWpModal, ">>>>selectedOppTitleWpModal");
//   return (
//     <div className={`${isLoading && "set-opacity"}`}>
//             {isLoading && <Spinner className="center-screen" />}

//           <Modal isOpen={revenueModal}>
//               <ModalContent className="general-modal">
//                   <div className="modal-header" style={{
//                       backgroundColor: '#76287C',
//                       color: '#fff'
//                   }}>
//                       <span className="modal-title">Enter Revenue</span>
//                       <img
//                           alt="close"
//                           id="Close"
//                           src={close_modal}
//                           className="close modal-close"
//                           onClick={openRevenueModalisFalse}
//                       />
//                   </div>

//                   <div className="modal-body">
//                       {/* <div className="row">
//                           <div className="col m-2">
//                               <span className="spled-colored-label">Service Price</span> <span className="spled-black-text">: {serviceRequestReadOnlyData.fAmountFirst}</span>
//                           </div>
//                       </div> */}
//                       <div className="row mt-2">
//                           <div className="col-12 w-100">
//                               <input type="number" placeholder="Enter Revenue Generated (for eg: 1000)" style={{
//                                   width: "-webkit-fill-available",
//                                   height: '45px'
//                               }}
//                               min={0}
//                                   onKeyDown={(e) => {
//                                       const invalidChars = ['=', '-', '+', 'e'];
//                                       if (invalidChars.includes(e.key)) {
//                                           e.preventDefault();
//                                       }
//                                   }}
//                                   onChange={(e) => setRevenueAmount(e.target.value)} />
//                           </div>
//                       </div>
//                       <div className="row m-2">
//                           <div className="offset-3 col-6">
//                               <Button 
//                               onClick={onGenerateRevenueClick}
//                               >Update Revenue</Button>
//                           </div>
//                       </div>
//                   </div>
//               </ModalContent>
//           </Modal>

//           <div className="row" style={{
//             //   height: "75px",
//               marginBottom: '15px',
//               boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)"
//           }} >
            
//               <div className='col-12'>
//                 <div className='row'>
//                     <div className="col-2 ml-4 mt-3 conv-pl25 spled-container conv-zindex" style={{backgroundColor:""}}>
//                         <button className="con-btn-filled conv-pl15 conv-pr15 conv-font14" style={{ marginLeft: '15px' }}
//                             onClick={(e) => { handleViewFilterModal() }} 
//                         >
//                             <img
//                                 alt=""
//                                 src={ic_filter}
//                                 height={"15px"}
//                                 width={"15px"}
//                                 className="conv-mr10"
//                             />
//                             Filter By
//                         </button>
//                 </div>
//                 </div>
//               </div>
            
//               <div className="col-12">
//                 <div className="row">
//                 <div className="col-2 ml-5 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       <Select
//                           options={oppTypeNameList}
//                           onChange={onOppTypeChange}
//                           value={selectedOppType}
//                           placeholder="Select Opp Type"
//                           isClearable
//                       />
//                   </div>
//               </div>

//               <div className="col-2 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       {/* <Select
//                           options={oppTitleNameList}
//                             onChange={onOppTitleChange}
//                             value={selectedOppTitle}
//                           placeholder="Select Opp Title"
//                           isClearable
//                       /> */}
//                       <MultiSelectAll
//                                   toggleAll={toggleAllOppTitle}
//                                   toggleSelection={onOppTitleChange}
//                                   checkboxItemsList={oppTitleNameList}
//                                   selectedOptions={selectedOppTitle}
//                                   placeholderButtonLabel="Select Opp Title"
//                               />
//                   </div>
//               </div>

//               <div className="col-2 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={businessSectorList}
//                           placeholder="Select Sector"
//                           onChange={onBusinessSectorChange}
//                           value={selectedBusinessSector}
//                           isClearable
//                       /> */}
//                               <MultiSelectAll
//                                   toggleAll={toggleAllSector}
//                                   toggleSelection={onBusinessSectorChange}
//                                   checkboxItemsList={businessSectorList}
//                                   selectedOptions={selectedBusinessSector}
//                                   placeholderButtonLabel="Select Sector"
//                               />
//                   </div>
//               </div>
//               <div className="col-2 spled-container mt-3 conv-zindex">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={tagsDropDownList}
//                           placeholder="Select Tag"
//                           onChange={onTagChange}
//                           value={selectedTagOption}
//                           isClearable
//                       /> */}
//                           <MultiSelectAll
//                               toggleAll={toggleAllTags}
//                               toggleSelection={onTagChange}
//                               checkboxItemsList={tagsDropDownList}
//                               selectedOptions={selectedTagOption}
//                               placeholderButtonLabel="Select Tags"
//                           />
//                   </div>
//                   <div className="col-2 spled-container mt-3 conv-zindex">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={businessCityList}
//                           placeholder="Select City"
//                           onChange={onBusinessCityChange}
//                           value={selectedBusinessCity}
//                           isClearable
//                       /> */}
//                           <MultiSelectAll
//                               toggleAll={toggleAllBusinessCity}
//                               toggleSelection={onBusinessCityChange}
//                               checkboxItemsList={businessCityList}
//                               selectedOptions={selectedBusinessCity}
//                               placeholderButtonLabel="Select City"
//                           />
//                   </div>

//               {/* <div className="col-2 mt-3 spled-container conv-zindex"> */}
//                   <div className='mt-3 spled-container conv-zindex'>
//                       <Button style={{
//                           margin: 0,
//                           marginLeft: '10px',
//                           height: '37px'
//                       }}
//                           onClick={onSearchClick}
//                           // disabled={!props.selectedExtPartner}
//                           className="con-btn-filled">Search</Button>
//                   </div>
//               {/* </div> */}
//                 </div>
//               </div>


//               {/* <div className="col-3 mt-2 spled-container"  style={{
//                     //   justifyContent: 'flex-end'
//                     marginLeft: '47px'
//                   }}>
//                             <ControlledInput
//                                 className="reportInputUmc"
//                                 name="sContactNumber"
//                                 placeholder="Contact Number"
//                                 value={searchFields.sContactNumber}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 //   onKeyDown={(e) => {
//                                 //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                                 //       if (
//                                 //           !/^\d$/.test(e.key) &&
//                                 //           !allowedKeys.includes(e.key) &&
//                                 //           e.key !== "Tab"
//                                 //       ) {
//                                 //           e.preventDefault();
//                                 //       }
//                                 //   }}
//                                 onKeyDown={(e) => {
//                                     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                                     const ctrlKeys = ["a", "c", "v", "x"];

//                                     if (
//                                         !/^\d$/.test(e.key) && // Allow digits
//                                         !allowedKeys.includes(e.key) && // Allow navigation keys
//                                         !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                                     ) {
//                                         e.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div> */}

              
//                   {/* <div className="col-3 d-flex align-items-center">
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={onDeliverServicesBtnClick}
//                                   className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Deliver Services</button>
//                               :
//                               <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Deliver Services</button>

//                       }
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={() => setShowCancellationReasonModal(true)}
//                                   className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Cancel Services</button>
//                               :
//                               <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Cancel Services</button>

//                       }
//                   </div> */}

//                   {/* Added Confirmation Received */}
//                  {/* <div className="col-4 d-flex mt-3">
//                             <div className="">
//                                 <Checkbox
//                                     id={`checkbox3-completed`}
//                                     checked={confirmationChecked}
//                                     onChange={(e) => {
//                                         e.stopPropagation();
//                                         setConfirmationChecked(!confirmationChecked)
//                                         // updateConfirmationFlagData(row.original)
//                                         // props.getExternalPartnerServices()
//                                     }}
//                                     label={"Confirmation Received"}
//                                 // disabled={row.original.bConfirmation_tag}
//                                 ></Checkbox>
//                             </div>
//                     </div> */}

//               <div className="col-2 mt-2 spled-container" style={{
//                   // justifyContent: 'flex-end'
//                   marginLeft: '33px',
//                   display: "flex",
//                   // alignItems:"center"
//                   justifyContent: "space-between",
//                   backgroundColor:""
//               }}>
//                   {/* Added Confirmation Received */}
//                   <div className="col-5 d-flex" style={{backgroundColor:""}}>
//                       <div className="">
//                           <Checkbox
//                               id={`checkbox3-completed`}
//                               checked={confirmationChecked}
//                               onChange={(e) => {
//                                   e.stopPropagation();
//                                   setConfirmationChecked(!confirmationChecked)
//                                   // updateConfirmationFlagData(row.original)
//                                   // props.getExternalPartnerServices()
//                               }}
//                               label={"Confirmation Received"}
//                           // disabled={row.original.bConfirmation_tag}
//                           ></Checkbox>
//                       </div>
//                   </div>
//               </div>

//               {/* <div className="col-8 d-flex align-items-center pl-4 ml-1">

//                   <div className='mt-2' style={{ display: "flex" }}>
//                       <ControlledInput
//                           className="reportInputUmc"
//                           name="sContactNumber"
//                           placeholder="Contact Number"
//                           value={searchFields.sContactNumber}
//                           onChange={({ target: { name, value } }) => handleChange(name, value)}
//                           // onKeyDown={(e) => {
//                           //     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                           //     if (
//                           //         !/^\d$/.test(e.key) &&
//                           //         !allowedKeys.includes(e.key) &&
//                           //         e.key !== "Tab"
//                           //     ) {
//                           //         e.preventDefault();
//                           //     }
//                           // }}
//                           onKeyDown={(e) => {
//                               const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                               const ctrlKeys = ["a", "c", "v", "x"];

//                               if (
//                                   !/^\d$/.test(e.key) && // Allow digits
//                                   !allowedKeys.includes(e.key) && // Allow navigation keys
//                                   !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                               ) {
//                                   e.preventDefault();
//                               }
//                           }}
//                           autoComplete="off"
//                       />
//                   </div>
//                   {
//                       selectedServices.length > 0 ?
//                           <button
//                               onClick={onDeliverServicesBtnClick}
//                               className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Deliver Services</button>
//                           :
//                           <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Deliver Services</button>

//                   }
//                   {
//                       selectedServices.length > 0 ?
//                           <button
//                               onClick={() => setShowCancellationReasonModal(true)}
//                               className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Cancel Services</button>
//                           :
//                           <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Cancel Services</button>

//                   }
//               </div> */}

//                <div className="col-2 mt-2 spled-container"  style={{
//                     //   justifyContent: 'flex-end'
//                     marginLeft: '15px',
//                     backgroundColor:""
//                   }}>
//                             <ControlledInput
//                                 className="reportInputUmc"
//                                 name="sContactNumber"
//                                 placeholder="Contact Number"
//                                 value={searchFields.sContactNumber}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 //   onKeyDown={(e) => {
//                                 //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                                 //       if (
//                                 //           !/^\d$/.test(e.key) &&
//                                 //           !allowedKeys.includes(e.key) &&
//                                 //           e.key !== "Tab"
//                                 //       ) {
//                                 //           e.preventDefault();
//                                 //       }
//                                 //   }}
//                                 onKeyDown={(e) => {
//                                     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                                     const ctrlKeys = ["a", "c", "v", "x"];

//                                     if (
//                                         !/^\d$/.test(e.key) && // Allow digits
//                                         !allowedKeys.includes(e.key) && // Allow navigation keys
//                                         !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                                     ) {
//                                         e.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div>

//                 {/* <div className="col-6 d-flex align-items-center" style={{backgroundColor:"red", margin:"0px", padding:"0px",justifyContent:"space-between", paddingLeft:"9px", paddingRight:"13px"}}>
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={onDeliverServicesBtnClick}
//                                   className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Deliver Services</button>
//                               :
//                               <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Deliver Services</button>

//                       }
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={() => setShowCancellationReasonModal(true)}
//                                   className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Cancel Services</button>
//                               :
//                               <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Cancel Services</button>

//                       }


//                     {
//                         selectedServices.length > 0 ?
//                             <button
//                                 onClick={() => handleSendCancellationMessage()}
//                                 className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                     marginBottom: "15px"
//                                 }}>
//                                 Send Cancellation Messge</button>
//                             :
//                             <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                 marginBottom: "15px",
//                                 opacity: "0.4",
//                                 pointerEvents: "none",
//                             }}>
//                                 Send Cancellation Message</button>
//                     }
//                     {
//                         <button
//                         onClick={() => toggleShowWhatsappMessagesModal()}
//                         className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                             marginBottom: "15px"
//                         }}>
//                             View Messages
//                         </button>
//                     }
//                 </div> */}

//                 <div
//                 className="col-6 d-flex align-items-center"
//                 style={{
//                     backgroundColor: "",
//                     margin: "0px",
//                     padding: "0px",
//                     justifyContent: "space-between",
//                     paddingLeft: "7px",
//                     paddingRight: "15px"
//                 }}
//                 >
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={onDeliverServicesBtnClick}
//                         className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Deliver Services
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Deliver Services
//                     </button>
//                     )
//                 }
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={() => setShowCancellationReasonModal(true)}
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Cancel Services
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Cancel Services
//                     </button>
//                     )
//                 }
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={() => handleSendCancellationMessage()}
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Send Cancellation Message
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Send Cancellation Message
//                     </button>
//                     )
//                 }
//                 {
//                     <button
//                     onClick={() => toggleShowWhatsappMessagesModal()}
//                     className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                     style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                     }}
//                     >
//                     View Messages
//                     </button>
//                 }
//                 </div>


//               {/* <div className='col-2 mt-2 spled-container conv-zindex'>
//                   <Button style={{
//                       margin: 0,
//                       marginLeft: '6px',
//                       height: '37px',
//                       display: 'none',
//                       width: 100
//                   }}
//                       onClick={onClearClick}
//                       // disabled={!props.selectedExtPartner}
//                       className="con-btn-filled">Clear</Button>
//               </div> */}


//                   <div className='mt-2 spled-container conv-zindex' style={{backgroundColor:""}}>
//                       <Button style={{
//                           margin: 0,
//                           marginLeft: '10px',
//                           height: '37px',
//                           width: 100
//                       }}
//                           onClick={onClearClick}
//                           // disabled={!props.selectedExtPartner}
//                           className="con-btn-filled">Clear</Button>
//                   </div>

                  

              
              
//               {/* <div className="col-2 d-flex align-items-center" style={{
//                   justifyContent: 'flex-end'
//               }} >
//                   {
//                       selectedServiceRequests.length > 0 ?
//                           <Button
//                               onClick={openPaymentModalisTrue}
//                               className="esp-inline-button ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Settle Payment</Button>
//                           :
//                           <Button className="esp-inline-button ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Settle Payment</Button>

//                   }
//               </div> */}
//           </div>

//           <ESPUmcReactTable 
//             data={tableData}
//             displayRecordCount={displayRecordCount}
//             handleCatalogueClick={handleCatalogueClick}
//             onEnterRevenueClick={onEnterRevenueClick}
//             handleCheckboxChange={handleCheckboxChange}
//             isSelected={isSelected}
//             selectedServices={selectedServices}
//             handleSelectAll={handleSelectAll}
//             openRevenueModalisTrue={openRevenueModalisTrue}
//             onFetchServiceRequests={fetchServiceRequests}
//             pages={pages}
//             pageSize={pageSize}
//             page={currentPage}
//             pageSizeOptions={pageSizeOptions}
//             selectedPageSizeOption={selectedPageSizeOption}
//             onPageSizeOptionChange={(option) => {
//                 setSelectedPageSizeOption(option);
//             }}
//           />

//           {
//               showCancellationReasonModal &&
//               <CancellationReasonModal
//                   isDisabled={enableCancelButtonFlag}
//                   isOpen={showCancellationReasonModal}
//                   toggleModal={toggleCancellationReasonModal}
//                   cancellationReasonDropdownOptions={
//                       cancellationReasonDropdownOptions
//                   }
//                   onSelectCancellationReason={setSelectedCancellationReason}
//                   selectedCancellationReason={selectedCancellationReason}
//                   enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
//                   cancellationReasonOtherDescription={
//                       cancellationReasonOtherDescription
//                   }
//                   onChangeCancellationReasonOtherDescription={(value) => {
//                       setCancellationReasonOtherDescription(value);
//                   }}
//                   onChangeState={handleChangeState}
//               />
//           }

//           {/* View Whatsapp Messages Model */}
//           <ViewWhatsappMessagesModal
//             data = {sentWhatsappCancellationMessages}
//             isOpen = {showWhatsappMessagesModal}
//             toggleModal = {toggleShowWhatsappMessagesModal}
//             page={wpMessagecurrentPage}
//             pages={wpMessagepages}
//             pageSize = {wpMessagePageSize}

//             // BELOW IS DATA FOR FILTER
//             oppTypeNameListWpModal={oppTypeNameListWpModal}
//             onOppTypeChange={onOppTypeChange}
//             selectedOppType={selectedOppTypeWpModal}

//             toggleAllOppTitle={toggleAllOppTitle}
//             onOppTitleChange={onOppTitleChange}
//             oppTitleNameListWpModal={oppTitleNameListWpModal}
//             selectedOppTitleWpModal={selectedOppTitleWpModal}

//             // setFromDate = {setFromDate}
//             handleFromDate={handleFromDate}
//             // setToDate={setToDate}
//             handleToDate={handleToDate}
//             fromDate={fromDate}
//             toDate={toDate}

//             searchFilterWpSendCacellationMessages={searchFilterWpSendCacellationMessages}
//             wpCancellationMessageIsLoading={wpCancellationMessageIsLoading}

//             clearSearchFilterWpCancellationMessages={clearSearchFilterWpCancellationMessages}
//           />

// {
// 				showFilterModal &&
// 				(
// 					<ESPUmcLedFilterModel
// 						isOpen={showFilterModal}
// 						toggleModal={toggleFilterModal}
// 						toggleAllForFilter={toggleAllForFilter}
// 						toggleSelectionForFilter={toggleSelectionForFilter}
// 						serviceNameListForFilter={serviceNameListForFilter}

// 						// selectedServiceNameListForFilter={props.selectedServiceNameListForFilter}
// 						// fromDate={props.fromDate}
// 						// setfromDate={props.setfromDate}
// 						// toDate={props.toDate}
// 						// settoDate={props.settoDate}
// 						// requestedByOptions={props.requestedByOptions}
// 						// setSelectedRequestedByOption={props.setSelectedRequestedByOption}
// 						// selectedRequestedByOption={props.selectedRequestedByOption}
// 						// packageNameListForFilter={props.packageNameListForFilter}
// 						// oppTypeNameListforFilter={props.oppTypeNameListforFilter}
// 						// setSelectedPackageNameListForFilter={props.setSelectedPackageNameListForFilter}
// 						// selectedPackageNameListForFilter={props.selectedPackageNameListForFilter}
// 						// requestedaCallBackOptions={props.requestedaCallBackOptions}
// 						// setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
// 						// selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
// 						// toggleServiceStatus={props.toggleServiceStatus}
// 						// serviceStatusList={props.serviceStatusList}
// 						// callStatusOptionsForFilter={props.callStatusOptionsForFilter}
// 						// setselectedCallStatusOptionForFilter={props.setselectedCallStatusOptionForFilter}
// 						// selectedCallStatusOptionForFilter={props.selectedCallStatusOptionForFilter}
// 						// setSelectedRequestedaCallBackOption={props.setSelectedRequestedaCallBackOption}
// 						// selectedRequestedaCallBackOption={props.selectedRequestedaCallBackOption}

// 						onSearchClicked={handleSearchClick}
// 						onClearFilterSearch={handleClearFilterSearch}
// 						toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
// 						toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
// 						selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
// 						serviceStatusNameListForFilter={serviceStatusNameListForFilter}

// 						// //offline meet
// 						// offlinemeetoptionsForFilter={props.offlinemeetoptionsForFilter}
// 						// setselectedofflinemeetoptionsForFilter={props.setselectedofflinemeetoptionsForFilter}
// 						// selectedofflinemeetoptionsForFilter={props.selectedofflinemeetoptionsForFilter}



// 						// offlinemeetoptions={props.offlinemeetoptions}
// 						// selectedofflinemeetoptions={props.selectedofflinemeetoptions}
// 						// setselectedofflinemeetoptions={props.setselectedofflinemeetoptions}




// 						// //for admin
// 						// externalServicePartnerOptions={props.externalServicePartnerOptions}
// 						// selectedExternalServicePartner={props.selectedExternalServicePartner}
// 						// onExternalServicePartnerChange={props.onExternalServicePartnerChange}
// 						// ExternalServicePartnerOrganization={props.ExternalServicePartnerOrganization}
// 						// isForAdmin={props.isForAdmin}
// 					>
// 					</ESPUmcLedFilterModel>
// 				)
// 			}
                
//     </div>
//   )
// }

// export default ESPUmcInterface


// ///////////////////////////////////////////////////////
// // Rakesh Ka With Confrmation Received
// ///////////////////////////////////////////////////////
// import React, { useEffect, useState } from 'react'
// import Select from "react-select";
// import api from '../../utils/api';
// import { Button } from '../../common/Button/Button';
// import ESPUmcReactTable from './ESPUmcReactTable';
// import ModalContent from '../../common/Modal/ModalContent';
// import close_modal from '../../assets/ic_close_wh.svg'
// import Modal from "react-modal";
// import Spinner from '../../common/Spinner/Spinner';
// import { toast } from 'react-toastify';
// import CancellationReasonModal from '../../components/ServiceRequests/Handholder/CancellationReasonModal';
// import MultiSelectAll from '../../common/Multiselect/MultiSelectAll';
// import { ControlledInput } from '../../common/Input/Input';
// import Checkbox from '../../common/Checkbox/Checkbox';

// import ViewWhatsappMessagesModal from '../../components/ServiceRequests/Handholder/ViewWhatsappMessagesModal';

// import ic_filter from "../../assets/ic_filter.svg";

// import ESPUmcLedFilterModel from '../../components/EServicePartnerServiceRequests/ESPUmcLedFilterModel';

// const ESPUmcInterface = () => {

//     const [revenueModal, setRevenueModal] = useState(false)
//     const [revenueAmount, setRevenueAmount] = useState('')

//     const [resourceId, setResourceId] = useState(0)
//     const [serviceDisplay, setServiceDisplay] = useState("")

//     const [tableData, setTableData] = useState([])
//     const [isClearAction, setIsClearAction] = useState(false);

//     const [oppTypeNameList, setOppTypeNameList] = useState()
//     const [selectedOppType, setSelectedOppType] = useState(null)

//     const [oppTitleNameList, setOppTitleNameList] = useState([])
//     const [selectedOppTitle, setSelectedOppTitle] = useState([])

//     const [businessSectorList, setBusinessSectorList] = useState([])
//     const [selectedBusinessSector, setSelectedBusinessSector] = useState([])

//     const [displayRecordCount, setDisplayRecordCount] = useState({displayCount: true, count: 0})

//     const [searchFields, setSearchFields] = useState({
//         sContactNumber: ""
//     })

//     const [confirmationChecked, setConfirmationChecked] = useState(false)

//     useEffect(() => {
//         if (isClearAction) {
//             // Call umcCustomersData only after state updates have been completed
//             getTableData(tableInstance, true);
            
//             // Reset the clear action flag
//             setIsClearAction(false);
//         }
//     }, [
//         isClearAction // This ensures the function is called after clearing
//     ]);

//     const handleChange = (name, value) => {
//         const updated = { ...searchFields, [name]: value };
//         setSearchFields(updated)
//     }

//     const onBusinessSectorChange = (options) => {
//         // setSelectedBusinessSector(option)
//         // getTagsDropdown(option)

//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedBusinessSector([{ value: "*", label: "All" }]);
//             getTagsDropdown(processFilters(options))
//         } else {
//             setSelectedBusinessSector(options.filter((opt) => opt.value !== "*"));
//             getTagsDropdown(processFilters(options))
//         }
//     }

//     const toggleAllSector = () => {
//         if (selectedBusinessSector.length != businessSectorList.length && selectedBusinessSector.length != (businessSectorList.length + 1)) {
//           let temp = []
    
//           if (selectedBusinessSector.includes({ label: "All", value: "*" })) {
//             temp = selectedBusinessSector
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = businessSectorList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setBusinessSectorList(tempSR)
//           setSelectedBusinessSector(temp)
//           getTagsDropdown(processFilters(temp))
//         } else {
//           setSelectedBusinessSector([])
//           getTagsDropdown(null)
//         }
    
//       }

//     const [businessCityList, setBusinessCityList] = useState([])
//     const [selectedBusinessCity, setSelectedBusinessCity] = useState([])

//     const onBusinessCityChange = (options) => {
//         // setSelectedBusinessCity(option)
        
//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedBusinessCity([{ value: "*", label: "All" }]);
//         } else {
//             setSelectedBusinessCity(options.filter((opt) => opt.value !== "*"));
//         }
//     }

//     const toggleAllBusinessCity = () => {
//         if (selectedBusinessCity.length != businessCityList.length && selectedBusinessCity.length != (businessCityList.length + 1)) {
//           let temp = []
    
//           if (selectedBusinessCity.includes({ label: "All", value: "*" })) {
//             temp = selectedBusinessCity
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = businessCityList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setBusinessCityList(tempSR)
//           setSelectedBusinessCity(temp)
//         } else {
//           setSelectedBusinessCity([])
//         }
    
//       }

//     const [tagsDropDownList, setTagsDropdownList] = useState([])
//     const [selectedTagOption, setSelectedTagOption] = useState([])

//     const getTagsDropdown = (e) => {
//         if (e !== null) {
//             api.tagsListApi(e)
//                 .then(({ data }) => {
//                     if (data.data.length > 0) {
//                         // Flatten all sTag arrays into a single array
//                         const allTags = data.data.flatMap(sector => sector.sTag);
    
//                         // Remove duplicates
//                         const uniqueTags = [...new Set(allTags)];
    
//                         // Format the tags for the dropdown
//                         const formattedData = uniqueTags.map(tag => ({
//                             value: tag,
//                             label: tag
//                         }));
    
//                         setTagsDropdownList(formattedData);
//                         console.log("Drop list", formattedData);
//                     } else {
//                         setTagsDropdownList([]);
//                     }
//                 })
//                 .catch(error => {
//                     console.error("API error:", error);
//                     setTagsDropdownList([]);
//                 });
//         } else {
//             setTagsDropdownList([]);
//             setSelectedTagOption([]);
//         }
//     };

//     const onTagChange = (options) => {
//         // setSelectedTagOption(option)

//         const isAllSelected = options.some((opt) => opt.value === "*");
//         if (isAllSelected) {
//             setSelectedTagOption([{ value: "*", label: "All" }]);
//         } else {
//             setSelectedTagOption(options.filter((opt) => opt.value !== "*"));
//         }
//     }

//     const toggleAllTags = () => {
//         if (selectedTagOption.length != tagsDropDownList.length && selectedTagOption.length != (tagsDropDownList.length + 1)) {
//           let temp = []
    
//           if (selectedTagOption.includes({ label: "All", value: "*" })) {
//             temp = selectedTagOption
//           } else {
//             temp = [{ label: "All", value: '*' }]
//           }
    
//           let tempSR = tagsDropDownList.map((e) => {
//             if (!temp.includes(e)) {
//               temp = temp.concat(e)
//             }
//             return e
//           })
//           setTagsDropdownList(tempSR)
//           setSelectedTagOption(temp)
//         } else {
//           setSelectedTagOption([])
//         }
    
//       }

//     const [pages, setPages] = useState(0);
//     const [pageSize, setPageSize] = useState(10);
//     const [currentPage, setcurrentPage] = useState(0);
//     const [tableInstance, setTableInstance] = useState(null);
//     const [count, setCount] = useState(0);
//     const [isLoading, setIsLoading] = useState(false);
//     const [isFilterTrue, setIsFilterTrue] = useState(false)
//     const [pageSizeOptions, setpageSizeOptions] = useState([
//         {
//             value: "10",
//             label: "10 Rows",
//         },
//         {
//             value: "20",
//             label: "20 Rows",
//         },
//         {
//             value: "30",
//             label: "30 Rows",
//         },
//         {
//             value: "50",
//             label: "50 Rows",
//         },
//         {
//             value: "75",
//             label: "75 Rows",
//         },
//         {
//             value: "100",
//             label: "100 Rows",
//         },
//     ]);
//     const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
//         value: "10",
//         label: "10",
//     });
//     const [selectedServices, setSelectedServices] = useState([]);

//     /**CancellationReason */

// 	const [showCancellationReasonModal, setShowCancellationReasonModal,] = useState(false);
//     const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState();
// 	const [selectedCancellationReason, setSelectedCancellationReason,] = useState();
// 	const [enableOtherDescriptionTextbox, setEnableOtherDescriptionTextbox,] = useState(false);
// 	const [cancellationReasonOtherDescription, setCancellationReasonOtherDescription,] = useState();
// 	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");

// 	const toggleCancellationReasonModal = () => {
//         setSelectedCancellationReason()
//         setCancellationReasonOtherDescription()
// 		setShowCancellationReasonModal(!showCancellationReasonModal);
// 	};

//     // const enableCancelButton = () => {
//     //     if(selectedCancellationReason){
//     //         setEnableCancelButtonFlag("")
//     //     }
//     // }

//     const enableCancelButton = () => {
// 		if (selectedCancellationReason) {
// 			if (selectedCancellationReason.value === "Other") {
// 				if (
// 					cancellationReasonOtherDescription &&
// 					cancellationReasonOtherDescription.length > 0
// 				) {
// 					setEnableCancelButtonFlag("");
// 				} else setEnableCancelButtonFlag("disable");
// 			} else setEnableCancelButtonFlag("");
// 		} else setEnableCancelButtonFlag("disable");
// 	};

//     useEffect(() => {
//         enableCancelButton()
//     }, [selectedCancellationReason, cancellationReasonOtherDescription])

//     const handleCheckboxChange = (serviceInstanceId) => {
//         console.log(serviceInstanceId, ">>>>ServiceInstanceId");
        
//         const currentIndex = selectedServices.indexOf(serviceInstanceId);
//         const newSelectedServices = [...selectedServices];

//         if (currentIndex === -1) {
//             newSelectedServices.push(serviceInstanceId);
//         } else {
//             newSelectedServices.splice(currentIndex, 1);
//         }

//         setSelectedServices(newSelectedServices);
//         console.log("Selected Service", newSelectedServices)
//     };

//     const isSelected = (serviceInstanceId) => selectedServices.includes(serviceInstanceId);

//     const handleSelectAll = () => {
//         const selectableServices = tableData.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled');
//         const selectableServiceIds = selectableServices.map(service => service.nResourceInstanceId);
    
//         if (selectedServices.length === selectableServiceIds.length) {
//             // Deselect all services
//             setSelectedServices([]);
//         } else {
//             // Select all services
//             setSelectedServices(selectableServiceIds);
//         }
//         console.log("Serv", selectableServiceIds)
//     };

//     const onDeliverServicesBtnClick = async() => {
//             let payload = {
//                 nResourceInstanceId: selectedServices,
//                 refCurrentState: 'Delivered'
//             }
//             setIsLoading(true)
//             const {deliverBulkServices} = api.deliverBulkServiceData(payload)
//             .then(({data}) => {
//                 if(data){
//                     console.log("Data", data.Message)
//                     setIsLoading(false)
//                     toast(String(data.Message), {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     });
//                     getTableData(tableInstance, false)
//                     setSelectedServices([])
//                 }
//             }) .catch((error) => {
//                 setIsLoading(false);
//                 if (error.response.data.error) {
//                     toast(String("Services cannot be delivered as some services are still in LPM."), {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//                 else if (error.response.data.message) {
//                     toast(String(error.response.data.message), {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//                 else {
//                     toast("Internal server error", {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//                 }
//             })
//     }

//     const getTableData = async (instance, flag = false) => {
//         if (!instance) return;
//         if (!tableInstance) setTableInstance(instance);

//         try {
//             const { page } = instance.state ?? { page: 0 };
//             let icurrentPage = page;
//             if (!flag && isNaN(icurrentPage)) return;
//             const pageSize = selectedPageSizeOption.value;

//             if (flag || isNaN(icurrentPage)) {
//                 icurrentPage = 0;
//             }

//             let servicestatusListtemp2 = [];
//         selectedServiceStatusListForFilter.map((e) => {
//             if (e.value != "*") {
//                 servicestatusListtemp2.push(e.value);
//             }
//         });
//         const serviceStatusList = servicestatusListtemp2;

//         let serviceStatusFilter = [];
//         serviceStatusList.map((e) => {
//             if (e === "Willing to Pay") {
//                 serviceStatusFilter.push("Ready For Progression:Partner");
//                 serviceStatusFilter.push("Partial/ Full Payment Pending");
//             }
//             else if (e === "Payment Received") {
//                 serviceStatusFilter.push("Payment Confirmed By Partner");
//                 serviceStatusFilter.push("Ready For Progression:deAsra");
//             }
//             else {
//                 serviceStatusFilter.push(e);
//             }
//         });
//         const statusList = serviceStatusFilter;

//             let ResourceNamesTemp = []
//             selectedOppTitle.map((e) => {
//                 if(e.value != "*"){
//                     ResourceNamesTemp.push(e.value)
//                 }
//             })


//             let filterParameters = {
//                 page_no: icurrentPage + 1,
//                 page_size: pageSize,
//                 // pagination: true,
//                 // SP_email: 'archana.sapre@mailinator.com'
//             };

//             if(selectedOppType){
//                 filterParameters.service_codes = [selectedOppType.value]
//             }
    
//             if(selectedOppTitle){
//                 filterParameters.ResourceName = ResourceNamesTemp
//             }

//             // if (selectedOppTitle.length > 0) {
//             //     filterParameters.sServiceDisplayName = processFilters(selectedOppTitle) 
//             // }

//             if(confirmationChecked){
//                 filterParameters.bConfirmation_tag = confirmationChecked
//             }
            
//             if (statusList.length) {
//                 filterParameters.statusList = statusList;
//             }

//             if(selectedBusinessSector.length > 0){
//                 filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
//             }

//             if(selectedBusinessCity.length > 0){
//                 filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
//             }

//             if(selectedTagOption.length > 0){
//                 filterParameters.sTag = processFilters(selectedTagOption)
//             }

//             if (searchFields.sContactNumber !== "") {
//                 filterParameters.search_value = searchFields.sContactNumber
//             }

//             if (currentPage != icurrentPage) {
//                 setSelectedServices([]);
//             }

//             setIsLoading(true);
//             const { tempServices } = api.getExternalPartnerUmcServices(filterParameters).then(({ data }) => {
//                 setIsLoading(false);
//                 if (data) {
//                     // const { results, count } = data;
//                     setcurrentPage(icurrentPage);
//                     setPages(data.total_pages);
//                     setPageSize(pageSize);
//                     setDisplayRecordCount({...displayRecordCount, count: data?.total_count})


//                     let tempLPMServiceList = data.ServiceRequests.map((x) => {
//                         x.custrefSRState = x.refSRState;
//                         x.custsSRCancellationReason = x.sSRCancellationReason;
//                         x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
//                         x.custsNotesHH = null;
//                         x.custdtFollowupOn = null;
//                         x.custsFollowupNotes = null;
//                         x.serviceFrom = "LPM";
//                         x.custOtherServiceInfo = x.sOtherServicesInfo;
//                         x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
//                         x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
//                         x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
//                         x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
//                         x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
//                         x.custsCallStatus = x.sCallStatus;
//                         x.custsUpdateNoteForAllServicesInPackage = false;
//                         x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
//                         x.custbOfflineMeet = x.bOfflineMeet;
//                         return x;
//                     });
    
//                     let tempSPMerviceList = data.Services.map((x) => {
//                         x.custrefSRState = x.refCurrentState.sServiceState;
//                         x.custsSRCancellationReason = x.sServiceCancellationReason;
//                         x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
//                         x.custsNotesHH = null;
//                         x.custdtFollowupOn = null;
//                         x.custsFollowupNotes = null;
//                         x.serviceFrom = "SPM";
//                         x.OtherServiceInfo = null;
//                         x.custOtherServiceInfo = x.sOtherServicesInfo;
//                         x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
//                         x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
//                         x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
//                         x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
//                         x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
//                         x.custsCallStatus = x.sCallStatus;
//                         x.custsUpdateNoteForAllServicesInPackage = false;
//                         x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
//                         x.custbOfflineMeet = x.bOfflineMeet;
//                         return x;
//                     });

//                     var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
//                     let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
//                         return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
//                     })

//                     console.log("New Data", sortedServiceRequestsDesc)
//                     setTableData(sortedServiceRequestsDesc)
//                 }
//                 else {
//                     // toast("Something went wrong. Please contact Deasra Representative.", {
//                     //     autoClose: 5000,
//                     //     type: toast.TYPE.ERROR,
//                     // });
//                 }
//             })
//         } catch (error) {
//             setIsLoading(false);
//             console.log(error)
//             // toast("Internal Server Error", {
//             //     autoClose: 5000,
//             //     type: toast.TYPE.ERROR,
//             // });
//         }

//     }

//     const onSearchClick = () => {
//         getTableData(tableInstance, true)
//     }

//     const onClearClick = () => {
//         setSelectedOppType(null)
//         setSelectedOppTitle([])
//         setSelectedBusinessSector([])
//         setSelectedBusinessCity([])
//         setSelectedTagOption([])
//         setSearchFields({
//             sContactNumber: ""
//         })
//         setConfirmationChecked(false)
//         setIsClearAction(true);
//     }

//     const onEnterRevenueClick = (ele) => {
//         openRevenueModalisTrue()
//         setResourceId(ele.nResourceInstanceId)
//         setServiceDisplay(ele.sServiceDisplayName)
//     }

//     const onGenerateRevenueClick = () => {
//         if(revenueAmount === "0") {
//             toast("Revenue cannot be zero", {
//                         autoClose: 5000,
//                         type: toast.TYPE.ERROR,
//                     });
//         } else {
//             setIsLoading(true)
//             openRevenueModalisFalse()
//             let payload = {
//                 nResourceInstanceId: resourceId,
//                 sServiceDisplayName: serviceDisplay,
//                 nRevenue: revenueAmount
//             }
    
//             const {tempAddRevenueUmc} = api.addRevenueUmc(payload)
//             .then(({data}) => {
//                 setIsLoading(false)
//                 toast("Revenue Updated Successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 console.log(data)
//                 setRevenueAmount('')
//                 getTableData(tableInstance, false)
//             })
//         }
        
//     }

//     useEffect(() => {
//         getTableData(tableInstance, true)
//     }, [selectedPageSizeOption])

//     useEffect(() => {
//         const { temp } = api.getCancellationReasons().then(({ data }) => {
// 			console.log("cancellationRason", data);
// 			let temp1 = data.map((e) => {
// 				return { value: e.sReason, label: e.sReason };
// 			});
// 			setCancellationReasonDropdownOptions(temp1);
// 		});
//     }, [])

//     const fetchServiceRequests = (instance, flag) => {
//         getTableData(instance, flag);
//     };
    

//     const onOppTypeChange = (option) => {
//         // setSelectedOppTitle(null)
//         if(showWhatsappMessagesModal){
//             setSelectedOppTypeWpModal(option)
//         } else{
//             setSelectedOppType(option)
//         }
//         getOppTitleNames(option)
//     }

//     // const onOppTitleChange = (option) => {
//     //     setSelectedOppTitle(option)
//     // }

//     const openRevenueModalisTrue = () => {
//         setRevenueModal(true)
//     }

//     const openRevenueModalisFalse = () => {
//         setRevenueModal(false)
//     }

//     useEffect(() => {
//         const { tempOppTypeServiceNames } = api.oppTypeListApi()
//         .then(({data}) => {
//             const formattedData = data.results.map((ele) => ({
//                 value: ele.sServiceCode,
//                 label: ele.sServiceName
//             }))
//             setOppTypeNameList(formattedData);
//             setOppTypeNameListWpModal(formattedData);
//         })

//         const { tempBusinessSectorListApi } = api.businessSectorListApi()
//             .then(({ data }) => {
//                 console.log("Business Sector", data)
//                 const formattedData = data.data
//                 .filter(ele => ele.sBusinessSector !== null)
//                 .map((ele) => ({
//                     value: ele.sBusinessSector,
//                     label: ele.sBusinessSector
//                 }))
//                 setBusinessSectorList(formattedData)
//             })

//             const { tempBusinessCityListApi } = api.businessCityListApi()
//             .then(({data}) => {
//                 const formatttedData = data.data
//                 .map((ele) => ({
//                     value: ele.sBusinessCity,
//                     label: ele.sBusinessCity
//                 }))
//                 setBusinessCityList(formatttedData)
//             })
//     }, [])

//     const getOppTitleNames = (ele) => {
//         // let filterParameters = {}

//         // if(selectedOppType !== null) {
//         //     filterParameters.OpportunityType = selectedOppType.value
//         // }
//         if(showWhatsappMessagesModal){
//             if(ele) {
//                 const { tempOppTitleNames } = api.oppTitleListApi({
//                     OpportunityType: ele.value
//                 })
//                 .then(({data}) => {
//                     const formattedData = data.results.map((ele) => ({
//                         value: ele.ResourceName,
//                         label: ele.ResourceName
//                     }))
//                     setOppTitleNameListWpModal(formattedData)
//                 })
//             } else {
//                 setOppTitleNameListWpModal([]);
//                 setSelectedOppTitleWpModal([]);
//             }
//         } else {
//             if(ele) {
//                 const { tempOppTitleNames } = api.oppTitleListApi({
//                     OpportunityType: ele.value
//                 })
//                 .then(({data}) => {
//                     const formattedData = data.results.map((ele) => ({
//                         value: ele.ResourceName,
//                         label: ele.ResourceName
//                     }))
//                     setOppTitleNameList(formattedData)
//                 })
//             } else {
//                 setOppTitleNameList([])
//                 setSelectedOppTitle([])
//             }
//         }
//     }

//     const toggleAllOppTitle = () => {
//         console.log(">>>toggle all opp titlw got clicekd");

//         if(showWhatsappMessagesModal){
//             if (selectedOppTitleWpModal?.length != oppTitleNameListWpModal?.length && selectedOppTitleWpModal?.length != (oppTitleNameListWpModal?.length + 1)) {
//                 let temp = []
          
//                 if (selectedOppTitleWpModal?.includes({ label: "All", value: "*" })) {
//                   temp = selectedOppTitleWpModal
//                 } else {
//                   temp = [{ label: "All", value: '*' }]
//                 }
          
//                 let tempSR = oppTitleNameListWpModal.map((e) => {
//                   if (!temp.includes(e)) {
//                     temp = temp.concat(e)
//                   }
//                   return e
//                 })
//                 setOppTitleNameListWpModal(tempSR);
//                 setSelectedOppTitleWpModal(temp)
//               //   getTagsDropdown(processFilters(temp))
//             } else {
//             setSelectedOppTitleWpModal([])
//             //   getTagsDropdown(null)
//             }
//         } else{
//             if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
//                 let temp = []
          
//                 if (selectedOppTitle.includes({ label: "All", value: "*" })) {
//                   temp = selectedOppTitle
//                 } else {
//                   temp = [{ label: "All", value: '*' }]
//                 }
          
//                 let tempSR = oppTitleNameList.map((e) => {
//                   if (!temp.includes(e)) {
//                     temp = temp.concat(e)
//                   }
//                   return e
//                 })
//                 setOppTitleNameList(tempSR)
//                 setSelectedOppTitle(temp)
//               //   getTagsDropdown(processFilters(temp))
//             } else {
//             setSelectedOppTitle([])
//             //   getTagsDropdown(null)
//             }
//         }
//     }

//     const onOppTitleChange = (options) => {
//         if(showWhatsappMessagesModal){
//             const isAllSelected = options.some((opt) => opt.value === "*");

//             if (isAllSelected) {
//                 setSelectedOppTitleWpModal([{ value: "*", label: "All" }]);
//                 // getTagsDropdown(processFilters(options))
//             } else {
//                 setSelectedOppTitleWpModal(options.filter((opt) => opt.value !== "*"));
//                 // getTagsDropdown(processFilters(options))
//             }
//         } else {
//             const isAllSelected = options.some((opt) => opt.value === "*");
//             if (isAllSelected) {
//                 setSelectedOppTitle([{ value: "*", label: "All" }]);
//                 // getTagsDropdown(processFilters(options))
//             } else {
//                 setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
//                 // getTagsDropdown(processFilters(options))
//             }
//         }
//     }

//     const handleChangeState = () => {
//         let cancellation_Reason, OtherDescription;
//         if(selectedCancellationReason) {
//             cancellation_Reason = selectedCancellationReason.value;
// 				if (cancellation_Reason !== "Other") OtherDescription = null;
// 				else OtherDescription = cancellationReasonOtherDescription;
//         }
//         setIsLoading(true)
//         setShowCancellationReasonModal(false)
//         let payload = {
//             nResourceInstanceId: selectedServices,
//             refCurrentState: "Cancelled",
//             sServiceCancellationReason: cancellation_Reason,
//             sOtherReason: OtherDescription
//         }

//         const {tempCancelBulkServices} = api.cancelBulkServiceData(payload)
//         .then(({data}) => {
//             if(data){
//                 setIsLoading(false)
//                 toast(String("Services Cancelled Successfully"), {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 });
//                 setSelectedCancellationReason()
//                 setCancellationReasonOtherDescription()
//                 getTableData(tableInstance, false)
//                 setSelectedServices([])
//             }
//         })
//     }

//     const calculateEnableOtherDescriptionTextbox = () => {
// 		if (selectedCancellationReason && selectedCancellationReason.value === "Other") {
// 			setEnableOtherDescriptionTextbox(true);
// 		}
// 		else {
// 			setEnableOtherDescriptionTextbox(false);
// 		}
// 	};

// 	useEffect(() => {
// 		calculateEnableOtherDescriptionTextbox();
// 	}, [selectedCancellationReason]);

//     const processFilters = (filter) => {
//         let filterNames = ""
//         if (filter.length > 1) {
//             filterNames = filter.map(city => city.value).join(", ");
//         } else if (filter.length === 1) {
//             filterNames = filter[0].value;
//         }

//         return filterNames
//     }

//     const handleCatalogueClick = (ele) => {
//         setIsLoading(true)
//         let payload = {
//             api_key: "82mqEyJnct4kzC8y",
//             user_id: ele._original.nUserId
//         }

//         const { tempCataloguelinkData } = api.catalogueLinkApi(payload)
//             .then(({ data }) => {
//                 console.log("Link", data)
//                 if (data.data !== null) {
//                     window.open(data.data.catalogue_url, "_blank");
//                     setIsLoading(false)
//                 }
//             })
//     }
    
//     // Handle send cancellation Message Function
//     const handleSendCancellationMessage = () => {
//         // console.log(">>>>>Cancellation Message Button Clicked");
//         setIsLoading(true)

//         let payload = {"nResourceInstanceId": selectedServices}
//         api.sendCancellationMessage(payload).then(({data}) => {
//             if(data){
//                 toast("Whatsapp message sent successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 })

//                 setSelectedServices([]);
//             }

//             setIsLoading(false)
//         })
//     }

//     //===== View Whatsapp Message Related Function and States ====//
//     const [showWhatsappMessagesModal, setShowWhatsappMessagesModal] = useState(false);
//     const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
//     const [wpMessageDisplayRecordCount, setWpMessageDisplayRecordCount] = useState({displayCount: true, count: 0})
//     const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
//     const [wpMessagepages, setWpMessagePages] = useState(0);
//     const [wpMessagePageSize, setWpMessagePageSize] = useState(10);
//     const [viewMessagePageSizeOptions, setViewMessagePageSizeOptions] = useState([
//         {
//             value: "10",
//             label: "10 Rows",
//         },
//         {
//             value: "20",
//             label: "20 Rows",
//         },
//         {
//             value: "30",
//             label: "30 Rows",
//         },
//         {
//             value: "50",
//             label: "50 Rows",
//         },
//         {
//             value: "75",
//             label: "75 Rows",
//         },
//         {
//             value: "100",
//             label: "100 Rows",
//         },
//     ]);
//     const [selectedViewMessagePageSizeOption, setSelectedViewMessagePageSizeOption] = useState({
//         value: "10",
//         label: "10",
//     });

//     const [oppTypeNameListWpModal, setOppTypeNameListWpModal] = useState(null);
//     const [selectedOppTypeWpModal, setSelectedOppTypeWpModal] = useState(null);

//     const [oppTitleNameListWpModal, setOppTitleNameListWpModal] = useState([])
//     const [selectedOppTitleWpModal, setSelectedOppTitleWpModal] = useState([]);

//     const [fromDate, setFromDate] = useState(null);
//     const [toDate, setToDate] = useState(null);

//     const [messageTypeOptions, setMessageTypeOptions] = useState(
//         [
//             {label: "New Opportunity", value:"Opportunity"},
//             {label: "Cancellation", value:"Cancellation"}
//         ]
//     )
//     const [selectedMessageType, setSelectedMessageType] = useState(null);

//     const [wpCancellationMessageIsLoading, setWpCancellationMessageIsLoading] = useState(false);
//     const [clearActionWpModalData, setClearActionWpModalData] = useState(false);

//     const toggleShowWhatsappMessagesModal = () => {
//         setShowWhatsappMessagesModal(!showWhatsappMessagesModal);

//         setSelectedOppTypeWpModal(null);
//         setSelectedOppTitleWpModal([]);
//         setFromDate(null);
//         setToDate(null);
//         // setSelectedOppTitle([]);
//         // setOppTitleNameList([]);
//     }

    

//     useEffect(()=>{
//         console.log(">>>useEffect to get cancellation message ran");
        
//         let payloads = {
//             page: wpMessagecurrentPage+1,
//             page_size: selectedViewMessagePageSizeOption?.value,
//             pagination: true,
//             sMessageType: "Opportunity"
//         }

//         console.log(payloads, ">>>>>>payloads");
        

//         if(showWhatsappMessagesModal){
//             getWhatsappCancellationMessages();
//         }
//         setClearActionWpModalData(false);
//     }, [showWhatsappMessagesModal, clearActionWpModalData ])

//     useEffect(()=>{
//         if(toDate < fromDate){
//             toast(String("From-Date cant be greater than To-Date"), {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             });
//         }else {
//             {
//                 let selectedOppTypeWp = [];
//                 let selectedOppTitleWp = [];
//                 let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
//                 let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
    
//                 selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
//                 selectedOppTitleWpModal?.map(titleObj => {
//                     selectedOppTitleWp.push(titleObj?.value);
//                 })
    
//                 let data = {
//                     page: wpMessagecurrentPage+1,
//                     page_size: selectedViewMessagePageSizeOption?.value,
//                     pagination: true,
//                     sMessageType: selectedMessageType?.value,
//                     sServiceCode:[...selectedOppTypeWp],
//                     sServiceDisplayName: [...selectedOppTitleWp],
//                     fromDate: formattedFromDate,
//                     toDate: adjustedToDate(formattedToDate)
//                 }
        
//                 console.log(data, ">> data on search click");
//                 getWhatsappCancellationMessages(data);
//             }
//         }
//     }, [ wpMessagecurrentPage, selectedViewMessagePageSizeOption])

//     let getWhatsappCancellationMessages = async(data) =>{
//         try{
//             setWpCancellationMessageIsLoading(true);
            
//             let response = await api.getWhatsappMessageSentForCancellation(data);
//             // console.log(response, ">>> whatsapp cancellation message responseeeee");
//             // console.log(response.data.count, ">>>>response count");
            
//             // console.log(response?.data?.results, ">>> whatsapp cancellation message response data");
//             setSentWhatsappCancellationMessages(response?.data?.results);
//             // setWpMessagePageSize(response.data.length);

//             let totalCounts = response?.data?.count;
//             // console.log(totalCounts, ">>>>totalCounts");
            
//             let totalPages = Math.ceil(totalCounts/selectedViewMessagePageSizeOption?.value);
//             // console.log(totalPages, ">>>>>totalPages");
            
//             setWpMessagePages(totalPages)

            
//             // toast(String("Successfully received the "), {
//             //     autoClose: 5000,
//             //     type: toast.TYPE.SUCCESS,
//             // });

//             setWpCancellationMessageIsLoading(false)
//         } catch(err){
//             console.log(err)
//             setWpCancellationMessageIsLoading(false)
//         }
//     }

//     const searchFilterWpSendCacellationMessages = () =>{
//         console.log(wpMessagecurrentPage, ">>>>wpMessagecurrentPage");
//         console.log(selectedViewMessagePageSizeOption, ">>>>selectedViewMessagePageSizeOption");
//         console.log("pagination: true");
//         console.log("sMessageType");
        
        
        
//         console.log(selectedOppTypeWpModal, ">>>selectedOppTypeWpModal");
//         console.log(selectedOppTitleWpModal, ">>>selectedOppTitleWpModal");
//         console.log(fromDate, ">>>fromDate");
//         console.log(toDate, ">>>toDate");
//         console.log(toDate > fromDate, ">>>is two date greater than from date")
//         console.log(selectedMessageType, ">>>> Selected Message Type");

//         if(wpMessagecurrentPage){
//             setwpMessagecurrentPage(0);
//         }else {
//             if(toDate < fromDate){
//                 toast(String("From-Date cant be greater than To-Date"), {
//                     autoClose: 5000,
//                     type: toast.TYPE.ERROR,
//                 });
//             }else {
//                 {
//                     let selectedOppTypeWp = [];
//                     let selectedOppTitleWp = [];
//                     let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
//                     let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
        
//                     selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
//                     selectedOppTitleWpModal?.map(titleObj => {
//                         selectedOppTitleWp.push(titleObj?.value);
//                     })
        
//                     let data = {
//                         page: wpMessagecurrentPage+1,
//                         page_size: selectedViewMessagePageSizeOption?.value,
//                         pagination: true,
//                         sMessageType: selectedMessageType?.value,
//                         sServiceCode:[...selectedOppTypeWp],
//                         sServiceDisplayName: [...selectedOppTitleWp],
//                         fromDate: formattedFromDate,
//                         toDate: adjustedToDate(formattedToDate)
//                     }
            
//                     console.log(data, ">> data on search click");
//                     getWhatsappCancellationMessages(data);
//                 }
//             }
//         }
//     }

//     const clearSearchFilterWpCancellationMessages = () => {
//         setClearActionWpModalData(true);
//         setSelectedOppTypeWpModal(null);
//         setSelectedOppTitleWpModal([]);
//         setOppTitleNameListWpModal([]);
        
//         setFromDate(null);
//         setToDate(null);
//         setSelectedMessageType(null);
//         setwpMessagecurrentPage(0)
//     }

//     const adjustedToDate = (date) => {
// 		let toDateAdjusted;
// 		if (date) {
// 			toDateAdjusted = new Date(date);

// 			toDateAdjusted = new Date(
// 				toDateAdjusted.setTime(
// 					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
// 				)
// 			);
// 		}
// 		return toDateAdjusted;
// 	};

//     const handleFromDate = (date) =>{
//         if(toDate && toDate<date){
//             setToDate(null)
//         }
//         setFromDate(date)
//     }

//     const handleToDate = (date) => {
//         if(fromDate && fromDate > date){
//             setFromDate(null)
//         }
//         setToDate(date)
//     }

//     const handleViewMessageOnFetchData = (state) =>{
//         console.log(state, ">>>>state on handleViewMessageOnFetchData");
//         setwpMessagecurrentPage(state?.page ? state?.page : 0);
//     }

//     const onMessageTypeChange = (option) =>{
//         // console.log(option, ">>>>option of message type");
//         setSelectedMessageType(option)
//     }

//     // States and functions for filter by status
//     /*Filter modal callbacks */
//     const [showFilterModal, setShowFilterModal] = useState(false);
//     const toggleFilterModal = () => {
//         setShowFilterModal(!showFilterModal);
//     };
//     const handleViewFilterModal = (original) => {
//         toggleFilterModal();
//     };
//     /*End */

//     // service status strates in filter modal
//     const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);
//     const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
//     const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
//     const [serviceStatusList, setServiceStatusList] = useState(statusArray);

//     let MainStatus = [
//         {
//             checked: false,
//             label: "Requested",
//             id: "Requested",
//             code: "Requested",
//         },
//         {
//             checked: false,
//             label: "Eligible",
//             id: "Eligible",
//             code: "Eligible",
//         },
//         {
//             checked: false,
//             label: "Quotation Sent",
//             id: "Quotation Sent",
//             code: "Quotation Sent",
//         },
//         {
//             checked: false,
//             label: "Willing to Pay",
//             id: "Willing to Pay",
//             code: "Willing to Pay",
//         },
//         {
//             checked: false,
//             label: "Payment Received",
//             id: "Payment Received",
//             code: "Payment Received",
//         },
//         {
//             checked: false,
//             label: "Awaiting for information/Documents",
//             id: "Awaiting for information/Documents",
//             code: "Awaiting for information/Documents",
//         },
//         {
//             checked: false,
//             label: "Service Delivery Started",
//             id: "Service Delivery Started",
//             code: "Service Delivery Started",
//         },
//         {
//             checked: false,
//             label: "Service deliverables ready",
//             id: "Service deliverables ready",
//             code: "Service deliverables ready",
//         },
//         {
//             checked: false,
//             label: "Full Payment Requested",
//             id: "Full Payment Requested",
//             code: "Full Payment Requested",
//         },
//         {
//             checked: false,
//             label: "Full Payment Received",
//             id: "Full Payment Received",
//             code: "Full Payment Received",
//         },
//         {
//             checked: false,
//             label: "Delivered",
//             id: "Delivered",
//             code: "Delivered",
//         },
//         {
//             checked: false,
//             label: "Cancelled",
//             id: "Cancelled",
//             code: "Cancelled",
//         },
//         {
//             checked: false,
//             label: "Refunded",
//             id: "Refunded",
//             code: "Refunded",
//         },
//     ]
    
//     var statusArray = MainStatus;

//     useEffect(()=>{
//         const serviceStatusNameForFilter = [];
//         MainStatus.map((x) => {
//             serviceStatusNameForFilter.push({
//                 label: x.label,
//                 value: x.code,
//                 id: x.id,
//             });
//         });

//         setServiceStatusNameListForFilter(serviceStatusNameForFilter);
//     }, [])

//     const toggleAllForServiceStatusFilter = () => {
//         let temp = [];

//         if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
//             if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
//                 temp = selectedServiceStatusListForFilter;
//             }
//             else {
//                 temp = [{ label: "All", value: "*" }];
//             }

//             let tempSR = serviceStatusNameListForFilter.map((e) => {
//                 if (!temp.includes(e)) {
//                     temp = temp.concat(e);
//                 }
//                 return e;
//             });
//             setSelectedServiceStatusListForFilter(temp);
//             setServiceStatusNameListForFilter(tempSR);
//             //getExternalPartnerServices(tableInstance);
//         }
//         else {
//             setSelectedServiceStatusListForFilter([]);
//             //getExternalPartnerServices(tableInstance);
//         }
//     };

//     const toggleSelectionForServiceStatusFilter = (e) => {
//         setSelectedServiceStatusListForFilter(e);
//     };
    
//     const toggleAllForFilter = () => {
//         let temp = [];

//         // if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
//         //     if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
//         //         temp = selectedServiceNameListForFilter;
//         //     }
//         //     else {
//         //         temp = [{ label: "All", value: "*" }];
//         //     }

//         //     let tempSR = serviceNameListForFilter.map((e) => {
//         //         if (!temp.includes(e)) {
//         //             temp = temp.concat(e);
//         //         }
//         //         return e;
//         //     });
//         //     setSelectedServiceNameListForFilter(temp);
//         //     setServiceNameListForFilter(tempSR);
//         //     //getExternalPartnerServices(tableInstance);
//         // }
//         // else {
//         //     setSelectedServiceNameListForFilter([]);
//         //     //getExternalPartnerServices(tableInstance);
//         // }
//     };

//     const toggleSelectionForFilter = (e) => {
//         // setSelectedServiceNameListForFilter(e);
//     };

//     const handleSearchClick = async () => {
//         if (showFilterModal) {
//             toggleFilterModal();
//         }
//         // setSelectedServiceForEdit();
//         // setSelectedSecondServiceForEdit();
//         // setExpandedChange({});
//         // if(confirmationChecked){
//         //      getFilterDataExternalService(tableInstance, true)
//         // } else {
//             // getExternalPartnerServices(tableInstance, true);
//             getTableData(tableInstance, true)
//         // }
        
//         //refreshTable();
//     };

//     const handleClearFilterSearch = () => {
//         let tempStatus = serviceStatusList?.map((x) => {
//             x.checked = false;
//             return x;
//         });
//         // setSelectedServiceNameListForFilter([]);
//         // setSelectedServiceStatus([]);
//         setServiceStatusList(tempStatus);
//         // setSearchTerm("");
//         // setfromDate("");
//         // settoDate("");
//         // setSelectedRequestedaCallBackOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setSelectedNeedToTalkToSPOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setSelectedRequestedByOption(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setselectedCallStatusOptionForFilter(null/*{
//         //     value: "all",
//         //     label: "All",
//         // }*/);
//         // setselectedofflinemeetoptionsForFilter(null);

//         // setSelectedPackageNameListForFilter(null);
//         // // setselectedofflinemeetoptions(null);
//         // //setExpandedChange({});
//         setSelectedServiceStatusListForFilter([]);
//         // setRequestWithinTAT('');
//     };

    
    

//     // console.log(selectedServiceStatusListForFilter, ">>>>selectedServiceStatusListForFilter");
    

//     // console.log(fromDate, ">>>>fromDate");
//     // console.log(toDate, ">>>toDate");
//     // console.log(selectedOppTypeWpModal, ">>>>selectedOppTypeWpModal");
//     // console.log(selectedOppTitleWpModal, ">>>>selectedOppTitleWpModal");
//     console.log(sentWhatsappCancellationMessages, ">>>>sentWhatsappCancellationMessages");
//     console.log(wpMessageDisplayRecordCount, ">>>>wpMessageDisplayRecordCount");
//     console.log(wpMessagecurrentPage, ">>>>wpMessagecurrentPage");
//     console.log(wpMessagepages, ">>>>>wpMessagepages");
//     console.log(wpMessagePageSize, ">>>>>wpMessagePageSize");
//     console.log(selectedViewMessagePageSizeOption, ">>>>>selectedViewMessagePageSizeOption");

//     // const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
//     // const [wpMessageDisplayRecordCount, setWpMessageDisplayRecordCount] = useState({displayCount: true, count: 0})
//     // const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
//     // const [wpMessagepages, setWpMessagePages] = useState(0);
//     // const [wpMessagePageSize, setWpMessagePageSize] = useState(10);
    
//   return (
//     <div className={`${isLoading && "set-opacity"}`}>
//             {isLoading && <Spinner className="center-screen" />}

//           <Modal isOpen={revenueModal}>
//               <ModalContent className="general-modal">
//                   <div className="modal-header" style={{
//                       backgroundColor: '#76287C',
//                       color: '#fff'
//                   }}>
//                       <span className="modal-title">Enter Revenue</span>
//                       <img
//                           alt="close"
//                           id="Close"
//                           src={close_modal}
//                           className="close modal-close"
//                           onClick={openRevenueModalisFalse}
//                       />
//                   </div>

//                   <div className="modal-body">
//                       {/* <div className="row">
//                           <div className="col m-2">
//                               <span className="spled-colored-label">Service Price</span> <span className="spled-black-text">: {serviceRequestReadOnlyData.fAmountFirst}</span>
//                           </div>
//                       </div> */}
//                       <div className="row mt-2">
//                           <div className="col-12 w-100">
//                               <input type="number" placeholder="Enter Revenue Generated (for eg: 1000)" style={{
//                                   width: "-webkit-fill-available",
//                                   height: '45px'
//                               }}
//                               min={0}
//                                   onKeyDown={(e) => {
//                                       const invalidChars = ['=', '-', '+', 'e'];
//                                       if (invalidChars.includes(e.key)) {
//                                           e.preventDefault();
//                                       }
//                                   }}
//                                   onChange={(e) => setRevenueAmount(e.target.value)} />
//                           </div>
//                       </div>
//                       <div className="row m-2">
//                           <div className="offset-3 col-6">
//                               <Button 
//                               onClick={onGenerateRevenueClick}
//                               >Update Revenue</Button>
//                           </div>
//                       </div>
//                   </div>
//               </ModalContent>
//           </Modal>

//           <div className="row" style={{
//             //   height: "75px",
//               marginBottom: '15px',
//               boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)"
//           }} >
            
//               <div className='col-12'>
//                 <div className='row'>
//                     <div className="col-2 ml-4 mt-3 conv-pl25 spled-container conv-zindex" style={{backgroundColor:""}}>
//                         <button className="con-btn-filled conv-pl15 conv-pr15 conv-font14" style={{ marginLeft: '15px' }}
//                             onClick={(e) => { handleViewFilterModal() }} 
//                         >
//                             <img
//                                 alt=""
//                                 src={ic_filter}
//                                 height={"15px"}
//                                 width={"15px"}
//                                 className="conv-mr10"
//                             />
//                             Filter By
//                         </button>
//                 </div>
//                 </div>
//               </div>
            
//               <div className="col-12">
//                 <div className="row">
//                 <div className="col-2 ml-5 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       <Select
//                           options={oppTypeNameList}
//                           onChange={onOppTypeChange}
//                           value={selectedOppType}
//                           placeholder="Select Opp Type"
//                           isClearable
//                       />
//                   </div>
//               </div>

//               <div className="col-2 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       {/* <Select
//                           options={oppTitleNameList}
//                             onChange={onOppTitleChange}
//                             value={selectedOppTitle}
//                           placeholder="Select Opp Title"
//                           isClearable
//                       /> */}
//                       <MultiSelectAll
//                                   toggleAll={toggleAllOppTitle}
//                                   toggleSelection={onOppTitleChange}
//                                   checkboxItemsList={oppTitleNameList}
//                                   selectedOptions={selectedOppTitle}
//                                   placeholderButtonLabel="Select Opp Title"
//                               />
//                   </div>
//               </div>

//               <div className="col-2 mt-3 spled-container conv-zindex">
//                   <div className="">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={businessSectorList}
//                           placeholder="Select Sector"
//                           onChange={onBusinessSectorChange}
//                           value={selectedBusinessSector}
//                           isClearable
//                       /> */}
//                               <MultiSelectAll
//                                   toggleAll={toggleAllSector}
//                                   toggleSelection={onBusinessSectorChange}
//                                   checkboxItemsList={businessSectorList}
//                                   selectedOptions={selectedBusinessSector}
//                                   placeholderButtonLabel="Select Sector"
//                               />
//                   </div>
//               </div>
//               <div className="col-2 spled-container mt-3 conv-zindex">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={tagsDropDownList}
//                           placeholder="Select Tag"
//                           onChange={onTagChange}
//                           value={selectedTagOption}
//                           isClearable
//                       /> */}
//                           <MultiSelectAll
//                               toggleAll={toggleAllTags}
//                               toggleSelection={onTagChange}
//                               checkboxItemsList={tagsDropDownList}
//                               selectedOptions={selectedTagOption}
//                               placeholderButtonLabel="Select Tags"
//                           />
//                   </div>
//                   <div className="col-2 spled-container mt-3 conv-zindex">
//                       {/* <Select
//                         //   className="reportInput"
//                           options={businessCityList}
//                           placeholder="Select City"
//                           onChange={onBusinessCityChange}
//                           value={selectedBusinessCity}
//                           isClearable
//                       /> */}
//                           <MultiSelectAll
//                               toggleAll={toggleAllBusinessCity}
//                               toggleSelection={onBusinessCityChange}
//                               checkboxItemsList={businessCityList}
//                               selectedOptions={selectedBusinessCity}
//                               placeholderButtonLabel="Select City"
//                           />
//                   </div>

//               {/* <div className="col-2 mt-3 spled-container conv-zindex"> */}
//                   <div className='mt-3 spled-container conv-zindex'>
//                       <Button style={{
//                           margin: 0,
//                           marginLeft: '10px',
//                           height: '37px'
//                       }}
//                           onClick={onSearchClick}
//                           // disabled={!props.selectedExtPartner}
//                           className="con-btn-filled">Search</Button>
//                   </div>
//               {/* </div> */}
//                 </div>
//               </div>


//               {/* <div className="col-3 mt-2 spled-container"  style={{
//                     //   justifyContent: 'flex-end'
//                     marginLeft: '47px'
//                   }}>
//                             <ControlledInput
//                                 className="reportInputUmc"
//                                 name="sContactNumber"
//                                 placeholder="Contact Number"
//                                 value={searchFields.sContactNumber}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 //   onKeyDown={(e) => {
//                                 //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                                 //       if (
//                                 //           !/^\d$/.test(e.key) &&
//                                 //           !allowedKeys.includes(e.key) &&
//                                 //           e.key !== "Tab"
//                                 //       ) {
//                                 //           e.preventDefault();
//                                 //       }
//                                 //   }}
//                                 onKeyDown={(e) => {
//                                     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                                     const ctrlKeys = ["a", "c", "v", "x"];

//                                     if (
//                                         !/^\d$/.test(e.key) && // Allow digits
//                                         !allowedKeys.includes(e.key) && // Allow navigation keys
//                                         !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                                     ) {
//                                         e.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div> */}

              
//                   {/* <div className="col-3 d-flex align-items-center">
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={onDeliverServicesBtnClick}
//                                   className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Deliver Services</button>
//                               :
//                               <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Deliver Services</button>

//                       }
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={() => setShowCancellationReasonModal(true)}
//                                   className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Cancel Services</button>
//                               :
//                               <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Cancel Services</button>

//                       }
//                   </div> */}

//                   {/* Added Confirmation Received */}
//                  {/* <div className="col-4 d-flex mt-3">
//                             <div className="">
//                                 <Checkbox
//                                     id={`checkbox3-completed`}
//                                     checked={confirmationChecked}
//                                     onChange={(e) => {
//                                         e.stopPropagation();
//                                         setConfirmationChecked(!confirmationChecked)
//                                         // updateConfirmationFlagData(row.original)
//                                         // props.getExternalPartnerServices()
//                                     }}
//                                     label={"Confirmation Received"}
//                                 // disabled={row.original.bConfirmation_tag}
//                                 ></Checkbox>
//                             </div>
//                     </div> */}

//               <div className="col-2 mt-2 spled-container" style={{
//                   // justifyContent: 'flex-end'
//                   marginLeft: '33px',
//                   display: "flex",
//                   // alignItems:"center"
//                   justifyContent: "space-between",
//                   backgroundColor:""
//               }}>
//                   {/* Added Confirmation Received */}
//                   <div className="col-5 d-flex" style={{backgroundColor:""}}>
//                       <div className="">
//                           <Checkbox
//                               id={`checkbox3-completed`}
//                               checked={confirmationChecked}
//                               onChange={(e) => {
//                                   e.stopPropagation();
//                                   setConfirmationChecked(!confirmationChecked)
//                                   // updateConfirmationFlagData(row.original)
//                                   // props.getExternalPartnerServices()
//                               }}
//                               label={"Confirmation Received"}
//                           // disabled={row.original.bConfirmation_tag}
//                           ></Checkbox>
//                       </div>
//                   </div>
//               </div>

//               {/* <div className="col-8 d-flex align-items-center pl-4 ml-1">

//                   <div className='mt-2' style={{ display: "flex" }}>
//                       <ControlledInput
//                           className="reportInputUmc"
//                           name="sContactNumber"
//                           placeholder="Contact Number"
//                           value={searchFields.sContactNumber}
//                           onChange={({ target: { name, value } }) => handleChange(name, value)}
//                           // onKeyDown={(e) => {
//                           //     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                           //     if (
//                           //         !/^\d$/.test(e.key) &&
//                           //         !allowedKeys.includes(e.key) &&
//                           //         e.key !== "Tab"
//                           //     ) {
//                           //         e.preventDefault();
//                           //     }
//                           // }}
//                           onKeyDown={(e) => {
//                               const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                               const ctrlKeys = ["a", "c", "v", "x"];

//                               if (
//                                   !/^\d$/.test(e.key) && // Allow digits
//                                   !allowedKeys.includes(e.key) && // Allow navigation keys
//                                   !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                               ) {
//                                   e.preventDefault();
//                               }
//                           }}
//                           autoComplete="off"
//                       />
//                   </div>
//                   {
//                       selectedServices.length > 0 ?
//                           <button
//                               onClick={onDeliverServicesBtnClick}
//                               className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Deliver Services</button>
//                           :
//                           <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Deliver Services</button>

//                   }
//                   {
//                       selectedServices.length > 0 ?
//                           <button
//                               onClick={() => setShowCancellationReasonModal(true)}
//                               className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Cancel Services</button>
//                           :
//                           <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Cancel Services</button>

//                   }
//               </div> */}

//                <div className="col-2 mt-2 spled-container"  style={{
//                     //   justifyContent: 'flex-end'
//                     marginLeft: '15px',
//                     backgroundColor:""
//                   }}>
//                             <ControlledInput
//                                 className="reportInputUmc"
//                                 name="sContactNumber"
//                                 placeholder="Contact Number"
//                                 value={searchFields.sContactNumber}
//                                 onChange={({ target: { name, value } }) => handleChange(name, value)}
//                                 //   onKeyDown={(e) => {
//                                 //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                                 //       if (
//                                 //           !/^\d$/.test(e.key) &&
//                                 //           !allowedKeys.includes(e.key) &&
//                                 //           e.key !== "Tab"
//                                 //       ) {
//                                 //           e.preventDefault();
//                                 //       }
//                                 //   }}
//                                 onKeyDown={(e) => {
//                                     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
//                                     const ctrlKeys = ["a", "c", "v", "x"];

//                                     if (
//                                         !/^\d$/.test(e.key) && // Allow digits
//                                         !allowedKeys.includes(e.key) && // Allow navigation keys
//                                         !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
//                                     ) {
//                                         e.preventDefault();
//                                     }
//                                 }}
//                                 autoComplete="off"
//                             />
//                         </div>

//                 {/* <div className="col-6 d-flex align-items-center" style={{backgroundColor:"red", margin:"0px", padding:"0px",justifyContent:"space-between", paddingLeft:"9px", paddingRight:"13px"}}>
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={onDeliverServicesBtnClick}
//                                   className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Deliver Services</button>
//                               :
//                               <button className="my-services-model-submit-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Deliver Services</button>

//                       }
//                       {
//                           selectedServices.length > 0 ?
//                               <button
//                                   onClick={() => setShowCancellationReasonModal(true)}
//                                   className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                       marginBottom: "15px"
//                                   }}>
//                                   Cancel Services</button>
//                               :
//                               <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                   marginBottom: "15px",
//                                   opacity: "0.4",
//                                   pointerEvents: "none",
//                               }}>
//                                   Cancel Services</button>

//                       }


//                     {
//                         selectedServices.length > 0 ?
//                             <button
//                                 onClick={() => handleSendCancellationMessage()}
//                                 className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                     marginBottom: "15px"
//                                 }}>
//                                 Send Cancellation Messge</button>
//                             :
//                             <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                                 marginBottom: "15px",
//                                 opacity: "0.4",
//                                 pointerEvents: "none",
//                             }}>
//                                 Send Cancellation Message</button>
//                     }
//                     {
//                         <button
//                         onClick={() => toggleShowWhatsappMessagesModal()}
//                         className="my-services-model-cancel-btn ml-2 mt-2" style={{
//                             marginBottom: "15px"
//                         }}>
//                             View Messages
//                         </button>
//                     }
//                 </div> */}

//                 <div
//                 className="col-6 d-flex align-items-center"
//                 style={{
//                     backgroundColor: "",
//                     margin: "0px",
//                     padding: "0px",
//                     justifyContent: "space-between",
//                     paddingLeft: "7px",
//                     paddingRight: "15px"
//                 }}
//                 >
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={onDeliverServicesBtnClick}
//                         className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Deliver Services
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Deliver Services
//                     </button>
//                     )
//                 }
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={() => setShowCancellationReasonModal(true)}
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Cancel Services
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Cancel Services
//                     </button>
//                     )
//                 }
//                 {
//                     selectedServices.length > 0 ? (
//                     <button
//                         onClick={() => handleSendCancellationMessage()}
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Send Cancellation Message
//                     </button>
//                     ) : (
//                     <button
//                         className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                         style={{
//                         marginBottom: "15px",
//                         opacity: "0.4",
//                         pointerEvents: "none",
//                         maxWidth: "100%",
//                         }}
//                     >
//                         Send Cancellation Message
//                     </button>
//                     )
//                 }
//                 {
//                     <button
//                     onClick={() => toggleShowWhatsappMessagesModal()}
//                     className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
//                     style={{
//                         marginBottom: "15px",
//                         maxWidth: "100%",
//                     }}
//                     >
//                     View Messages
//                     </button>
//                 }
//                 </div>


//               {/* <div className='col-2 mt-2 spled-container conv-zindex'>
//                   <Button style={{
//                       margin: 0,
//                       marginLeft: '6px',
//                       height: '37px',
//                       display: 'none',
//                       width: 100
//                   }}
//                       onClick={onClearClick}
//                       // disabled={!props.selectedExtPartner}
//                       className="con-btn-filled">Clear</Button>
//               </div> */}


//                   <div className='mt-2 spled-container conv-zindex' style={{backgroundColor:""}}>
//                       <Button style={{
//                           margin: 0,
//                           marginLeft: '10px',
//                           height: '37px',
//                           width: 100
//                       }}
//                           onClick={onClearClick}
//                           // disabled={!props.selectedExtPartner}
//                           className="con-btn-filled">Clear</Button>
//                   </div>

                  

              
              
//               {/* <div className="col-2 d-flex align-items-center" style={{
//                   justifyContent: 'flex-end'
//               }} >
//                   {
//                       selectedServiceRequests.length > 0 ?
//                           <Button
//                               onClick={openPaymentModalisTrue}
//                               className="esp-inline-button ml-2 mt-2" style={{
//                                   marginBottom: "15px"
//                               }}>
//                               Settle Payment</Button>
//                           :
//                           <Button className="esp-inline-button ml-2 mt-2" style={{
//                               marginBottom: "15px",
//                               opacity: "0.4",
//                               pointerEvents: "none",
//                           }}>
//                               Settle Payment</Button>

//                   }
//               </div> */}
//           </div>

//           <ESPUmcReactTable 
//             data={tableData}
//             displayRecordCount={displayRecordCount}
//             handleCatalogueClick={handleCatalogueClick}
//             onEnterRevenueClick={onEnterRevenueClick}
//             handleCheckboxChange={handleCheckboxChange}
//             isSelected={isSelected}
//             selectedServices={selectedServices}
//             handleSelectAll={handleSelectAll}
//             openRevenueModalisTrue={openRevenueModalisTrue}
//             onFetchServiceRequests={fetchServiceRequests}
//             pages={pages}
//             pageSize={pageSize}
//             page={currentPage}
//             pageSizeOptions={pageSizeOptions}
//             selectedPageSizeOption={selectedPageSizeOption}
//             onPageSizeOptionChange={(option) => {
//                 setSelectedPageSizeOption(option);
//             }}
//           />

//           {
//               showCancellationReasonModal &&
//               <CancellationReasonModal
//                   isDisabled={enableCancelButtonFlag}
//                   isOpen={showCancellationReasonModal}
//                   toggleModal={toggleCancellationReasonModal}
//                   cancellationReasonDropdownOptions={
//                       cancellationReasonDropdownOptions
//                   }
//                   onSelectCancellationReason={setSelectedCancellationReason}
//                   selectedCancellationReason={selectedCancellationReason}
//                   enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
//                   cancellationReasonOtherDescription={
//                       cancellationReasonOtherDescription
//                   }
//                   onChangeCancellationReasonOtherDescription={(value) => {
//                       setCancellationReasonOtherDescription(value);
//                   }}
//                   onChangeState={handleChangeState}
//               />
//           }

//           {/* View Whatsapp Messages Model */}
//           <ViewWhatsappMessagesModal
//             isOpen = {showWhatsappMessagesModal}
//             data = {sentWhatsappCancellationMessages}
//             displayRecordCount={wpMessageDisplayRecordCount}
//             pageSizeOptions={viewMessagePageSizeOptions}

//             pages={wpMessagepages}
            
//             toggleModal = {toggleShowWhatsappMessagesModal}
            
//             pageSize = {wpMessagePageSize} // responsible for purple select the page size
//             page={wpMessagecurrentPage}
            
//             onViewMessagePageSizeOptionChange={(option) => {
//                 console.log(">>>>option on onViewMessagePageSizeOptionChange");
                
//                 setSelectedViewMessagePageSizeOption(option);
//                 setWpMessagePageSize(option?.value)
//             }}
//             selectedPageSizeOption={selectedViewMessagePageSizeOption}

//             // BELOW IS DATA FOR FILTER
//             oppTypeNameListWpModal={oppTypeNameListWpModal}
//             onOppTypeChange={onOppTypeChange}
//             selectedOppType={selectedOppTypeWpModal}

//             toggleAllOppTitle={toggleAllOppTitle}
//             onOppTitleChange={onOppTitleChange}
//             oppTitleNameListWpModal={oppTitleNameListWpModal}
//             selectedOppTitleWpModal={selectedOppTitleWpModal}

//             // setFromDate = {setFromDate}
//             handleFromDate={handleFromDate}
//             // setToDate={setToDate}
//             handleToDate={handleToDate}
//             fromDate={fromDate}
//             toDate={toDate}

//             searchFilterWpSendCacellationMessages={searchFilterWpSendCacellationMessages}
//             wpCancellationMessageIsLoading={wpCancellationMessageIsLoading}

//             clearSearchFilterWpCancellationMessages={clearSearchFilterWpCancellationMessages}

//             messageTypeOptions={messageTypeOptions}
//             onMessageTypeChange={onMessageTypeChange}
//             selectedMessageType={selectedMessageType}

//             handleViewMessageOnFetchData={handleViewMessageOnFetchData}
//           />

// {
// 				showFilterModal &&
// 				(
// 					<ESPUmcLedFilterModel
// 						isOpen={showFilterModal}
// 						toggleModal={toggleFilterModal}
// 						toggleAllForFilter={toggleAllForFilter}
// 						toggleSelectionForFilter={toggleSelectionForFilter}
// 						serviceNameListForFilter={serviceNameListForFilter}

// 						// selectedServiceNameListForFilter={props.selectedServiceNameListForFilter}
// 						// fromDate={props.fromDate}
// 						// setfromDate={props.setfromDate}
// 						// toDate={props.toDate}
// 						// settoDate={props.settoDate}
// 						// requestedByOptions={props.requestedByOptions}
// 						// setSelectedRequestedByOption={props.setSelectedRequestedByOption}
// 						// selectedRequestedByOption={props.selectedRequestedByOption}
// 						// packageNameListForFilter={props.packageNameListForFilter}
// 						// oppTypeNameListforFilter={props.oppTypeNameListforFilter}
// 						// setSelectedPackageNameListForFilter={props.setSelectedPackageNameListForFilter}
// 						// selectedPackageNameListForFilter={props.selectedPackageNameListForFilter}
// 						// requestedaCallBackOptions={props.requestedaCallBackOptions}
// 						// setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
// 						// selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
// 						// toggleServiceStatus={props.toggleServiceStatus}
// 						// serviceStatusList={props.serviceStatusList}
// 						// callStatusOptionsForFilter={props.callStatusOptionsForFilter}
// 						// setselectedCallStatusOptionForFilter={props.setselectedCallStatusOptionForFilter}
// 						// selectedCallStatusOptionForFilter={props.selectedCallStatusOptionForFilter}
// 						// setSelectedRequestedaCallBackOption={props.setSelectedRequestedaCallBackOption}
// 						// selectedRequestedaCallBackOption={props.selectedRequestedaCallBackOption}

// 						onSearchClicked={handleSearchClick}
// 						onClearFilterSearch={handleClearFilterSearch}
// 						toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
// 						toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
// 						selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
// 						serviceStatusNameListForFilter={serviceStatusNameListForFilter}

// 						// //offline meet
// 						// offlinemeetoptionsForFilter={props.offlinemeetoptionsForFilter}
// 						// setselectedofflinemeetoptionsForFilter={props.setselectedofflinemeetoptionsForFilter}
// 						// selectedofflinemeetoptionsForFilter={props.selectedofflinemeetoptionsForFilter}



// 						// offlinemeetoptions={props.offlinemeetoptions}
// 						// selectedofflinemeetoptions={props.selectedofflinemeetoptions}
// 						// setselectedofflinemeetoptions={props.setselectedofflinemeetoptions}




// 						// //for admin
// 						// externalServicePartnerOptions={props.externalServicePartnerOptions}
// 						// selectedExternalServicePartner={props.selectedExternalServicePartner}
// 						// onExternalServicePartnerChange={props.onExternalServicePartnerChange}
// 						// ExternalServicePartnerOrganization={props.ExternalServicePartnerOrganization}
// 						// isForAdmin={props.isForAdmin}
// 					>
// 					</ESPUmcLedFilterModel>
// 				)
// 			}
                
//     </div>
//   )
// }

// export default ESPUmcInterface


////////////////////////////////////////////////////
// My without confirmation received
////////////////////////////////////////////////////
import React, { useEffect, useState } from 'react'
import Select from "react-select";
import api from '../../utils/api';
import { Button } from '../../common/Button/Button';
import ESPUmcReactTable from './ESPUmcReactTable';
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import Modal from "react-modal";
import Spinner from '../../common/Spinner/Spinner';
import { toast } from 'react-toastify';
import CancellationReasonModal from '../../components/ServiceRequests/Handholder/CancellationReasonModal';
import MultiSelectAll from '../../common/Multiselect/MultiSelectAll';
import { ControlledInput } from '../../common/Input/Input';
import Checkbox from '../../common/Checkbox/Checkbox';

import ViewWhatsappMessagesModal from '../../components/ServiceRequests/Handholder/ViewWhatsappMessagesModal';

import ic_filter from "../../assets/ic_filter.svg";

import ESPUmcLedFilterModel from '../../components/EServicePartnerServiceRequests/ESPUmcLedFilterModel';

const ESPUmcInterface = () => {

    const [revenueModal, setRevenueModal] = useState(false)
    const [revenueAmount, setRevenueAmount] = useState('')

    const [resourceId, setResourceId] = useState(0)
    const [serviceDisplay, setServiceDisplay] = useState("")

    const [tableData, setTableData] = useState([])
    const [isClearAction, setIsClearAction] = useState(false);

    const [oppTypeNameList, setOppTypeNameList] = useState()
    const [selectedOppType, setSelectedOppType] = useState(null)

    const [oppTitleNameList, setOppTitleNameList] = useState([])
    const [selectedOppTitle, setSelectedOppTitle] = useState([])

    const [businessSectorList, setBusinessSectorList] = useState([])
    const [selectedBusinessSector, setSelectedBusinessSector] = useState([])

    const [displayRecordCount, setDisplayRecordCount] = useState({displayCount: true, count: 0})

    const [searchFields, setSearchFields] = useState({
        sContactNumber: ""
    })

    const [confirmationChecked, setConfirmationChecked] = useState(false)

    useEffect(() => {
        if (isClearAction) {
            // Call umcCustomersData only after state updates have been completed
            getTableData(tableInstance, true);
            
            // Reset the clear action flag
            setIsClearAction(false);
        }
    }, [
        isClearAction // This ensures the function is called after clearing
    ]);

    const handleChange = (name, value) => {
        const updated = { ...searchFields, [name]: value };
        setSearchFields(updated)
    }

    const onBusinessSectorChange = (options) => {
        // setSelectedBusinessSector(option)
        // getTagsDropdown(option)

        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedBusinessSector([{ value: "*", label: "All" }]);
            getTagsDropdown(processFilters(options))
        } else {
            setSelectedBusinessSector(options.filter((opt) => opt.value !== "*"));
            getTagsDropdown(processFilters(options))
        }
    }

    const toggleAllSector = () => {
        if (selectedBusinessSector.length != businessSectorList.length && selectedBusinessSector.length != (businessSectorList.length + 1)) {
          let temp = []
    
          if (selectedBusinessSector.includes({ label: "All", value: "*" })) {
            temp = selectedBusinessSector
          } else {
            temp = [{ label: "All", value: '*' }]
          }
    
          let tempSR = businessSectorList.map((e) => {
            if (!temp.includes(e)) {
              temp = temp.concat(e)
            }
            return e
          })
          setBusinessSectorList(tempSR)
          setSelectedBusinessSector(temp)
          getTagsDropdown(processFilters(temp))
        } else {
          setSelectedBusinessSector([])
          getTagsDropdown(null)
        }
    
      }

    const [businessCityList, setBusinessCityList] = useState([])
    const [selectedBusinessCity, setSelectedBusinessCity] = useState([])

    const onBusinessCityChange = (options) => {
        // setSelectedBusinessCity(option)
        
        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedBusinessCity([{ value: "*", label: "All" }]);
        } else {
            setSelectedBusinessCity(options.filter((opt) => opt.value !== "*"));
        }
    }

    const toggleAllBusinessCity = () => {
        if (selectedBusinessCity.length != businessCityList.length && selectedBusinessCity.length != (businessCityList.length + 1)) {
          let temp = []
    
          if (selectedBusinessCity.includes({ label: "All", value: "*" })) {
            temp = selectedBusinessCity
          } else {
            temp = [{ label: "All", value: '*' }]
          }
    
          let tempSR = businessCityList.map((e) => {
            if (!temp.includes(e)) {
              temp = temp.concat(e)
            }
            return e
          })
          setBusinessCityList(tempSR)
          setSelectedBusinessCity(temp)
        } else {
          setSelectedBusinessCity([])
        }
    
      }

    const [tagsDropDownList, setTagsDropdownList] = useState([])
    const [selectedTagOption, setSelectedTagOption] = useState([])

    const getTagsDropdown = (e) => {
        if (e !== null) {
            api.tagsListApi(e)
                .then(({ data }) => {
                    if (data.data.length > 0) {
                        // Flatten all sTag arrays into a single array
                        const allTags = data.data.flatMap(sector => sector.sTag);
    
                        // Remove duplicates
                        const uniqueTags = [...new Set(allTags)];
    
                        // Format the tags for the dropdown
                        const formattedData = uniqueTags.map(tag => ({
                            value: tag,
                            label: tag
                        }));
    
                        setTagsDropdownList(formattedData);
                        console.log("Drop list", formattedData);
                    } else {
                        setTagsDropdownList([]);
                    }
                })
                .catch(error => {
                    console.error("API error:", error);
                    setTagsDropdownList([]);
                });
        } else {
            setTagsDropdownList([]);
            setSelectedTagOption([]);
        }
    };

    const onTagChange = (options) => {
        // setSelectedTagOption(option)

        const isAllSelected = options.some((opt) => opt.value === "*");
        if (isAllSelected) {
            setSelectedTagOption([{ value: "*", label: "All" }]);
        } else {
            setSelectedTagOption(options.filter((opt) => opt.value !== "*"));
        }
    }

    const toggleAllTags = () => {
        if (selectedTagOption.length != tagsDropDownList.length && selectedTagOption.length != (tagsDropDownList.length + 1)) {
          let temp = []
    
          if (selectedTagOption.includes({ label: "All", value: "*" })) {
            temp = selectedTagOption
          } else {
            temp = [{ label: "All", value: '*' }]
          }
    
          let tempSR = tagsDropDownList.map((e) => {
            if (!temp.includes(e)) {
              temp = temp.concat(e)
            }
            return e
          })
          setTagsDropdownList(tempSR)
          setSelectedTagOption(temp)
        } else {
          setSelectedTagOption([])
        }
    
      }

    const [pages, setPages] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
    const [count, setCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isFilterTrue, setIsFilterTrue] = useState(false)
    const [pageSizeOptions, setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });
    const [selectedServices, setSelectedServices] = useState([]);

    /**CancellationReason */

	const [showCancellationReasonModal, setShowCancellationReasonModal,] = useState(false);
    const [cancellationReasonDropdownOptions, setCancellationReasonDropdownOptions,] = useState();
	const [selectedCancellationReason, setSelectedCancellationReason,] = useState();
	const [enableOtherDescriptionTextbox, setEnableOtherDescriptionTextbox,] = useState(false);
	const [cancellationReasonOtherDescription, setCancellationReasonOtherDescription,] = useState();
	const [enableCancelButtonFlag, setEnableCancelButtonFlag] = useState("disable");

	const toggleCancellationReasonModal = () => {
        setSelectedCancellationReason()
        setCancellationReasonOtherDescription()
		setShowCancellationReasonModal(!showCancellationReasonModal);
	};

    // const enableCancelButton = () => {
    //     if(selectedCancellationReason){
    //         setEnableCancelButtonFlag("")
    //     }
    // }

    const enableCancelButton = () => {
		if (selectedCancellationReason) {
			if (selectedCancellationReason.value === "Other") {
				if (
					cancellationReasonOtherDescription &&
					cancellationReasonOtherDescription.length > 0
				) {
					setEnableCancelButtonFlag("");
				} else setEnableCancelButtonFlag("disable");
			} else setEnableCancelButtonFlag("");
		} else setEnableCancelButtonFlag("disable");
	};

    useEffect(() => {
        enableCancelButton()
    }, [selectedCancellationReason, cancellationReasonOtherDescription])

    const handleCheckboxChange = (serviceInstanceId) => {
        console.log(serviceInstanceId, ">>>>ServiceInstanceId");
        
        const currentIndex = selectedServices.indexOf(serviceInstanceId);
        const newSelectedServices = [...selectedServices];

        if (currentIndex === -1) {
            newSelectedServices.push(serviceInstanceId);
        } else {
            newSelectedServices.splice(currentIndex, 1);
        }

        setSelectedServices(newSelectedServices);
        console.log("Selected Service", newSelectedServices)
    };

    const isSelected = (serviceInstanceId) => selectedServices.includes(serviceInstanceId);

    const handleSelectAll = () => {
        const selectableServices = tableData.filter(service => service.custrefSRState !== 'Delivered' && service.custrefSRState !== 'Cancelled');
        const selectableServiceIds = selectableServices.map(service => service.nResourceInstanceId);
    
        if (selectedServices.length === selectableServiceIds.length) {
            // Deselect all services
            setSelectedServices([]);
        } else {
            // Select all services
            setSelectedServices(selectableServiceIds);
        }
        console.log("Serv", selectableServiceIds)
    };

    // OLD CODE
    // const onDeliverServicesBtnClick = async() => {
    //         let payload = {
    //             nResourceInstanceId: selectedServices,
    //             refCurrentState: 'Delivered'
    //         }
    //         setIsLoading(true)
    //         const {deliverBulkServices} = api.deliverBulkServiceData(payload)
    //         .then(({data}) => {
    //             if(data){
    //                 console.log("Data", data.Message)
    //                 setIsLoading(false)
    //                 toast(String(data.Message), {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.SUCCESS,
    //                 });
    //                 getTableData(tableInstance, false)
    //                 setSelectedServices([])
    //             }
    //         }) .catch((error) => {
    //             setIsLoading(false);
    //             if (error.response.data.error) {
    //                 toast(String("Services cannot be delivered as some services are still in LPM."), {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.ERROR,
    //                 });
    //             }
    //             else if (error.response.data.message) {
    //                 toast(String(error.response.data.message), {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.ERROR,
    //                 });
    //             }
    //             else {
    //                 toast("Internal server error", {
    //                     autoClose: 5000,
    //                     type: toast.TYPE.ERROR,
    //                 });
    //             }
    //         })
    // }

    // NEW CODE: TWo api calling simultaneously for deliver services, belivering delovering service movin them to SPM
    const onDeliverServicesBtnClick = async () => {
        try {
            setIsLoading(true);
            
            const allSelectedServices = selectedServices.join(",");
            const result = await api.updateConfirmationFlagLPM(allSelectedServices, true);
            console.log(result, ">>>>>>result");
            
            setIsLoading(false);
            
            if (result.status === 200) {
                // Prepare payload for the second API call
                const payload = {
                    nResourceInstanceId: selectedServices,
                    refCurrentState: 'Delivered'
                };
                
                setIsLoading(true);
                
                try {
                    const { data } = await api.deliverBulkServiceData(payload);
                    
                    if (data) {
                        console.log("Data", data.Message);
                        toast(String(data.Message), {
                            autoClose: 5000,
                            type: toast.TYPE.SUCCESS,
                        });
                        getTableData(tableInstance, false);
                        setSelectedServices([]);
                    }
                } catch (error) {
                    if (error.response?.data?.error) {
                        toast("Services cannot be delivered as some services are still in LPM.", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response?.data?.message) {
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else {
                        toast("Internal server error", {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                } finally {
                    setIsLoading(false);
                }
            }
        } catch (err) {
            console.error("Error in onDeliverServicesBtnClick:", err);
            setIsLoading(false);
            toast("Something went wrong. Please try again.", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }
    };

    const getTableData = async (instance, flag = false) => {
        if (!instance) return;
        if (!tableInstance) setTableInstance(instance);

        try {
            const { page } = instance.state ?? { page: 0 };
            let icurrentPage = page;
            if (!flag && isNaN(icurrentPage)) return;
            const pageSize = selectedPageSizeOption.value;

            if (flag || isNaN(icurrentPage)) {
                icurrentPage = 0;
            }

            let servicestatusListtemp2 = [];
        selectedServiceStatusListForFilter.map((e) => {
            if (e.value != "*") {
                servicestatusListtemp2.push(e.value);
            }
        });
        const serviceStatusList = servicestatusListtemp2;

        let serviceStatusFilter = [];
        serviceStatusList.map((e) => {
            if (e === "Willing to Pay") {
                serviceStatusFilter.push("Ready For Progression:Partner");
                serviceStatusFilter.push("Partial/ Full Payment Pending");
            }
            else if (e === "Payment Received") {
                serviceStatusFilter.push("Payment Confirmed By Partner");
                serviceStatusFilter.push("Ready For Progression:deAsra");
            }
            else {
                serviceStatusFilter.push(e);
            }
        });
        const statusList = serviceStatusFilter;

            let ResourceNamesTemp = []
            selectedOppTitle.map((e) => {
                if(e.value != "*"){
                    ResourceNamesTemp.push(e.value)
                }
            })


            let filterParameters = {
                page_no: icurrentPage + 1,
                page_size: pageSize,
                // pagination: true,
                // SP_email: 'archana.sapre@mailinator.com'
            };

            if(selectedOppType){
                filterParameters.service_codes = [selectedOppType.value]
            }
    
            if(selectedOppTitle){
                filterParameters.ResourceName = ResourceNamesTemp
            }

            // if (selectedOppTitle.length > 0) {
            //     filterParameters.sServiceDisplayName = processFilters(selectedOppTitle) 
            // }

            if(confirmationChecked){
                filterParameters.bConfirmation_tag = confirmationChecked
            }
            
            if (statusList.length) {
                filterParameters.statusList = statusList;
            }

            if(selectedBusinessSector.length > 0){
                filterParameters.sBusinessSector = processFilters(selectedBusinessSector)
            }

            if(selectedBusinessCity.length > 0){
                filterParameters.sBusinessCity = processFilters(selectedBusinessCity)
            }

            if(selectedTagOption.length > 0){
                filterParameters.sTag = processFilters(selectedTagOption)
            }

            if (searchFields.sContactNumber !== "") {
                filterParameters.search_value = searchFields.sContactNumber
            }

            if (currentPage != icurrentPage) {
                setSelectedServices([]);
            }

            setIsLoading(true);
            const { tempServices } = api.getExternalPartnerUmcServices(filterParameters).then(({ data }) => {
                setIsLoading(false);
                if (data) {
                    // const { results, count } = data;
                    setcurrentPage(icurrentPage);
                    setPages(data.total_pages);
                    setPageSize(pageSize);
                    setDisplayRecordCount({...displayRecordCount, count: data?.total_count})


                    let tempLPMServiceList = data.ServiceRequests.map((x) => {
                        x.custrefSRState = x.refSRState;
                        x.custsSRCancellationReason = x.sSRCancellationReason;
                        x.custssSRCancellationReasonOtherDescription = x.sSRCancellationReasonOtherDescription;
                        x.custsNotesHH = null;
                        x.custdtFollowupOn = null;
                        x.custsFollowupNotes = null;
                        x.serviceFrom = "LPM";
                        x.custOtherServiceInfo = x.sOtherServicesInfo;
                        x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                        x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                        x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                        x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                        x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                        x.custsCallStatus = x.sCallStatus;
                        x.custsUpdateNoteForAllServicesInPackage = false;
                        x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                        x.custbOfflineMeet = x.bOfflineMeet;
                        return x;
                    });
    
                    let tempSPMerviceList = data.Services.map((x) => {
                        x.custrefSRState = x.refCurrentState.sServiceState;
                        x.custsSRCancellationReason = x.sServiceCancellationReason;
                        x.custssSRCancellationReasonOtherDescription = x.sServiceCancellationReasonOtherDescription;
                        x.custsNotesHH = null;
                        x.custdtFollowupOn = null;
                        x.custsFollowupNotes = null;
                        x.serviceFrom = "SPM";
                        x.OtherServiceInfo = null;
                        x.custOtherServiceInfo = x.sOtherServicesInfo;
                        x.custfGovtCharges = x.ext_sp_charges ? (x.ext_sp_charges.fGovtCharges) : (null);
                        x.custfAffiliateFees = x.ext_sp_charges ? (x.ext_sp_charges.fAffiliateFees) : (null);
                        x.custfProfessionalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fProfessionalCharges) : (null);
                        x.custfTotalCharges = x.ext_sp_charges ? (x.ext_sp_charges.fTotalCharges) : (null);
                        x.custChargesid = x.ext_sp_charges ? (x.ext_sp_charges.id) : (null);
                        x.custsCallStatus = x.sCallStatus;
                        x.custsUpdateNoteForAllServicesInPackage = false;
                        x.custbNeedToTalkToSP = x.bNeedToTalkToSP;
                        x.custbOfflineMeet = x.bOfflineMeet;
                        return x;
                    });

                    var masterAllServiceRequests = [...tempLPMServiceList, ...tempSPMerviceList];
                    let sortedServiceRequestsDesc = masterAllServiceRequests.sort((a, b) => {
                        return parseInt(b.nResourceInstanceId) - parseInt(a.nResourceInstanceId);
                    })

                    console.log("New Data", sortedServiceRequestsDesc)
                    setTableData(sortedServiceRequestsDesc)
                }
                else {
                    // toast("Something went wrong. Please contact Deasra Representative.", {
                    //     autoClose: 5000,
                    //     type: toast.TYPE.ERROR,
                    // });
                }
            })
        } catch (error) {
            setIsLoading(false);
            console.log(error)
            // toast("Internal Server Error", {
            //     autoClose: 5000,
            //     type: toast.TYPE.ERROR,
            // });
        }

    }

    const onSearchClick = () => {
        getTableData(tableInstance, true)
    }

    const onClearClick = () => {
        setSelectedOppType(null)
        setSelectedOppTitle([])
        setSelectedBusinessSector([])
        setSelectedBusinessCity([])
        setSelectedTagOption([])
        setSearchFields({
            sContactNumber: ""
        })
        setConfirmationChecked(false)
        setIsClearAction(true);
    }

    const onEnterRevenueClick = (ele) => {
        openRevenueModalisTrue()
        setResourceId(ele.nResourceInstanceId)
        setServiceDisplay(ele.sServiceDisplayName)
    }

    const onGenerateRevenueClick = () => {
        if(revenueAmount === "0") {
            toast("Revenue cannot be zero", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
        } else {
            setIsLoading(true)
            openRevenueModalisFalse()
            let payload = {
                nResourceInstanceId: resourceId,
                sServiceDisplayName: serviceDisplay,
                nRevenue: revenueAmount
            }
    
            const {tempAddRevenueUmc} = api.addRevenueUmc(payload)
            .then(({data}) => {
                setIsLoading(false)
                toast("Revenue Updated Successfully", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                console.log(data)
                setRevenueAmount('')
                getTableData(tableInstance, false)
            })
        }
        
    }

    useEffect(() => {
        getTableData(tableInstance, true)
    }, [selectedPageSizeOption])

    useEffect(() => {
        const { temp } = api.getCancellationReasons().then(({ data }) => {
			console.log("cancellationRason", data);
			let temp1 = data.map((e) => {
				return { value: e.sReason, label: e.sReason };
			});
			setCancellationReasonDropdownOptions(temp1);
		});
    }, [])

    const fetchServiceRequests = (instance, flag) => {
        getTableData(instance, flag);
    };
    

    const onOppTypeChange = (option) => {
        // setSelectedOppTitle(null)
        if(showWhatsappMessagesModal){
            setSelectedOppTypeWpModal(option)
        } else{
            setSelectedOppType(option)
        }
        getOppTitleNames(option)
    }

    // const onOppTitleChange = (option) => {
    //     setSelectedOppTitle(option)
    // }

    const openRevenueModalisTrue = () => {
        setRevenueModal(true)
    }

    const openRevenueModalisFalse = () => {
        setRevenueModal(false)
    }

    useEffect(() => {
        const { tempOppTypeServiceNames } = api.oppTypeListApi()
        .then(({data}) => {
            const formattedData = data.results.map((ele) => ({
                value: ele.sServiceCode,
                label: ele.sServiceName
            }))
            setOppTypeNameList(formattedData);
            setOppTypeNameListWpModal(formattedData);
        })

        const { tempBusinessSectorListApi } = api.businessSectorListApi()
            .then(({ data }) => {
                console.log("Business Sector", data)
                const formattedData = data.data
                .filter(ele => ele.sBusinessSector !== null)
                .map((ele) => ({
                    value: ele.sBusinessSector,
                    label: ele.sBusinessSector
                }))
                setBusinessSectorList(formattedData)
            })

            const { tempBusinessCityListApi } = api.businessCityListApi()
            .then(({data}) => {
                const formatttedData = data.data
                .map((ele) => ({
                    value: ele.sBusinessCity,
                    label: ele.sBusinessCity
                }))
                setBusinessCityList(formatttedData)
            })
    }, [])

    const getOppTitleNames = (ele) => {
        // let filterParameters = {}

        // if(selectedOppType !== null) {
        //     filterParameters.OpportunityType = selectedOppType.value
        // }
        if(showWhatsappMessagesModal){
            if(ele) {
                const { tempOppTitleNames } = api.oppTitleListApi({
                    OpportunityType: ele.value
                })
                .then(({data}) => {
                    const formattedData = data.results.map((ele) => ({
                        value: ele.ResourceName,
                        label: ele.ResourceName
                    }))
                    setOppTitleNameListWpModal(formattedData)
                })
            } else {
                setOppTitleNameListWpModal([]);
                setSelectedOppTitleWpModal([]);
            }
        } else {
            if(ele) {
                const { tempOppTitleNames } = api.oppTitleListApi({
                    OpportunityType: ele.value
                })
                .then(({data}) => {
                    const formattedData = data.results.map((ele) => ({
                        value: ele.ResourceName,
                        label: ele.ResourceName
                    }))
                    setOppTitleNameList(formattedData)
                })
            } else {
                setOppTitleNameList([])
                setSelectedOppTitle([])
            }
        }
    }

    const toggleAllOppTitle = () => {
        console.log(">>>toggle all opp titlw got clicekd");

        if(showWhatsappMessagesModal){
            if (selectedOppTitleWpModal?.length != oppTitleNameListWpModal?.length && selectedOppTitleWpModal?.length != (oppTitleNameListWpModal?.length + 1)) {
                let temp = []
          
                if (selectedOppTitleWpModal?.includes({ label: "All", value: "*" })) {
                  temp = selectedOppTitleWpModal
                } else {
                  temp = [{ label: "All", value: '*' }]
                }
          
                let tempSR = oppTitleNameListWpModal.map((e) => {
                  if (!temp.includes(e)) {
                    temp = temp.concat(e)
                  }
                  return e
                })
                setOppTitleNameListWpModal(tempSR);
                setSelectedOppTitleWpModal(temp)
              //   getTagsDropdown(processFilters(temp))
            } else {
            setSelectedOppTitleWpModal([])
            //   getTagsDropdown(null)
            }
        } else{
            if (selectedOppTitle.length != oppTitleNameList.length && selectedOppTitle.length != (oppTitleNameList.length + 1)) {
                let temp = []
          
                if (selectedOppTitle.includes({ label: "All", value: "*" })) {
                  temp = selectedOppTitle
                } else {
                  temp = [{ label: "All", value: '*' }]
                }
          
                let tempSR = oppTitleNameList.map((e) => {
                  if (!temp.includes(e)) {
                    temp = temp.concat(e)
                  }
                  return e
                })
                setOppTitleNameList(tempSR)
                setSelectedOppTitle(temp)
              //   getTagsDropdown(processFilters(temp))
            } else {
            setSelectedOppTitle([])
            //   getTagsDropdown(null)
            }
        }
    }

    const onOppTitleChange = (options) => {
        if(showWhatsappMessagesModal){
            const isAllSelected = options.some((opt) => opt.value === "*");

            if (isAllSelected) {
                setSelectedOppTitleWpModal([{ value: "*", label: "All" }]);
                // getTagsDropdown(processFilters(options))
            } else {
                setSelectedOppTitleWpModal(options.filter((opt) => opt.value !== "*"));
                // getTagsDropdown(processFilters(options))
            }
        } else {
            const isAllSelected = options.some((opt) => opt.value === "*");
            if (isAllSelected) {
                setSelectedOppTitle([{ value: "*", label: "All" }]);
                // getTagsDropdown(processFilters(options))
            } else {
                setSelectedOppTitle(options.filter((opt) => opt.value !== "*"));
                // getTagsDropdown(processFilters(options))
            }
        }
    }

    const handleChangeState = () => {
        let cancellation_Reason, OtherDescription;
        if(selectedCancellationReason) {
            cancellation_Reason = selectedCancellationReason.value;
				if (cancellation_Reason !== "Other") OtherDescription = null;
				else OtherDescription = cancellationReasonOtherDescription;
        }
        setIsLoading(true)
        setShowCancellationReasonModal(false)
        let payload = {
            nResourceInstanceId: selectedServices,
            refCurrentState: "Cancelled",
            sServiceCancellationReason: cancellation_Reason,
            sOtherReason: OtherDescription
        }

        const {tempCancelBulkServices} = api.cancelBulkServiceData(payload)
        .then(({data}) => {
            if(data){
                setIsLoading(false)
                toast(String("Services Cancelled Successfully"), {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                });
                setSelectedCancellationReason()
                setCancellationReasonOtherDescription()
                getTableData(tableInstance, false)
                setSelectedServices([])
            }
        })
    }

    const calculateEnableOtherDescriptionTextbox = () => {
		if (selectedCancellationReason && selectedCancellationReason.value === "Other") {
			setEnableOtherDescriptionTextbox(true);
		}
		else {
			setEnableOtherDescriptionTextbox(false);
		}
	};

	useEffect(() => {
		calculateEnableOtherDescriptionTextbox();
	}, [selectedCancellationReason]);

    const processFilters = (filter) => {
        let filterNames = ""
        if (filter.length > 1) {
            filterNames = filter.map(city => city.value).join(", ");
        } else if (filter.length === 1) {
            filterNames = filter[0].value;
        }

        return filterNames
    }

    const handleCatalogueClick = (ele) => {
        setIsLoading(true)
        let payload = {
            api_key: "r54B?rHXUE7v%$9t",
            user_id: ele._original.nUserId
        }

        const { tempCataloguelinkData } = api.catalogueLinkApi(payload)
            .then(({ data }) => {
                console.log("Link", data)
                if (data.data !== null) {
                    window.open(data.data.catalogue_url, "_blank");
                    setIsLoading(false)
                }
            })
    }
    
    // Handle send cancellation Message Function
    const handleSendCancellationMessage = () => {
        // console.log(">>>>>Cancellation Message Button Clicked");
        setIsLoading(true)

        let payload = {"nResourceInstanceId": selectedServices}
        api.sendCancellationMessage(payload).then(({data}) => {
            if(data){
                toast("Whatsapp message sent successfully", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                })

                setSelectedServices([]);
            }

            setIsLoading(false)
        })
    }

    //===== View Whatsapp Message Related Function and States ====//
    const [showWhatsappMessagesModal, setShowWhatsappMessagesModal] = useState(false);
    const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
    const [wpMessageDisplayRecordCount, setWpMessageDisplayRecordCount] = useState({displayCount: true, count: 0})
    const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
    const [wpMessagepages, setWpMessagePages] = useState(0);
    const [wpMessagePageSize, setWpMessagePageSize] = useState(10);
    const [viewMessagePageSizeOptions, setViewMessagePageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedViewMessagePageSizeOption, setSelectedViewMessagePageSizeOption] = useState({
        value: "10",
        label: "10",
    });

    const [oppTypeNameListWpModal, setOppTypeNameListWpModal] = useState(null);
    const [selectedOppTypeWpModal, setSelectedOppTypeWpModal] = useState(null);

    const [oppTitleNameListWpModal, setOppTitleNameListWpModal] = useState([])
    const [selectedOppTitleWpModal, setSelectedOppTitleWpModal] = useState([]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [messageTypeOptions, setMessageTypeOptions] = useState(
        [
            {label: "New Opportunity", value:"Opportunity"},
            {label: "Cancellation", value:"Cancellation"}
        ]
    )
    const [selectedMessageType, setSelectedMessageType] = useState(null);

    const [wpCancellationMessageIsLoading, setWpCancellationMessageIsLoading] = useState(false);
    const [clearActionWpModalData, setClearActionWpModalData] = useState(false);

    const toggleShowWhatsappMessagesModal = () => {
        setShowWhatsappMessagesModal(!showWhatsappMessagesModal);

        setSelectedOppTypeWpModal(null);
        setSelectedOppTitleWpModal([]);
        setFromDate(null);
        setToDate(null);
        // setSelectedOppTitle([]);
        // setOppTitleNameList([]);
    }

    

    useEffect(()=>{
        console.log(">>>useEffect to get cancellation message ran");
        
        let payloads = {
            page: wpMessagecurrentPage+1,
            page_size: selectedViewMessagePageSizeOption?.value,
            pagination: true,
            sMessageType: "Opportunity"
        }

        console.log(payloads, ">>>>>>payloads");
        

        if(showWhatsappMessagesModal){
            getWhatsappCancellationMessages();
        }
        setClearActionWpModalData(false);
    }, [showWhatsappMessagesModal, clearActionWpModalData ])

    useEffect(()=>{
        if(toDate < fromDate){
            toast(String("From-Date cant be greater than To-Date"), {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
        }else {
            {
                let selectedOppTypeWp = [];
                let selectedOppTitleWp = [];
                let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
                let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
    
                selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
                selectedOppTitleWpModal?.map(titleObj => {
                    selectedOppTitleWp.push(titleObj?.value);
                })
    
                let data = {
                    page: wpMessagecurrentPage+1,
                    page_size: selectedViewMessagePageSizeOption?.value,
                    pagination: true,
                    sMessageType: selectedMessageType?.value,
                    sServiceCode:[...selectedOppTypeWp],
                    sServiceDisplayName: [...selectedOppTitleWp],
                    fromDate: formattedFromDate,
                    toDate: adjustedToDate(formattedToDate)
                }
        
                console.log(data, ">> data on search click");
                getWhatsappCancellationMessages(data);
            }
        }
    }, [ wpMessagecurrentPage, selectedViewMessagePageSizeOption])

    let getWhatsappCancellationMessages = async(data) =>{
        try{
            setWpCancellationMessageIsLoading(true);
            
            let response = await api.getWhatsappMessageSentForCancellation(data);
            // console.log(response, ">>> whatsapp cancellation message responseeeee");
            // console.log(response.data.count, ">>>>response count");
            
            // console.log(response?.data?.results, ">>> whatsapp cancellation message response data");
            setSentWhatsappCancellationMessages(response?.data?.results);
            // setWpMessagePageSize(response.data.length);

            let totalCounts = response?.data?.count;
            // console.log(totalCounts, ">>>>totalCounts");
            
            let totalPages = Math.ceil(totalCounts/selectedViewMessagePageSizeOption?.value);
            // console.log(totalPages, ">>>>>totalPages");
            
            setWpMessagePages(totalPages)

            
            // toast(String("Successfully received the "), {
            //     autoClose: 5000,
            //     type: toast.TYPE.SUCCESS,
            // });

            setWpCancellationMessageIsLoading(false)
        } catch(err){
            console.log(err)
            setWpCancellationMessageIsLoading(false)
        }
    }

    const searchFilterWpSendCacellationMessages = () =>{
        console.log(wpMessagecurrentPage, ">>>>wpMessagecurrentPage");
        console.log(selectedViewMessagePageSizeOption, ">>>>selectedViewMessagePageSizeOption");
        console.log("pagination: true");
        console.log("sMessageType");
        
        
        
        console.log(selectedOppTypeWpModal, ">>>selectedOppTypeWpModal");
        console.log(selectedOppTitleWpModal, ">>>selectedOppTitleWpModal");
        console.log(fromDate, ">>>fromDate");
        console.log(toDate, ">>>toDate");
        console.log(toDate > fromDate, ">>>is two date greater than from date")
        console.log(selectedMessageType, ">>>> Selected Message Type");

        if(wpMessagecurrentPage){
            setwpMessagecurrentPage(0);
        }else {
            if(toDate < fromDate){
                toast(String("From-Date cant be greater than To-Date"), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }else {
                {
                    let selectedOppTypeWp = [];
                    let selectedOppTitleWp = [];
                    let formattedFromDate = fromDate? new Date(fromDate).toISOString().split(".")[0] + ".000Z" : "";
                    let formattedToDate = toDate ? new Date(toDate).toISOString().split(".")[0] + ".000Z": "";
        
                    selectedOppTypeWp?.push(selectedOppTypeWpModal?.value);
                    selectedOppTitleWpModal?.map(titleObj => {
                        selectedOppTitleWp.push(titleObj?.value);
                    })
        
                    let data = {
                        page: wpMessagecurrentPage+1,
                        page_size: selectedViewMessagePageSizeOption?.value,
                        pagination: true,
                        sMessageType: selectedMessageType?.value,
                        sServiceCode:[...selectedOppTypeWp],
                        sServiceDisplayName: [...selectedOppTitleWp],
                        fromDate: formattedFromDate,
                        toDate: adjustedToDate(formattedToDate)
                    }
            
                    console.log(data, ">> data on search click");
                    getWhatsappCancellationMessages(data);
                }
            }
        }
    }

    const clearSearchFilterWpCancellationMessages = () => {
        setClearActionWpModalData(true);
        setSelectedOppTypeWpModal(null);
        setSelectedOppTitleWpModal([]);
        setOppTitleNameListWpModal([]);
        
        setFromDate(null);
        setToDate(null);
        setSelectedMessageType(null);
        setwpMessagecurrentPage(0)
    }

    const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

    const handleFromDate = (date) =>{
        if(toDate && toDate<date){
            setToDate(null)
        }
        setFromDate(date)
    }

    const handleToDate = (date) => {
        if(fromDate && fromDate > date){
            setFromDate(null)
        }
        setToDate(date)
    }

    const handleViewMessageOnFetchData = (state) =>{
        console.log(state, ">>>>state on handleViewMessageOnFetchData");
        setwpMessagecurrentPage(state?.page ? state?.page : 0);
    }

    const onMessageTypeChange = (option) =>{
        // console.log(option, ">>>>option of message type");
        setSelectedMessageType(option)
    }

    // States and functions for filter by status
    /*Filter modal callbacks */
    const [showFilterModal, setShowFilterModal] = useState(false);
    const toggleFilterModal = () => {
        setShowFilterModal(!showFilterModal);
    };
    const handleViewFilterModal = (original) => {
        toggleFilterModal();
    };
    /*End */

    // service status strates in filter modal
    const [serviceStatusNameListForFilter, setServiceStatusNameListForFilter] = useState([]);
    const [selectedServiceStatusListForFilter, setSelectedServiceStatusListForFilter] = useState([]);
    const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
    const [serviceStatusList, setServiceStatusList] = useState(statusArray);

    let MainStatus = [
        {
            checked: false,
            label: "Requested",
            id: "Requested",
            code: "Requested",
        },
        {
            checked: false,
            label: "Eligible",
            id: "Eligible",
            code: "Eligible",
        },
        {
            checked: false,
            label: "Quotation Sent",
            id: "Quotation Sent",
            code: "Quotation Sent",
        },
        {
            checked: false,
            label: "Willing to Pay",
            id: "Willing to Pay",
            code: "Willing to Pay",
        },
        {
            checked: false,
            label: "Payment Received",
            id: "Payment Received",
            code: "Payment Received",
        },
        {
            checked: false,
            label: "Awaiting for information/Documents",
            id: "Awaiting for information/Documents",
            code: "Awaiting for information/Documents",
        },
        {
            checked: false,
            label: "Service Delivery Started",
            id: "Service Delivery Started",
            code: "Service Delivery Started",
        },
        {
            checked: false,
            label: "Service deliverables ready",
            id: "Service deliverables ready",
            code: "Service deliverables ready",
        },
        {
            checked: false,
            label: "Full Payment Requested",
            id: "Full Payment Requested",
            code: "Full Payment Requested",
        },
        {
            checked: false,
            label: "Full Payment Received",
            id: "Full Payment Received",
            code: "Full Payment Received",
        },
        {
            checked: false,
            label: "Delivered",
            id: "Delivered",
            code: "Delivered",
        },
        {
            checked: false,
            label: "Cancelled",
            id: "Cancelled",
            code: "Cancelled",
        },
        {
            checked: false,
            label: "Refunded",
            id: "Refunded",
            code: "Refunded",
        },
    ]
    
    var statusArray = MainStatus;

    useEffect(()=>{
        const serviceStatusNameForFilter = [];
        MainStatus.map((x) => {
            serviceStatusNameForFilter.push({
                label: x.label,
                value: x.code,
                id: x.id,
            });
        });

        setServiceStatusNameListForFilter(serviceStatusNameForFilter);
    }, [])

    const toggleAllForServiceStatusFilter = () => {
        let temp = [];

        if (selectedServiceStatusListForFilter.length != serviceStatusNameListForFilter.length && selectedServiceStatusListForFilter.length != (serviceStatusNameListForFilter.length + 1)) {
            if (selectedServiceStatusListForFilter.includes({ label: "All", value: "*" })) {
                temp = selectedServiceStatusListForFilter;
            }
            else {
                temp = [{ label: "All", value: "*" }];
            }

            let tempSR = serviceStatusNameListForFilter.map((e) => {
                if (!temp.includes(e)) {
                    temp = temp.concat(e);
                }
                return e;
            });
            setSelectedServiceStatusListForFilter(temp);
            setServiceStatusNameListForFilter(tempSR);
            //getExternalPartnerServices(tableInstance);
        }
        else {
            setSelectedServiceStatusListForFilter([]);
            //getExternalPartnerServices(tableInstance);
        }
    };

    const toggleSelectionForServiceStatusFilter = (e) => {
        setSelectedServiceStatusListForFilter(e);
    };
    
    const toggleAllForFilter = () => {
        let temp = [];

        // if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length != (serviceNameListForFilter.length + 1)) {
        //     if (selectedServiceNameListForFilter.includes({ label: "All", value: "*" })) {
        //         temp = selectedServiceNameListForFilter;
        //     }
        //     else {
        //         temp = [{ label: "All", value: "*" }];
        //     }

        //     let tempSR = serviceNameListForFilter.map((e) => {
        //         if (!temp.includes(e)) {
        //             temp = temp.concat(e);
        //         }
        //         return e;
        //     });
        //     setSelectedServiceNameListForFilter(temp);
        //     setServiceNameListForFilter(tempSR);
        //     //getExternalPartnerServices(tableInstance);
        // }
        // else {
        //     setSelectedServiceNameListForFilter([]);
        //     //getExternalPartnerServices(tableInstance);
        // }
    };

    const toggleSelectionForFilter = (e) => {
        // setSelectedServiceNameListForFilter(e);
    };

    const handleSearchClick = async () => {
        if (showFilterModal) {
            toggleFilterModal();
        }
        // setSelectedServiceForEdit();
        // setSelectedSecondServiceForEdit();
        // setExpandedChange({});
        // if(confirmationChecked){
        //      getFilterDataExternalService(tableInstance, true)
        // } else {
            // getExternalPartnerServices(tableInstance, true);
            getTableData(tableInstance, true)
        // }
        
        //refreshTable();
    };

    const handleClearFilterSearch = () => {
        let tempStatus = serviceStatusList?.map((x) => {
            x.checked = false;
            return x;
        });
        // setSelectedServiceNameListForFilter([]);
        // setSelectedServiceStatus([]);
        setServiceStatusList(tempStatus);
        // setSearchTerm("");
        // setfromDate("");
        // settoDate("");
        // setSelectedRequestedaCallBackOption(null/*{
        //     value: "all",
        //     label: "All",
        // }*/);
        // setSelectedNeedToTalkToSPOption(null/*{
        //     value: "all",
        //     label: "All",
        // }*/);
        // setSelectedRequestedByOption(null/*{
        //     value: "all",
        //     label: "All",
        // }*/);
        // setselectedCallStatusOptionForFilter(null/*{
        //     value: "all",
        //     label: "All",
        // }*/);
        // setselectedofflinemeetoptionsForFilter(null);

        // setSelectedPackageNameListForFilter(null);
        // // setselectedofflinemeetoptions(null);
        // //setExpandedChange({});
        setSelectedServiceStatusListForFilter([]);
        // setRequestWithinTAT('');
    };

    
    

    // console.log(selectedServiceStatusListForFilter, ">>>>selectedServiceStatusListForFilter");
    

    // console.log(fromDate, ">>>>fromDate");
    // console.log(toDate, ">>>toDate");
    // console.log(selectedOppTypeWpModal, ">>>>selectedOppTypeWpModal");
    // console.log(selectedOppTitleWpModal, ">>>>selectedOppTitleWpModal");
    console.log(sentWhatsappCancellationMessages, ">>>>sentWhatsappCancellationMessages");
    console.log(wpMessageDisplayRecordCount, ">>>>wpMessageDisplayRecordCount");
    console.log(wpMessagecurrentPage, ">>>>wpMessagecurrentPage");
    console.log(wpMessagepages, ">>>>>wpMessagepages");
    console.log(wpMessagePageSize, ">>>>>wpMessagePageSize");
    console.log(selectedViewMessagePageSizeOption, ">>>>>selectedViewMessagePageSizeOption");

    // const [sentWhatsappCancellationMessages, setSentWhatsappCancellationMessages] = useState([]);
    // const [wpMessageDisplayRecordCount, setWpMessageDisplayRecordCount] = useState({displayCount: true, count: 0})
    // const [wpMessagecurrentPage, setwpMessagecurrentPage] = useState(0);
    // const [wpMessagepages, setWpMessagePages] = useState(0);
    // const [wpMessagePageSize, setWpMessagePageSize] = useState(10);
    
  return (
    <div className={`${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="center-screen" />}

          <Modal isOpen={revenueModal}>
              <ModalContent className="general-modal">
                  <div className="modal-header" style={{
                      backgroundColor: '#76287C',
                      color: '#fff'
                  }}>
                      <span className="modal-title">Enter Revenue</span>
                      <img
                          alt="close"
                          id="Close"
                          src={close_modal}
                          className="close modal-close"
                          onClick={openRevenueModalisFalse}
                      />
                  </div>

                  <div className="modal-body">
                      {/* <div className="row">
                          <div className="col m-2">
                              <span className="spled-colored-label">Service Price</span> <span className="spled-black-text">: {serviceRequestReadOnlyData.fAmountFirst}</span>
                          </div>
                      </div> */}
                      <div className="row mt-2">
                          <div className="col-12 w-100">
                              <input type="number" placeholder="Enter Revenue Generated (for eg: 1000)" style={{
                                  width: "-webkit-fill-available",
                                  height: '45px'
                              }}
                              min={0}
                                  onKeyDown={(e) => {
                                      const invalidChars = ['=', '-', '+', 'e'];
                                      if (invalidChars.includes(e.key)) {
                                          e.preventDefault();
                                      }
                                  }}
                                  onChange={(e) => setRevenueAmount(e.target.value)} />
                          </div>
                      </div>
                      <div className="row m-2">
                          <div className="offset-3 col-6">
                              <Button 
                              onClick={onGenerateRevenueClick}
                              >Update Revenue</Button>
                          </div>
                      </div>
                  </div>
              </ModalContent>
          </Modal>

          <div className="row" style={{
            //   height: "75px",
              marginBottom: '15px',
              boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)"
          }} >
            
              <div className='col-12'>
                <div className='row'>
                    <div className="col-2 ml-4 mt-3 conv-pl25 spled-container conv-zindex" style={{backgroundColor:""}}>
                        <button className="con-btn-filled conv-pl15 conv-pr15 conv-font14" style={{ marginLeft: '15px' }}
                            onClick={(e) => { handleViewFilterModal() }} 
                        >
                            <img
                                alt=""
                                src={ic_filter}
                                height={"15px"}
                                width={"15px"}
                                className="conv-mr10"
                            />
                            Filter By
                        </button>
                </div>
                </div>
              </div>
            
              <div className="col-12">
                <div className="row">
                <div className="col-2 ml-5 mt-3 spled-container conv-zindex">
                  <div className="">
                      <Select
                          options={oppTypeNameList}
                          onChange={onOppTypeChange}
                          value={selectedOppType}
                          placeholder="Select Opp Type"
                          isClearable
                      />
                  </div>
              </div>

              <div className="col-2 mt-3 spled-container conv-zindex">
                  <div className="">
                      {/* <Select
                          options={oppTitleNameList}
                            onChange={onOppTitleChange}
                            value={selectedOppTitle}
                          placeholder="Select Opp Title"
                          isClearable
                      /> */}
                      <MultiSelectAll
                                  toggleAll={toggleAllOppTitle}
                                  toggleSelection={onOppTitleChange}
                                  checkboxItemsList={oppTitleNameList}
                                  selectedOptions={selectedOppTitle}
                                  placeholderButtonLabel="Select Opp Title"
                              />
                  </div>
              </div>

              <div className="col-2 mt-3 spled-container conv-zindex">
                  <div className="">
                      {/* <Select
                        //   className="reportInput"
                          options={businessSectorList}
                          placeholder="Select Sector"
                          onChange={onBusinessSectorChange}
                          value={selectedBusinessSector}
                          isClearable
                      /> */}
                              <MultiSelectAll
                                  toggleAll={toggleAllSector}
                                  toggleSelection={onBusinessSectorChange}
                                  checkboxItemsList={businessSectorList}
                                  selectedOptions={selectedBusinessSector}
                                  placeholderButtonLabel="Select Sector"
                              />
                  </div>
              </div>
              <div className="col-2 spled-container mt-3 conv-zindex">
                      {/* <Select
                        //   className="reportInput"
                          options={tagsDropDownList}
                          placeholder="Select Tag"
                          onChange={onTagChange}
                          value={selectedTagOption}
                          isClearable
                      /> */}
                          <MultiSelectAll
                              toggleAll={toggleAllTags}
                              toggleSelection={onTagChange}
                              checkboxItemsList={tagsDropDownList}
                              selectedOptions={selectedTagOption}
                              placeholderButtonLabel="Select Tags"
                          />
                  </div>
                  <div className="col-2 spled-container mt-3 conv-zindex">
                      {/* <Select
                        //   className="reportInput"
                          options={businessCityList}
                          placeholder="Select City"
                          onChange={onBusinessCityChange}
                          value={selectedBusinessCity}
                          isClearable
                      /> */}
                          <MultiSelectAll
                              toggleAll={toggleAllBusinessCity}
                              toggleSelection={onBusinessCityChange}
                              checkboxItemsList={businessCityList}
                              selectedOptions={selectedBusinessCity}
                              placeholderButtonLabel="Select City"
                          />
                  </div>

              {/* <div className="col-2 mt-3 spled-container conv-zindex"> */}
                  <div className='mt-3 spled-container conv-zindex'>
                      <Button style={{
                          margin: 0,
                          marginLeft: '10px',
                          height: '37px'
                      }}
                          onClick={onSearchClick}
                          // disabled={!props.selectedExtPartner}
                          className="con-btn-filled">Search</Button>
                  </div>
              {/* </div> */}
                </div>
              </div>


              {/* <div className="col-3 mt-2 spled-container"  style={{
                    //   justifyContent: 'flex-end'
                    marginLeft: '47px'
                  }}>
                            <ControlledInput
                                className="reportInputUmc"
                                name="sContactNumber"
                                placeholder="Contact Number"
                                value={searchFields.sContactNumber}
                                onChange={({ target: { name, value } }) => handleChange(name, value)}
                                //   onKeyDown={(e) => {
                                //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                //       if (
                                //           !/^\d$/.test(e.key) &&
                                //           !allowedKeys.includes(e.key) &&
                                //           e.key !== "Tab"
                                //       ) {
                                //           e.preventDefault();
                                //       }
                                //   }}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                    const ctrlKeys = ["a", "c", "v", "x"];

                                    if (
                                        !/^\d$/.test(e.key) && // Allow digits
                                        !allowedKeys.includes(e.key) && // Allow navigation keys
                                        !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div> */}

              
                  {/* <div className="col-3 d-flex align-items-center">
                      {
                          selectedServices.length > 0 ?
                              <button
                                  onClick={onDeliverServicesBtnClick}
                                  className="my-services-model-submit-btn ml-2 mt-2" style={{
                                      marginBottom: "15px"
                                  }}>
                                  Deliver Services</button>
                              :
                              <button className="my-services-model-submit-btn ml-2 mt-2" style={{
                                  marginBottom: "15px",
                                  opacity: "0.4",
                                  pointerEvents: "none",
                              }}>
                                  Deliver Services</button>

                      }
                      {
                          selectedServices.length > 0 ?
                              <button
                                  onClick={() => setShowCancellationReasonModal(true)}
                                  className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                      marginBottom: "15px"
                                  }}>
                                  Cancel Services</button>
                              :
                              <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                  marginBottom: "15px",
                                  opacity: "0.4",
                                  pointerEvents: "none",
                              }}>
                                  Cancel Services</button>

                      }
                  </div> */}

                  {/* Added Confirmation Received */}
                 {/* <div className="col-4 d-flex mt-3">
                            <div className="">
                                <Checkbox
                                    id={`checkbox3-completed`}
                                    checked={confirmationChecked}
                                    onChange={(e) => {
                                        e.stopPropagation();
                                        setConfirmationChecked(!confirmationChecked)
                                        // updateConfirmationFlagData(row.original)
                                        // props.getExternalPartnerServices()
                                    }}
                                    label={"Confirmation Received"}
                                // disabled={row.original.bConfirmation_tag}
                                ></Checkbox>
                            </div>
                    </div> */}

                 {/* Main Added Confirmation Received */}
              {/* <div className="col-2 mt-2 spled-container" style={{
                  // justifyContent: 'flex-end'
                  marginLeft: '33px',
                  display: "flex",
                  // alignItems:"center"
                  justifyContent: "space-between",
                  backgroundColor:""
              }}>
                 
                  <div className="col-5 d-flex" style={{backgroundColor:""}}>
                      <div className="">
                          <Checkbox
                              id={`checkbox3-completed`}
                              checked={confirmationChecked}
                              onChange={(e) => {
                                  e.stopPropagation();
                                  setConfirmationChecked(!confirmationChecked)
                                  // updateConfirmationFlagData(row.original)
                                  // props.getExternalPartnerServices()
                              }}
                              label={"Confirmation Received"}
                          // disabled={row.original.bConfirmation_tag}
                          ></Checkbox>
                      </div>
                  </div>
              </div> */}

              {/* <div className="col-8 d-flex align-items-center pl-4 ml-1">

                  <div className='mt-2' style={{ display: "flex" }}>
                      <ControlledInput
                          className="reportInputUmc"
                          name="sContactNumber"
                          placeholder="Contact Number"
                          value={searchFields.sContactNumber}
                          onChange={({ target: { name, value } }) => handleChange(name, value)}
                          // onKeyDown={(e) => {
                          //     const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                          //     if (
                          //         !/^\d$/.test(e.key) &&
                          //         !allowedKeys.includes(e.key) &&
                          //         e.key !== "Tab"
                          //     ) {
                          //         e.preventDefault();
                          //     }
                          // }}
                          onKeyDown={(e) => {
                              const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                              const ctrlKeys = ["a", "c", "v", "x"];

                              if (
                                  !/^\d$/.test(e.key) && // Allow digits
                                  !allowedKeys.includes(e.key) && // Allow navigation keys
                                  !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
                              ) {
                                  e.preventDefault();
                              }
                          }}
                          autoComplete="off"
                      />
                  </div>
                  {
                      selectedServices.length > 0 ?
                          <button
                              onClick={onDeliverServicesBtnClick}
                              className="my-services-model-submit-btn ml-2 mt-2" style={{
                                  marginBottom: "15px"
                              }}>
                              Deliver Services</button>
                          :
                          <button className="my-services-model-submit-btn ml-2 mt-2" style={{
                              marginBottom: "15px",
                              opacity: "0.4",
                              pointerEvents: "none",
                          }}>
                              Deliver Services</button>

                  }
                  {
                      selectedServices.length > 0 ?
                          <button
                              onClick={() => setShowCancellationReasonModal(true)}
                              className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                  marginBottom: "15px"
                              }}>
                              Cancel Services</button>
                          :
                          <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
                              marginBottom: "15px",
                              opacity: "0.4",
                              pointerEvents: "none",
                          }}>
                              Cancel Services</button>

                  }
              </div> */}

               <div className="col-2 mt-2 spled-container ml-5"  style={{
                    //   justifyContent: 'flex-end'
                    marginLeft: '15px',
                    backgroundColor:""
                  }}>
                            <ControlledInput
                                className="reportInputUmc"
                                name="sContactNumber"
                                placeholder="Contact Number"
                                value={searchFields.sContactNumber}
                                onChange={({ target: { name, value } }) => handleChange(name, value)}
                                //   onKeyDown={(e) => {
                                //       const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                                //       if (
                                //           !/^\d$/.test(e.key) &&
                                //           !allowedKeys.includes(e.key) &&
                                //           e.key !== "Tab"
                                //       ) {
                                //           e.preventDefault();
                                //       }
                                //   }}
                                onKeyDown={(e) => {
                                    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                                    const ctrlKeys = ["a", "c", "v", "x"];

                                    if (
                                        !/^\d$/.test(e.key) && // Allow digits
                                        !allowedKeys.includes(e.key) && // Allow navigation keys
                                        !(e.ctrlKey && ctrlKeys.includes(e.key.toLowerCase())) // Allow Ctrl combinations
                                    ) {
                                        e.preventDefault();
                                    }
                                }}
                                autoComplete="off"
                            />
                        </div>

                {/* <div className="col-6 d-flex align-items-center" style={{backgroundColor:"red", margin:"0px", padding:"0px",justifyContent:"space-between", paddingLeft:"9px", paddingRight:"13px"}}>
                      {
                          selectedServices.length > 0 ?
                              <button
                                  onClick={onDeliverServicesBtnClick}
                                  className="my-services-model-submit-btn ml-2 mt-2" style={{
                                      marginBottom: "15px"
                                  }}>
                                  Deliver Services</button>
                              :
                              <button className="my-services-model-submit-btn ml-2 mt-2" style={{
                                  marginBottom: "15px",
                                  opacity: "0.4",
                                  pointerEvents: "none",
                              }}>
                                  Deliver Services</button>

                      }
                      {
                          selectedServices.length > 0 ?
                              <button
                                  onClick={() => setShowCancellationReasonModal(true)}
                                  className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                      marginBottom: "15px"
                                  }}>
                                  Cancel Services</button>
                              :
                              <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                  marginBottom: "15px",
                                  opacity: "0.4",
                                  pointerEvents: "none",
                              }}>
                                  Cancel Services</button>

                      }


                    {
                        selectedServices.length > 0 ?
                            <button
                                onClick={() => handleSendCancellationMessage()}
                                className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                    marginBottom: "15px"
                                }}>
                                Send Cancellation Messge</button>
                            :
                            <button className="my-services-model-cancel-btn ml-2 mt-2" style={{
                                marginBottom: "15px",
                                opacity: "0.4",
                                pointerEvents: "none",
                            }}>
                                Send Cancellation Message</button>
                    }
                    {
                        <button
                        onClick={() => toggleShowWhatsappMessagesModal()}
                        className="my-services-model-cancel-btn ml-2 mt-2" style={{
                            marginBottom: "15px"
                        }}>
                            View Messages
                        </button>
                    }
                </div> */}

                <div
                className="col-6 d-flex align-items-center"
                style={{
                    backgroundColor: "",
                    margin: "0px",
                    padding: "0px",
                    justifyContent: "space-between",
                    paddingLeft: "7px",
                    paddingRight: "15px"
                }}
                >
                {
                    selectedServices.length > 0 ? (
                    <button
                        onClick={onDeliverServicesBtnClick}
                        className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
                        style={{
                        marginBottom: "15px",
                        maxWidth: "100%",
                        }}
                    >
                        Deliver Services
                    </button>
                    ) : (
                    <button
                        className="my-services-model-submit-btn ml-2 mt-2 flex-grow-1"
                        style={{
                        marginBottom: "15px",
                        opacity: "0.4",
                        pointerEvents: "none",
                        maxWidth: "100%",
                        }}
                    >
                        Deliver Services
                    </button>
                    )
                }
                {
                    selectedServices.length > 0 ? (
                    <button
                        onClick={() => setShowCancellationReasonModal(true)}
                        className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
                        style={{
                        marginBottom: "15px",
                        maxWidth: "100%",
                        }}
                    >
                        Cancel Services
                    </button>
                    ) : (
                    <button
                        className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
                        style={{
                        marginBottom: "15px",
                        opacity: "0.4",
                        pointerEvents: "none",
                        maxWidth: "100%",
                        }}
                    >
                        Cancel Services
                    </button>
                    )
                }
                {
                    selectedServices.length > 0 ? (
                    <button
                        onClick={() => handleSendCancellationMessage()}
                        className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
                        style={{
                        marginBottom: "15px",
                        maxWidth: "100%",
                        }}
                    >
                        Send Cancellation Message
                    </button>
                    ) : (
                    <button
                        className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
                        style={{
                        marginBottom: "15px",
                        opacity: "0.4",
                        pointerEvents: "none",
                        maxWidth: "100%",
                        }}
                    >
                        Send Cancellation Message
                    </button>
                    )
                }
                {
                    <button
                    onClick={() => toggleShowWhatsappMessagesModal()}
                    className="my-services-model-cancel-btn ml-2 mt-2 flex-grow-1"
                    style={{
                        marginBottom: "15px",
                        maxWidth: "100%",
                    }}
                    >
                    View Messages
                    </button>
                }
                </div>


              {/* <div className='col-2 mt-2 spled-container conv-zindex'>
                  <Button style={{
                      margin: 0,
                      marginLeft: '6px',
                      height: '37px',
                      display: 'none',
                      width: 100
                  }}
                      onClick={onClearClick}
                      // disabled={!props.selectedExtPartner}
                      className="con-btn-filled">Clear</Button>
              </div> */}

                <div className="col-2 mt-2 spled-container" style={{
                  // justifyContent: 'flex-end'
                //   marginLeft: '33px',
                  display: "flex",
                  // alignItems:"center"
                  justifyContent: "space-between",
                  backgroundColor:""
                }}>
                 
                  {/* <div className="col-5 d-flex" style={{backgroundColor:""}}>
                      <div className="">
                          <Checkbox
                              id={`checkbox3-completed`}
                              checked={confirmationChecked}
                              onChange={(e) => {
                                  e.stopPropagation();
                                  setConfirmationChecked(!confirmationChecked)
                                  // updateConfirmationFlagData(row.original)
                                  // props.getExternalPartnerServices()
                              }}
                              label={"Confirmation Received"}
                          // disabled={row.original.bConfirmation_tag}
                          ></Checkbox>
                      </div>
                  </div> */}
                </div>

                  <div className='mt-2 spled-container conv-zindex' style={{backgroundColor:""}}>
                      <Button style={{
                          margin: 0,
                          marginLeft: '10px',
                          height: '37px',
                          width: 100
                      }}
                          onClick={onClearClick}
                          // disabled={!props.selectedExtPartner}
                          className="con-btn-filled">Clear</Button>
                  </div>

                  

              
              
              {/* <div className="col-2 d-flex align-items-center" style={{
                  justifyContent: 'flex-end'
              }} >
                  {
                      selectedServiceRequests.length > 0 ?
                          <Button
                              onClick={openPaymentModalisTrue}
                              className="esp-inline-button ml-2 mt-2" style={{
                                  marginBottom: "15px"
                              }}>
                              Settle Payment</Button>
                          :
                          <Button className="esp-inline-button ml-2 mt-2" style={{
                              marginBottom: "15px",
                              opacity: "0.4",
                              pointerEvents: "none",
                          }}>
                              Settle Payment</Button>

                  }
              </div> */}
          </div>

          <ESPUmcReactTable 
            data={tableData}
            displayRecordCount={displayRecordCount}
            handleCatalogueClick={handleCatalogueClick}
            onEnterRevenueClick={onEnterRevenueClick}
            handleCheckboxChange={handleCheckboxChange}
            isSelected={isSelected}
            selectedServices={selectedServices}
            handleSelectAll={handleSelectAll}
            openRevenueModalisTrue={openRevenueModalisTrue}
            onFetchServiceRequests={fetchServiceRequests}
            pages={pages}
            pageSize={pageSize}
            page={currentPage}
            pageSizeOptions={pageSizeOptions}
            selectedPageSizeOption={selectedPageSizeOption}
            onPageSizeOptionChange={(option) => {
                setSelectedPageSizeOption(option);
            }}
          />

          {
              showCancellationReasonModal &&
              <CancellationReasonModal
                  isDisabled={enableCancelButtonFlag}
                  isOpen={showCancellationReasonModal}
                  toggleModal={toggleCancellationReasonModal}
                  cancellationReasonDropdownOptions={
                      cancellationReasonDropdownOptions
                  }
                  onSelectCancellationReason={setSelectedCancellationReason}
                  selectedCancellationReason={selectedCancellationReason}
                  enableOtherDescriptionTextbox={enableOtherDescriptionTextbox}
                  cancellationReasonOtherDescription={
                      cancellationReasonOtherDescription
                  }
                  onChangeCancellationReasonOtherDescription={(value) => {
                      setCancellationReasonOtherDescription(value);
                  }}
                  onChangeState={handleChangeState}
              />
          }

          {/* View Whatsapp Messages Model */}
          <ViewWhatsappMessagesModal
            isOpen = {showWhatsappMessagesModal}
            data = {sentWhatsappCancellationMessages}
            displayRecordCount={wpMessageDisplayRecordCount}
            pageSizeOptions={viewMessagePageSizeOptions}

            pages={wpMessagepages}
            
            toggleModal = {toggleShowWhatsappMessagesModal}
            
            pageSize = {wpMessagePageSize} // responsible for purple select the page size
            page={wpMessagecurrentPage}
            
            onViewMessagePageSizeOptionChange={(option) => {
                console.log(">>>>option on onViewMessagePageSizeOptionChange");
                
                setSelectedViewMessagePageSizeOption(option);
                setWpMessagePageSize(option?.value)
            }}
            selectedPageSizeOption={selectedViewMessagePageSizeOption}

            // BELOW IS DATA FOR FILTER
            oppTypeNameListWpModal={oppTypeNameListWpModal}
            onOppTypeChange={onOppTypeChange}
            selectedOppType={selectedOppTypeWpModal}

            toggleAllOppTitle={toggleAllOppTitle}
            onOppTitleChange={onOppTitleChange}
            oppTitleNameListWpModal={oppTitleNameListWpModal}
            selectedOppTitleWpModal={selectedOppTitleWpModal}

            // setFromDate = {setFromDate}
            handleFromDate={handleFromDate}
            // setToDate={setToDate}
            handleToDate={handleToDate}
            fromDate={fromDate}
            toDate={toDate}

            searchFilterWpSendCacellationMessages={searchFilterWpSendCacellationMessages}
            wpCancellationMessageIsLoading={wpCancellationMessageIsLoading}

            clearSearchFilterWpCancellationMessages={clearSearchFilterWpCancellationMessages}

            messageTypeOptions={messageTypeOptions}
            onMessageTypeChange={onMessageTypeChange}
            selectedMessageType={selectedMessageType}

            handleViewMessageOnFetchData={handleViewMessageOnFetchData}
          />

{
				showFilterModal &&
				(
					<ESPUmcLedFilterModel
						isOpen={showFilterModal}
						toggleModal={toggleFilterModal}
						toggleAllForFilter={toggleAllForFilter}
						toggleSelectionForFilter={toggleSelectionForFilter}
						serviceNameListForFilter={serviceNameListForFilter}

						// selectedServiceNameListForFilter={props.selectedServiceNameListForFilter}
						// fromDate={props.fromDate}
						// setfromDate={props.setfromDate}
						// toDate={props.toDate}
						// settoDate={props.settoDate}
						// requestedByOptions={props.requestedByOptions}
						// setSelectedRequestedByOption={props.setSelectedRequestedByOption}
						// selectedRequestedByOption={props.selectedRequestedByOption}
						// packageNameListForFilter={props.packageNameListForFilter}
						// oppTypeNameListforFilter={props.oppTypeNameListforFilter}
						// setSelectedPackageNameListForFilter={props.setSelectedPackageNameListForFilter}
						// selectedPackageNameListForFilter={props.selectedPackageNameListForFilter}
						// requestedaCallBackOptions={props.requestedaCallBackOptions}
						// setSelectedNeedToTalkToSPOption={props.setSelectedNeedToTalkToSPOption}
						// selectedNeedToTalkToSPOption={props.selectedNeedToTalkToSPOption}
						// toggleServiceStatus={props.toggleServiceStatus}
						// serviceStatusList={props.serviceStatusList}
						// callStatusOptionsForFilter={props.callStatusOptionsForFilter}
						// setselectedCallStatusOptionForFilter={props.setselectedCallStatusOptionForFilter}
						// selectedCallStatusOptionForFilter={props.selectedCallStatusOptionForFilter}
						// setSelectedRequestedaCallBackOption={props.setSelectedRequestedaCallBackOption}
						// selectedRequestedaCallBackOption={props.selectedRequestedaCallBackOption}

						onSearchClicked={handleSearchClick}
						onClearFilterSearch={handleClearFilterSearch}
						toggleAllForServiceStatusFilter={toggleAllForServiceStatusFilter}
						toggleSelectionForServiceStatusFilter={toggleSelectionForServiceStatusFilter}
						selectedServiceStatusListForFilter={selectedServiceStatusListForFilter}
						serviceStatusNameListForFilter={serviceStatusNameListForFilter}

						// //offline meet
						// offlinemeetoptionsForFilter={props.offlinemeetoptionsForFilter}
						// setselectedofflinemeetoptionsForFilter={props.setselectedofflinemeetoptionsForFilter}
						// selectedofflinemeetoptionsForFilter={props.selectedofflinemeetoptionsForFilter}



						// offlinemeetoptions={props.offlinemeetoptions}
						// selectedofflinemeetoptions={props.selectedofflinemeetoptions}
						// setselectedofflinemeetoptions={props.setselectedofflinemeetoptions}




						// //for admin
						// externalServicePartnerOptions={props.externalServicePartnerOptions}
						// selectedExternalServicePartner={props.selectedExternalServicePartner}
						// onExternalServicePartnerChange={props.onExternalServicePartnerChange}
						// ExternalServicePartnerOrganization={props.ExternalServicePartnerOrganization}
						// isForAdmin={props.isForAdmin}
					>
					</ESPUmcLedFilterModel>
				)
			}
                
    </div>
  )
}

export default ESPUmcInterface
